import React, { useEffect, useState, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./Read.css";
import $ from "jquery";
import "./material.css";
import "./material_btn.css";
import "./material_layout.css";
import "react-toggle/style.css";
import ReactDOM from "react-dom";
import Spinner from "../Spinner/Spinner";
import { post } from "../../app/shared/http";
import { GrFormClose } from "react-icons/gr";
import Dialog from "@material-ui/core/Dialog";
import { Modal, Button } from "react-bootstrap";
import shareLinkIcon from "./shareLinkIcon.png";
import { useMediaQuery } from "react-responsive";
import { AiOutlineUnderline } from "react-icons/ai";
import { makeStyles } from "@material-ui/core/styles";
import CopyToClipboard from "react-copy-to-clipboard";
import { handleException } from "../../app/util/util";
import { useSelector, useDispatch } from "react-redux";
import DialogTitle from "@material-ui/core/DialogTitle";
import loaderColors1 from "../Spinner/loaderColors1.gif";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import ReactPlayerLoader from "@brightcove/react-player-loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DialogContentText from "@material-ui/core/DialogContentText";
import QuickHighlightShowColorPalete from "./QuickHighlightShowColorPalete";
import PrimitivoHighlighter from "../MyTextHighlighter/highlighters/primitivo";
import {
  Typography,
  Popper,
  ClickAwayListener,
  Fade,
  Paper,
} from "@material-ui/core";
import {
  setReduxAnnotationVOList,
  setReduxAnnotationVO,
  setReduxBriefVO,
} from "../../app/redux/UserSlice";
console.log("added print in highlight ---><---");
let MARK = false,
  yValue,
  multiParaAnnotationStartParaStartOffset,
  multiParaHighlightIndexer = 0,
  highlightTagFirstPart,
  multiParaAnnotationID,
  highlightTagLastPart,
  multiParaAnnotationStartParaEndOffset,
  dppAnotationId,
  selectedNoteId;
let selectedHighlightColor,
  addingNote = false,
  bodyRect = "",
  selection = "",
  selectedContent = "",
  selectionHTML = "";
let insidePrincipalCase = false,
  pCaseWithHeadingCitation = false,
  pCaseWithHeadingOnly = false,
  annotationEndParaId = "",
  annotationStartParaId = "",
  notesList = [];
let updatingNote = false,
  addingLink = false,
  addingBrief = false,
  updatingLink = false,
  updatingBrief = false;
let highLightSpanId = 0,
  highLightSpanIdAcrossPara = [],
  selectedParaIds = [],
  paraLevelAnnotation = "",
  acrossParaLevelAnnotationFlag = false;
let paraIdDictonary = {},
  paraIDHTMLDictionary = {},
  paraOuterHTMLDictionary = {},
  wrapperDictionaryForSelecteedPara = {},
  innerWrapperDictionaryForSelecteedPara = {},
  listChildItems = {},
  newListItem = {};
let pageNumberElementDic = {},
  featureChildItems = {},
  listChildItemsFlag = false,
  selectedText = "",
  enclosingParaIdString = "",
  highlightStartOffset = 0;
let highlightEndOffset = "",
  annotationSectionId = "",
  annotationSectionTitle = "",
  highlightedTextWithoutHTML = "",
  idToBeReplaced = "",
  getFocusElement = "",
  globalChapterAnnotationList = "",
  globalChapterBriefList = "",
  highlightStartOffsetAtSectionLevel = "";
let linkStartOffset = "",
  linkEndOffset = "",
  highlightedTextWithoutHTMLAtSectionLevel = "",
  highlightEndOffsetAtSectionLevel = "",
  briefSpanId = 0,
  timeCount = "",
  selectedNoteIdlink = "";
let briefStartOffsetAtSectionLevel = "",
  briefEndOffsetAtSectionLevel = "",
  briefStartParaId = "",
  briefEndParaId = "",
  briefParaStartOffset = "",
  briefParaEndOffset = "",
  insideAddBriefFunction = 0,
  addBriefPopoverShown = false,
  globalChapterLinkList = "";
let labelColor = "",
  briefNote = "",
  selectionElement = "",
  colorCodeId = "",
  selectedNoteIdUpdate = "",
  selectedColor = "",
  noteIsEmpty = false,
  saveHighlightsRequestData = "",
  selectedNoteIdUpdate1 = "",
  briefedTextWithoutHTML = "",
  existingNoteValueBrief = "",
  copySelectedText = "",
  updateLinkFlag = false,
  existingLinkValue = "",
  existingLinkValueDes = "",
  sharewithStudFlag = false,
  updateLinkFlagStud = false;
let chapterAnnotations = [],
  valueCheck = "",
  valueCheck1 = "",
  annotationType = "annotation",
  isAnnotatable = "",
  outlineOnly = false;
const useStyles = makeStyles(() => ({ root: { width: 500 } }));
const Ebook = React.forwardRef((props, ref) => {
  let lastVisitedPage = null;
  let history = useHistory();
  let { hash } = useLocation();
  let saveActivityTimer = null;
  const classes = useStyles();
  const dispatch = useDispatch();
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const { userId, userRole, userRoleId } = props.userInfo;
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const localUserSettingsVO = JSON.parse(
    localStorage.getItem("userSettingsVO"),
  );
  const { chapterId, bookId, bookISBN, lastReadPageNum, chapterTitle } =
    props.bookInfo;
  const userSetScreenMode = localStorage.getItem("screenMode")
    ? localStorage.getItem("screenMode")
    : localUserSettingsVO && localUserSettingsVO.length > 0
      ? localUserSettingsVO[0].userScreenMode
      : null;
  const [videoId, setVideoId] = useState("");
  const [studLink, setStudlink] = useState("");
  const [profLink, setProflink] = useState("");
  const [placement, setPlacement] = useState();
  const [HTMLData, setHTMLData] = useState("");
  const [anchorEl, setAnchorEl] = useState("");
  const [loading, setLoading] = useState(false);
  const [noteValue, setNoteValue] = useState("");
  const [showLink, setShowLink] = useState(true);
  const [copiedText, setCopiedText] = useState("");
  const [colorCyan, setColorCyan] = useState(false);
  const [colorBlue, setColorBlue] = useState(false);
  const [colorPink, setColorPink] = useState(false);
  const [briefLabels, setBriefLabels] = useState([]);
  const [colorGreen, setColorGreen] = useState(false);
  const [linkDesStud, setLinkDesStud] = useState(true);
  const [colorYellow, setColorYellow] = useState(false);
  const [casePopOver, setCasePopOver] = useState(false);
  const [colorOrange, setColorOrange] = useState(false);
  const [colorPurple, setColorPurple] = useState(false);
  const [isBriefOpen, setIsBriefOpen] = useState(false);
  const [videoplatform, setVideoplatform] = useState("");
  const [studLinkFlag, setStudLinkFlag] = useState(false);
  const [anchorElUpdate, setAnchorElUpdate] = useState("");
  const [placementUpdate, setPlacementUpdate] = useState();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [colorSandrift, setColorSandrift] = useState(false);
  const [isNoteUpdated, setIsNoteUpdated] = useState(false);
  const [quickTipContent, setQuickTipContent] = useState("");
  const [noteValueUpdate, setNoteValueUpdate] = useState("");
  const [colorGainsboro, setColorGainsboro] = useState(false);
  const [colorLightNavy, setColorLightNavy] = useState(false);
  const [colorLightCoral, setColorLightCoral] = useState(false);
  const [currentBriefLabel, setCurrentBriefLabel] = useState("");
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [highlightQuickOn, setHighlightQuickOn] = useState(false);
  const [highlightChangeMsg, setHighlightChangeMsg] = useState("");
  const [casePopOverUpdate, setCasePopOverUpdate] = useState(false);
  const [colorCodeListEbook1, setColorCodeListEbook1] = useState([]);
  const [highlightQuickColor, setHighlightQuickColor] = useState("");
  const [notificationContent, setNotificationContent] = useState("");
  const [isReadQuickTipOpen, setIsReadQuickTipOpen] = useState(false);
  const [showNextChapterLink, setShowNextChapterLink] = useState(false);
  const [isPopoverOpenUpdate, setIsPopoverOpenUpdate] = useState(false);
  const [isReadPopupOverOpen, setIsReadPopupOverOpen] = useState(false);
  const [saveHighlightLoading, setSaveHighlightLoading] = useState(false);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1224px)" });
  const [isCopyOnlyPopoverOpen, setIsCopyOnlyPopoverOpen] = useState(false);
  const [isPopoverOpenProfessor, setIsPopoverOpenProfessor] = useState(false);
  const [highlightQuickUnderLine, setHighlightQuickUnderLine] = useState(false);
  const [isAnnotatable, setIsAnnotatable] = useState(
    props.bookVO.isAnnotatable,
  );
  const [windowSize, setWindowSize] = useState(
    window.innerWidth + window.innerHeight,
  );
  const [isPopoverOpenProfessorUpdate, setIsPopoverOpenProfessorUpdate] =
    useState(false);
  const [lastReadPgNum, setLastReadPgNum] = useState(
    localStorage.getItem("lastPageReadNum"),
  );
  const isPrevElementPrincipalCase = useRef({
    prevElementIsPrincpialCase: false,
    principalCaseId: "",
  });
  const {
    labelSettingsVOList,
    removedColorsVOList,
    userSettingVO,
    reduxAnnotationVOList,
    reduxAnnotationVO,
  } = useSelector((selectState) => selectState.userVO);
  const readBookFocus = useRef(null);

  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };
  const updateWindowSize = () => {
    setWindowSize(window.innerWidth + window.innerHeight);
  };
  const updateReduxAnnotation = (annotationVOList) => {
    dispatch(setReduxAnnotationVOList(annotationVOList));
  };
  const addBriefToRedux = (briefVO) => {
    dispatch(setReduxBriefVO(briefVO));
  };
  const addHighlightToRedux = (annotationVO) => {
    var existingAnnotationVOList = reduxAnnotationVOList;
    existingAnnotationVOList = Array.isArray(existingAnnotationVOList)
      ? existingAnnotationVOList
      : [existingAnnotationVOList];
    dispatch(setReduxAnnotationVO(annotationVO));
  };
  const handleScroll = () => {
    let myDiv = document.querySelector("#ereaderBookContentContainer");
    setShowNextChapterLink(
      myDiv.offsetHeight + myDiv.scrollTop >= myDiv.scrollHeight - 1000
        ? true
        : false,
    );
    let Txtpage = document.querySelectorAll(".cc-pagenum-begin");
    window.addEventListener("resize", updateWindowSize);
    if (Txtpage != "undefined" && Txtpage != null) {
      Array.from(Txtpage).forEach((e) => {
        if (checkVisible(e)) {
          document.getElementById("pageNumTxt").value = e.innerHTML
            .replace("p", "")
            .replace(".", "")
            .trim();
        }
        return false;
      });
    }
    if (saveActivityTimer) {
      clearTimeout(saveActivityTimer);
    }
    saveActivityTimer = setTimeout(
      function () {
        let Txtpage = document.querySelectorAll(".cc-pagenum-begin");
        if (Txtpage != "undefined" && Txtpage != null) {
          let pagNumb = document.getElementById("pageNumTxt").value;
          if (pagNumb && pagNumb !== lastVisitedPage) {
            lastVisitedPage = pagNumb;
            setLastReadPgNum(lastVisitedPage);
            localStorage.setItem("lastPageReadNum", lastVisitedPage);
            var newUrl = `/${localStorage.getItem("reactNodeName")}/read/users/${userId}/books/${bookISBN}/${chapterId}#page-${pagNumb}`;
            window.history.replaceState("", "", newUrl);
            let reqData = {
              userVO: {
                userId: userId,
                userRole: userRole,
                userRoleId: userRoleId,
                streamContentRequiredFlag: false,
                userActivityVO: {
                  lastReadSectionId: "",
                  lastReadBookId: bookId,
                  lastReadParagraphId: "",
                  lastViewedOutlineId: "",
                  lastReadPageNum: pagNumb,
                  lastReadSubSectionId: "",
                  pageNavigatingTo: "CASES",
                  pageNavigatingFrom: "CASES",
                  lastReadChapterId: chapterId,
                  lastActivityCode: "BOOKSHELF",
                },
                sessionVO: getSessionVO(),
              },
              bookVO: { bookId: bookId },
            };
            const requestOptions1 = {
              method: "POST",
              body: JSON.stringify(reqData),
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            };
            fetch(
              `${localStorage.getItem("ENV")}/activityTrackingService/updateBookReadingProgress`,
              requestOptions1,
            )
              .then((response) => response.json())
              .then((data) => {
                if (data.status === "false" && data.wkErrorCode) {
                  handleException(data);
                }
              })
              .catch((error) => {
                console.error(
                  "There has been a problem with your fetch operation:",
                  error,
                );
              });
          }
        }
      }.bind(this),
      1000,
    );
  };
  const expandEreader = () => {
    document
      .querySelector(".expandNoteBookLink")
      .setAttribute("aria-expanded", "false");
    $(".expandNoteBookLink").addClass("collapsed");
    $("#minimizeNoteBook").removeClass("show");
    document.querySelector(".minimizeNoteBookLink") !== null &&
      document
        .querySelector(".minimizeNoteBookLink")
        .setAttribute("aria-expanded", "false");
    let eSplitBar = document.querySelector(".e-split-bar");
    let minimizeNoteBookLinkHide = document.querySelector(
      ".expandNoteBookLink",
    );
    let minimizeNoteBookLinkShow = document.querySelector(
      ".minimizeNoteBookLink",
    );
    let ereaderBookIndexFooter = document.querySelector(
      "#ereaderBookIndexFooter",
    );
    let ereaderContentCenterSec = document.querySelector(
      ".ereaderContentCenterSec",
    );
    let quickHighlightContainer = document.querySelector(
      ".quickHighlightContainer",
    );
    let ereaderBookContentMainBlock = document.querySelector(
      "#ereaderBookContentMainBlock",
    );
    document.querySelectorAll("#percentage .e-pane")[0].style.flexBasis =
      "100%";
    eSplitBar.classList.remove("e-static-pane");
    ereaderBookIndexFooter.classList.add("col-xl-7");
    ereaderContentCenterSec.classList.add("mx-auto");
    quickHighlightContainer.classList.add("mx-auto");
    minimizeNoteBookLinkShow.style.visibility = "hidden";
    ereaderBookIndexFooter.classList.remove("col-xl-12");
    minimizeNoteBookLinkHide.style.visibility = "visible";
    ereaderBookContentMainBlock.classList.remove("col-xl-12");
    ereaderBookContentMainBlock.classList.add(
      "col-xl-8",
      "col-md-8",
      "mx-auto",
      "text-center",
      "no-padding",
    );
  };
  const minimizeEreader = (ebookSize, notebookSize) => {
    let eSplitBar = document.querySelector(".e-split-bar");
    let minimizeNoteBookLinkHide = document.querySelector(
      ".expandNoteBookLink",
    );
    let minimizeNoteBookLinkShow = document.querySelector(
      ".minimizeNoteBookLink",
    );
    let ereaderBookIndexFooter = document.querySelector(
      "#ereaderBookIndexFooter",
    );
    let ereaderContentCenterSec = document.querySelector(
      ".ereaderContentCenterSec",
    );
    let quickHighlightContainer = document.querySelector(
      ".quickHighlightContainer",
    );
    let ereaderBookContentMainBlock = document.querySelector(
      "#ereaderBookContentMainBlock",
    );
    document.querySelectorAll("#percentage .e-pane")[1].style.display = "block";
    document.querySelectorAll("#percentage .e-pane")[0].style.flexBasis =
      ebookSize + "%";
    document.querySelectorAll("#percentage .e-pane")[1].style.flexBasis =
      notebookSize + "%";
    eSplitBar.classList.add("e-static-pane");
    ereaderBookIndexFooter.classList.add("col-xl-12");
    ereaderContentCenterSec.classList.remove("mx-auto");
    ereaderBookIndexFooter.classList.remove("col-xl-7");
    quickHighlightContainer.classList.remove("mx-auto");
    minimizeNoteBookLinkHide.style.visibility = "hidden";
    minimizeNoteBookLinkShow.style.visibility = "visible";
    ereaderBookContentMainBlock.classList.add("col-xl-12");
    ereaderBookContentMainBlock.classList.remove(
      "col-xl-8",
      "mx-auto",
      "text-center",
      "no-padding",
    );
  };
  const goToNextChapter = () => {
    history.push(
      `/read/users/${userId}/books/${bookISBN}/${props.bookInfo.nextChapterId}`,
    );
    localStorage.setItem("nextChapterFocus", "true");
  };
  useEffect(() => {
    if (localStorage.getItem("nextChapterFocus") === "true") {
      readBookFocus.current.focus();
    }
  });
  const checkVisible = (elm) => {
    let rect = elm.getBoundingClientRect();
    let viewHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight,
    );
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  };
  const reloadPage = () => {
    const windScreenMode = localStorage.getItem("screenMode");
    const pageNxtValue = document.getElementById("pageNumTxt").value;
    const pageView = document.querySelectorAll("#percentage .e-pane");
    const lastScrolledPageNum = localStorage.getItem("lastPageReadNum");
    const section = document.getElementById(
      `page-${lastScrolledPageNum ? lastScrolledPageNum : pageNxtValue}`,
    );
    setTimeout(() => {
      if (
        isDesktopOrLaptop &&
        windScreenMode === "expand" &&
        pageView &&
        pageView[0]
      ) {
        pageView[0].style.flexBasis = "100%";
        pageView[1].style.flexBasis = "0%";
      }
      if (section && section.scrollIntoView) {
        section.scrollIntoView();
        window.scroll(0, 0);
      }
    }, 1000);
  };
  const navigateToPageFromToc = () => {
    let section = document.getElementById(
      `page-${hash ? hash.split("-")[1] : lastReadPageNum}`,
    );
    if (section) {
      section.scrollIntoView();
      window.scroll(0, 0);
    }
  };
  useEffect(() => {
    reloadPage();
  }, [windowSize]);
  useEffect(() => {
    var myDiv = document.querySelector("#ereaderBookContentContainer");
    if (HTMLData.length > 0 && myDiv.scrollHeight == myDiv.offsetHeight) {
      setShowNextChapterLink(true);
    }
    $(".fa-comment").click(function () {
      alert($(this).prev().text());
    });
    // 47038 - A11Y: eBook Reader TOC content is read out of order by assistive technologies
    document.querySelectorAll(".epubc-ui__toccontents").forEach((contentsDiv) => {
      // 47038 - A11Y: eBook Reader TOC content is read out of order by assistive technologies
      const parent = contentsDiv && contentsDiv.parentNode;
      if (parent && typeof parent.querySelector === "function") {
        const pageDiv = parent.querySelector(".epubc-ui__tocpage");
        if (pageDiv) {
          // 47038 - A11Y: eBook Reader TOC content is read out of order by assistive technologies
          parent.insertBefore(contentsDiv, pageDiv);
        }
      }
    });
  }, [HTMLData]);
  useEffect(() => {
    async function fetchEreaderHTML() {
      setLoading(true);
      let pageNumber;
      let isPageFound = false;
      if (props.bookVO) {
        if (document.getElementById("pageNumTxt")) {
          pageNumber = props.bookVoPage
            ? localStorage.getItem("lastPageReadNum")
            : props.bookVO.chapterStartPageNumber
              ? props.bookVO.chapterStartPageNumber
              : "";
        }
        if (document.getElementById(`page-${pageNumber}`) !== null) {
          var newUrl = `/${localStorage.getItem("reactNodeName")}/read/users/${userId}/books/${bookISBN}/${chapterId}#page-${pageNumber}`;
          window.history.replaceState("", "", newUrl);
        }
      }
      fetch(props.bookInfo.pageHtmlLocation)
        .then((response) => response.text())
        .then((data) => {
          if (data) {
            setHTMLData(
              data
                .split("<body>")[1]
                .replace(/<body>|<\/body>|<\/html>/g, "")
                .replace(/<([bh]r)\s*\/>/g, "<$1>")
                .replace(/<\s*([^\s>]+)([^>]*)\/\s*>/g, "<$1$2><\/$1>"),
            );
            if (isDesktopOrLaptop) {
              if (userSetScreenMode !== undefined) {
                if (userSetScreenMode === "expand") {
                  expandEreader();
                } else if (userSetScreenMode === "split") {
                  minimizeEreader();
                }
                let Txtpage = document.querySelectorAll(".cc-pagenum-begin");
                if (
                  Txtpage != "undefined" &&
                  Txtpage != null &&
                  Txtpage.length
                ) {
                  Array.from(Txtpage).forEach((e) => {
                    if (
                      e.innerHTML.replace("p", "").replace(".", "").trim() ==
                      pageNumber
                    ) {
                      isPageFound = true;
                      document.getElementById("pageNumTxt").value = pageNumber;
                    }
                    return false;
                  });
                  if (!isPageFound) {
                    document.getElementById("pageNumTxt").value =
                      Txtpage[0].innerHTML
                        .replace("p", "")
                        .replace(".", "")
                        .trim();
                  }
                }
                const visPageNum = document.getElementById(
                  `page-${pageNumber}`,
                );
                if (visPageNum !== null) {
                  visPageNum.scrollIntoView();
                }
                navigateToPageFromToc();
              }
            } else if (isTabletOrMobile) {
              reloadPage();
            }
            if (userSettingVO !== null && userSettingVO !== undefined) {
              const userSetPrefFontSize = userSettingVO[0].prefferedFontSize;
              const userSetPrefLineSpace =
                userSettingVO[0].prefferedLineSpacing;

              if (
                userSetPrefFontSize !== undefined &&
                userSetPrefFontSize !== null &&
                parseInt(userSetPrefFontSize) >= 12
              ) {
                let contentClass = "#ereaderBookContentContainer",
                  i,
                  j;
                i = userSetPrefFontSize;
                if (userSetPrefLineSpace === "12") j = "1.2";
                else if (userSetPrefLineSpace === "15") j = "1.8";
                else if (userSetPrefLineSpace === "20") j = "2.4";
                if (i === "12") {
                  $(contentClass)
                    .find(".cc-font-xxsmall p")
                    .css("font-size", "11px");
                  $(contentClass + " div:not([cc-font-xxsmall]) p").css({
                    "font-size": "12px",
                    "line-height": j,
                  });

                  $(contentClass)
                    .find(".cc-font-xsmall")
                    .css("font-size", "12px");
                  $(contentClass)
                    .find(".cc-font-xsmall p")
                    .css("font-size", "12px");
                  $(contentClass + " div:not([cc-font-xsmall]) p").css({
                    "font-size": "12px",
                    "line-height": j,
                  });

                  $(contentClass)
                    .find(".cc-font-small")
                    .css("font-size", "14px");
                  $(contentClass)
                    .find(".cc-font-small p")
                    .css("font-size", "14px");
                  $(contentClass + " div:not([cc-font-small]) p").css({
                    "font-size": "12px",
                    "line-height": j,
                  });

                  $(contentClass)
                    .find(".cc-font-medium")
                    .css({ "font-size": "14px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-medium h3 p")
                    .css({ "font-size": "14px", "line-height": j });
                  $(contentClass + " div:not([cc-font-medium]) p").css({
                    "font-size": "12px",
                    "line-height": j,
                  });

                  $(contentClass)
                    .find(".cc-font-large")
                    .css({ "font-size": "14px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-large p")
                    .css({ "font-size": "14px", "line-height": j });
                  $(contentClass + " div:not([cc-font-large]) p").css({
                    "font-size": "12px",
                    "line-height": j,
                  });

                  $(contentClass)
                    .find(".cc-font-xlarge")
                    .css({ "font-size": "16px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge h2 p")
                    .css({ "font-size": "16px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge h3 p")
                    .css({ "font-size": "16px", "line-height": j });
                  $(contentClass + " div:not([cc-font-xlarge]) p").css({
                    "font-size": "12px",
                    "line-height": j,
                  });

                  $(".ccapp-chunkHeader").css({
                    "font-size": "200%",
                    "line-height": "120%",
                  });
                  $(contentClass)
                    .find(".cc-chapter-title")
                    .css({ "font-size": "22px", "line-height": j });
                  $(contentClass)
                    .find(".cc-chapter-title h1 p")
                    .css({ "font-size": "22px", "line-height": j });
                  $(contentClass)
                    .find("#notes-container .notesText")
                    .css({ "font-size": "14px", "line-height": j });
                  $(contentClass)
                    .find("#notes-container .labelNoteWrapper")
                    .css({ "font-size": "14px", "line-height": j });
                } else if (i === "14") {
                  $(contentClass)
                    .find(".cc-font-small")
                    .css("font-size", "16px");
                  $(contentClass)
                    .find(".cc-font-xsmall")
                    .css("font-size", "14px");
                  $(contentClass)
                    .find(".cc-font-small p")
                    .css("font-size", "16px");
                  $(contentClass)
                    .find(".cc-font-xsmall p")
                    .css("font-size", "14px");
                  $(contentClass)
                    .find(".cc-font-xxsmall p")
                    .css("font-size", "12px");
                  $(".ccapp-chunkHeader").css({
                    "font-size": "200%",
                    "line-height": "120%",
                  });
                  $(contentClass)
                    .find(".cc-font-large")
                    .css({ "font-size": "16px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-medium")
                    .css({ "font-size": "16px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge")
                    .css({ "font-size": "18px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-large p")
                    .css({ "font-size": "16px", "line-height": j });
                  $(contentClass)
                    .find(".cc-chapter-title")
                    .css({ "font-size": "24px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-medium h3 p")
                    .css({ "font-size": "16px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge h2 p")
                    .css({ "font-size": "18px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge h3 p")
                    .css({ "font-size": "18px", "line-height": j });
                  $(contentClass)
                    .find(".cc-chapter-title h1 p")
                    .css({ "font-size": "24px", "line-height": j });
                  $(contentClass + " div:not([cc-font-small]) p").css({
                    "font-size": "14px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-large]) p").css({
                    "font-size": "14px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xsmall]) p").css({
                    "font-size": "14px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-medium]) p").css({
                    "font-size": "14px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xlarge]) p").css({
                    "font-size": "14px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xxsmall]) p").css({
                    "font-size": "14px",
                    "line-height": j,
                  });
                  $(contentClass)
                    .find("#notes-container .notesText")
                    .css({ "font-size": "16px", "line-height": j });
                  $(contentClass)
                    .find("#notes-container .labelNoteWrapper")
                    .css({ "font-size": "16px", "line-height": j });
                } else if (i === "16") {
                  $(contentClass)
                    .find(".cc-font-small")
                    .css("font-size", "18px");
                  $(contentClass)
                    .find(".cc-font-xsmall")
                    .css("font-size", "16px");
                  $(contentClass)
                    .find(".cc-font-small p")
                    .css("font-size", "18px");
                  $(contentClass)
                    .find(".cc-font-xsmall p")
                    .css("font-size", "16px");
                  $(contentClass)
                    .find(".cc-font-xxsmall p")
                    .css("font-size", "14px");
                  $(".ccapp-chunkHeader").css({
                    "font-size": "200%",
                    "line-height": "120%",
                  });
                  $(contentClass)
                    .find(".cc-font-large")
                    .css({ "font-size": "22px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-medium")
                    .css({ "font-size": "22px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge")
                    .css({ "font-size": "24px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-large p")
                    .css({ "font-size": "22px", "line-height": j });
                  $(contentClass)
                    .find(".cc-chapter-title")
                    .css({ "font-size": "30px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-medium h3 p")
                    .css({ "font-size": "22px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge h2 p")
                    .css({ "font-size": "24px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge h3 p")
                    .css({ "font-size": "24px", "line-height": j });
                  $(contentClass)
                    .find(".cc-chapter-title h1 p")
                    .css({ "font-size": "30px", "line-height": j });
                  $(contentClass + " div:not([cc-font-small]) p").css({
                    "font-size": "16px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-large]) p").css({
                    "font-size": "16px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xsmall]) p").css({
                    "font-size": "16px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-medium]) p").css({
                    "font-size": "16px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xlarge]) p").css({
                    "font-size": "16px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xxsmall]) p").css({
                    "font-size": "16px",
                    "line-height": j,
                  });
                  $(contentClass)
                    .find("#notes-container .notesText")
                    .css({ "font-size": "22px", "line-height": j });
                  $(contentClass)
                    .find("#notes-container .labelNoteWrapper")
                    .css({ "font-size": "22px", "line-height": j });
                } else if (i === "18") {
                  $(contentClass)
                    .find(".cc-font-small")
                    .css("font-size", "22px");
                  $(contentClass)
                    .find(".cc-font-xsmall")
                    .css("font-size", "18px");
                  $(contentClass)
                    .find(".cc-font-small p")
                    .css("font-size", "22px");
                  $(contentClass)
                    .find(".cc-font-xsmall p")
                    .css("font-size", "18px");
                  $(contentClass)
                    .find(".cc-font-xxsmall p")
                    .css("font-size", "16px");
                  $(".ccapp-chunkHeader").css({
                    "font-size": "200%",
                    "line-height": "120%",
                  });
                  $(contentClass)
                    .find(".cc-font-large")
                    .css({ "font-size": "24px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-medium")
                    .css({ "font-size": "24px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge")
                    .css({ "font-size": "30px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-large p")
                    .css({ "font-size": "24px", "line-height": j });
                  $(contentClass)
                    .find(".cc-chapter-title")
                    .css({ "font-size": "36px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-medium h3 p")
                    .css({ "font-size": "24px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge h2 p")
                    .css({ "font-size": "30px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge h3 p")
                    .css({ "font-size": "30px", "line-height": j });
                  $(contentClass)
                    .find(".cc-chapter-title h1 p")
                    .css({ "font-size": "36px", "line-height": j });
                  $(contentClass + " div:not([cc-font-small]) p").css({
                    "font-size": "18px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-large]) p").css({
                    "font-size": "18px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xsmall]) p").css({
                    "font-size": "18px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-medium]) p").css({
                    "font-size": "18px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xlarge]) p").css({
                    "font-size": "18px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xxsmall]) p").css({
                    "font-size": "18px",
                    "line-height": j,
                  });
                  $(contentClass)
                    .find("#notes-container .notesText")
                    .css({ "font-size": "24px", "line-height": j });
                  $(contentClass)
                    .find("#notes-container .labelNoteWrapper")
                    .css({ "font-size": "24px", "line-height": j });
                } else if (i === "20") {
                  $(contentClass)
                    .find(".cc-font-small")
                    .css("font-size", "24px");
                  $(contentClass)
                    .find(".cc-font-xsmall")
                    .css("font-size", "22px");
                  $(contentClass)
                    .find(".cc-font-small p")
                    .css("font-size", "24px");
                  $(contentClass)
                    .find(".cc-font-xsmall p")
                    .css("font-size", "22px");
                  $(contentClass)
                    .find(".cc-font-xxsmall p")
                    .css("font-size", "18px");
                  $(".ccapp-chunkHeader").css({
                    "font-size": "200%",
                    "line-height": "120%",
                  });
                  $(contentClass)
                    .find(".cc-font-large")
                    .css({ "font-size": "30px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-medium")
                    .css({ "font-size": "30px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge")
                    .css({ "font-size": "36px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-large p")
                    .css({ "font-size": "30px", "line-height": j });
                  $(contentClass)
                    .find(".cc-chapter-title")
                    .css({ "font-size": "42px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-medium h3 p")
                    .css({ "font-size": "30px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge h2 p")
                    .css({ "font-size": "36px", "line-height": j });
                  $(contentClass)
                    .find(".cc-font-xlarge h3 p")
                    .css({ "font-size": "36px", "line-height": j });
                  $(contentClass)
                    .find(".cc-chapter-title h1 p")
                    .css({ "font-size": "42px", "line-height": j });
                  $(contentClass + " div:not([cc-font-small]) p").css({
                    "font-size": "20px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-large]) p").css({
                    "font-size": "20px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xsmall]) p").css({
                    "font-size": "20px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-medium]) p").css({
                    "font-size": "20px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xlarge]) p").css({
                    "font-size": "20px",
                    "line-height": j,
                  });
                  $(contentClass + " div:not([cc-font-xxsmall]) p").css({
                    "font-size": "20px",
                    "line-height": j,
                  });
                  $(contentClass)
                    .find("#notes-container .notesText")
                    .css({ "font-size": "30px", "line-height": j });
                  $(contentClass)
                    .find("#notes-container .labelNoteWrapper")
                    .css({ "font-size": "30px", "line-height": j });
                }
              }
            }
            loadImagesFromCDN();
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
    fetchEreaderHTML();
  }, [props]);
  useEffect(() => {
    if (reduxAnnotationVO !== undefined && reduxAnnotationVO !== null) {
      if (
        reduxAnnotationVO.annotationStatus === "updated" ||
        reduxAnnotationVO.annotationStatus === "updatedLink"
      ) {
        const highlightElements = document.querySelectorAll(`.highlightedText`);
        highlightElements.forEach((highlightElement) => {
          if (
            highlightElement.id.includes(reduxAnnotationVO.annotationId) ||
            highlightElement.id.includes(reduxAnnotationVO.annotationId + "_")
          ) {
            if (
              reduxAnnotationVO.highlightColorCode === "underLine" ||
              reduxAnnotationVO.highlightColorCode === "underline"
            ) {
              highlightElement.style.textDecoration = "underline";
              highlightElement.style.backgroundColor = "white";
            } else {
              highlightElement.style.backgroundColor =
                reduxAnnotationVO.highlightColorCode;
              highlightElement.style.textDecoration = "none";
            }
          }
        });
        const briefElements = document.querySelectorAll(`.briefElementText`);
        briefElements.forEach((briefElement) => {
          if (briefElement.id.includes(reduxAnnotationVO.annotationId)) {
            if (
              reduxAnnotationVO.highlightColorCode === "underLine" ||
              reduxAnnotationVO.highlightColorCode === "underline"
            ) {
              briefElement.style.textDecoration = "underline";
              briefElement.style.backgroundColor = "white";
            } else {
              briefElement.style.backgroundColor =
                reduxAnnotationVO.highlightColorCode;
              briefElement.style.textDecoration = "none";
            }
          }
        });
        const anchorElements = document.querySelectorAll(
          `[aid="${reduxAnnotationVO.annotationId}"]`,
        );
        anchorElements.forEach((anchorElement) => {
          if (anchorElement.id.includes(reduxAnnotationVO.annotationId)) {
            if (
              reduxAnnotationVO.linkBackGroundColorCode === "underLine" ||
              reduxAnnotationVO.linkBackGroundColorCode === "underline"
            ) {
              anchorElement.style.textDecoration = "underline";
              anchorElement.style.backgroundColor = "white";
            } else {
              anchorElement.style.backgroundColor =
                reduxAnnotationVO.linkBackGroundColorCode;
              anchorElement.style.textDecoration = "none";
            }
          }
        });
      }
      localStorage.setItem("updatededAnotationFromOutlines", false);
    }
  }, [reduxAnnotationVO]);
  const handleAnchorTag = () => {
    document.querySelectorAll("a[href^='#']").forEach((node) => {
      node.addEventListener("click", (e) => {
        e.preventDefault();
        let section = document.getElementById(
          e.currentTarget.hash.replace("#", ""),
        );
        if (section) {
          section.scrollIntoView();
          window.history.replaceState(
            null,
            null,
            "/" +
              localStorage.getItem("reactNodeName") +
              history.location.pathname +
              "#" +
              e.currentTarget.hash.replace("#", ""),
          );
          window.scroll(0, 0);
        }
      });
    });
  };
  const loadImagesFromCDN = () => {
    handleAnchorTag();
    let relativeUrl = "",
      imgInChapter = [],
      i = 0,
      imgTags = "";
    imgInChapter = document.querySelectorAll("#ereader-container img");
    imgTags = imgInChapter;
    if (imgInChapter != undefined) {
      for (i = 0; i < imgInChapter.length; i++) {
        relativeUrl = `/casebook/${bookISBN}/ex-epub/OPS/images${imgInChapter[i].src.split("/images")[1]}`;
        relativeUrl = relativeUrl.split("?")[0];
        let reqData = {
          genericServiceRequestVO: { inputBaseUrl: relativeUrl },
        };
        post("/manageUrlService/getCDNUrl", reqData, "ENV")
          .then((response) => response.json())
          .then((data) => {
            if (data.status === "true") {
              for (i = 0; i < imgTags.length; i++) {
                if (
                  data.genericServiceResponseVO.cdnUrl.indexOf(
                    imgTags[i].src.split("/images")[1],
                  ) != -1
                ) {
                  imgTags[i].src = data.genericServiceResponseVO.cdnUrl;
                }
              }
            } else if (data.wkErrorCode) {
              handleException(data);
            }
          })
          .catch((error) => {
            console.error(
              "There has been a problem with your fetch operation:",
              error,
            );
          });
      }
      paintAnnotation();
      paintBriefs();
      paintLinks();
    }
  };
  const paintAnnotation = (valueCheck) => {
    if (typeof valueCheck == "undefined") {
      setLoading(true);
    }

    let reqData = {
      bookVO: { bookId: bookId },
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadPageNum: "",
          lastReadSectionId: "",
          lastReadBookId: bookId,
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      annotationVO: {
        pageNum: 0,
        bookId: bookId,
        chapterId: chapterId,
        ereaderNotesAndHighlightsPopoverFlowFlag: false,
      },
    };
    if (valueCheck != undefined && valueCheck != "") {
      reqData.annotationVO.pageNum = valueCheck;
    }
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/getChapterAnnotations`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          let annotationVOList = data.annotationVOList;
          if (annotationVOList) {
            annotationVOList = Array.isArray(annotationVOList)
              ? annotationVOList
              : [annotationVOList];
            updateReduxAnnotation(annotationVOList);
            if (annotationVOList.length > 0) {
              chapterAnnotations = annotationVOList;
            } else {
              chapterAnnotations.push(annotationVOList);
            }
            globalChapterAnnotationList = chapterAnnotations;
            for (let j = 0; j < annotationVOList.length; j++) {
              highlightParas(annotationVOList[j], "highlight");
            }
            notesList = annotationVOList;
            displayNotes(annotationVOList, "highlight");
            setTimeout(() => {
              if (data.totalPages != undefined && data.totalPages != "") {
                let checkingCount = 0;
                let totalPages = data.totalPages;
                checkingCount =
                  valueCheck == undefined || valueCheck == null
                    ? 0
                    : valueCheck;
                if (checkingCount < totalPages - 1) {
                  paintAnnotation(checkingCount + 1);
                }
              }
              document.querySelectorAll(".highlightedText");
              document.querySelectorAll(".briefElementText");
            }, 1000);
          }
          // setLoading(false);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        // setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const paintBriefs = (valueCheck1) => {
    if (typeof valueCheck1 == "undefined") {
      setLoading(true);
    }

    let briefReqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadPageNum: "",
          lastReadSectionId: "",
          lastReadBookId: bookId,
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      briefVO: {
        pageNum: 0,
        bookId: bookId,
        chapterId: chapterId,
        ereaderNotesAndHighlightsPopoverFlowFlag: false,
      },
    };
    if (valueCheck1 != undefined && valueCheck1 != "") {
      briefReqData.briefVO.pageNum = valueCheck1;
    }
    const briefRequestOptions1 = {
      method: "POST",
      body: JSON.stringify(briefReqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageCases/getChapterBrief`,
      briefRequestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          let annotationVOList = data.briefVOList;
          if (annotationVOList) {
            annotationVOList = Array.isArray(annotationVOList)
              ? annotationVOList
              : [annotationVOList];
            let chapterBriefs = [];
            if (annotationVOList.length > 0) {
              chapterBriefs = annotationVOList;
            } else {
              chapterBriefs.push(annotationVOList);
            }
            globalChapterBriefList = chapterBriefs;
            for (let j = 0; j < annotationVOList.length; j++) {
              highlightParas(annotationVOList[j], "briefstag");
            }
            displayBriefNotes(annotationVOList);
            setTimeout(() => {
              if (data.totalPages != undefined && data.totalPages != "") {
                let checkingCount = 0;
                let totalPages = data.totalPages;
                checkingCount =
                  valueCheck1 == undefined || valueCheck1 == null
                    ? 0
                    : valueCheck1;
                if (checkingCount < totalPages - 1) {
                  paintBriefs(checkingCount + 1);
                }
              }
            }, 2000);
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        // setLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const paintLinks = () => {
    setLoading(true);
    let linkReqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadPageNum: "",
          lastReadSectionId: "",
          lastReadBookId: bookId,
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
        },
        sessionVO: getSessionVO(),
      },
      annotationVO: {
        bookId: bookId,
        chapterTitle: "",
        chapterId: chapterId,
      },
    };
    let linkFetchURLUser, linkFetchinguser;
    if (userVO.userRole === "Professor") {
      linkFetchinguser = "Professor";
      linkFetchURLUser = "/manageAnnotationService/getChapterLinkProfessor";
    } else if (userVO.userRole === "Student") {
      linkFetchinguser = "Student";
      linkFetchURLUser = "/manageAnnotationService/getChapterLinkStudent";
    }
    const linkRequestOptions1 = {
      method: "POST",
      body: JSON.stringify(linkReqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(localStorage.getItem("ENV") + linkFetchURLUser, linkRequestOptions1)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          let annotationVOList = data.annotationVOList;
          if (annotationVOList) {
            annotationVOList = Array.isArray(annotationVOList)
              ? annotationVOList
              : [annotationVOList];
            let chapterLinks = [];
            if (annotationVOList.length > 0) {
              chapterLinks = annotationVOList;
            } else {
              chapterLinks.push(annotationVOList);
            }
            globalChapterLinkList = chapterLinks;
            for (let j = 0; j < annotationVOList.length; j++) {
              highlightParas(annotationVOList[j], "anchortag");
            }
            notesList = annotationVOList;
            displayNotes(annotationVOList, "anchortag");
            removeHighlightFromPageNumbers();
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        setLoading(false);
        localStorage.setItem("ChapterContentFocus", "false");
      })
      .catch((error) => {
        setLoading(false);
        localStorage.setItem("ChapterContentFocus", "false");
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const highlightParas = (annotationVO, type) => {
    if (annotationVO.highlightStartParaId === annotationVO.highlightEndParaId) {
      highlightElement(
        annotationVO,
        annotationVO.highlightStartParaId,
        annotationVO.highlightParaStartOffset,
        annotationVO.highlightParaEndOffset,
        "single",
        type,
      );
    } else {
      let paraList = annotationVO.enclosingParaList;
      for (let r = 0; r < paraList.length; r++) {
        let paraId = typeof paraList === "string" ? paraList : paraList[r];
        if (r === 0)
          highlightElement(
            annotationVO,
            paraId,
            annotationVO.highlightParaStartOffset,
            annotationVO.highlightParaEndOffset,
            "startPara",
            type,
            r,
          );
        else if (r === paraList.length - 1)
          highlightElement(
            annotationVO,
            paraId,
            annotationVO.highlightParaStartOffset,
            annotationVO.highlightParaEndOffset,
            "endPara",
            type,
            r,
          );
        else
          highlightElement(
            annotationVO,
            paraId,
            annotationVO.highlightParaStartOffset,
            annotationVO.highlightParaEndOffset,
            "fullPara",
            type,
            r,
          );
      }
    }
  };
  const displayNotes = (annotationVOList, tagvalue) => {
    let chapterAnnotations = annotationVOList;
    for (let i in chapterAnnotations) {
      dppAnotationId = chapterAnnotations[i].annotationId;
      if (document.getElementById(dppAnotationId)) {
        let isLinkValue = tagvalue === "anchortag" ? true : false;
        if (isLinkValue === false) {
          if (chapterAnnotations[i].noteText) {
            selectedNoteId = dppAnotationId;
            bodyRect = document.body.getBoundingClientRect();
            selectedHighlightColor = chapterAnnotations[i].highlightColorCode;
            let element = document.getElementById(selectedNoteId);
            let rect = element.getBoundingClientRect();
            yValue = rect.top;
            displayNotesOnRight(
              chapterAnnotations[i].noteText
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;"),
              selectedNoteId,
              yValue,
              selectedHighlightColor,
              isLinkValue,
            );
          }
        } else if (isLinkValue === true) {
          if (chapterAnnotations[i].linkUrl) {
            selectedNoteId = dppAnotationId;
            bodyRect = document.body.getBoundingClientRect();
            selectedHighlightColor =
              chapterAnnotations[i].linkBackGroundColorCode;
            let element = document.getElementById(selectedNoteId);
            let rect = element.getBoundingClientRect();
            yValue = rect.top;
            if (userVO.userRole === "Student") {
              displayLinksOnLeft(
                selectedNoteId,
                yValue,
                chapterAnnotations[i].linkUrl,
                chapterAnnotations[i].linkDescription,
                chapterAnnotations[i].linkShareFlag,
                chapterAnnotations[i].linkEditFlag,
              );
            } else if (userVO.userRole === "Professor") {
              if (chapterAnnotations[i].linkShareFlag === "true") {
                displayLinksOnLeft(
                  selectedNoteId,
                  yValue,
                  chapterAnnotations[i].linkUrl,
                  chapterAnnotations[i].linkDescription,
                  chapterAnnotations[i].linkShareFlag,
                  chapterAnnotations[i].linkEditFlag,
                );
              } else if (chapterAnnotations[i].linkShareFlag === "false") {
                displayNotesOnRight(
                  chapterAnnotations[i].linkDescription,
                  selectedNoteId,
                  yValue,
                  selectedHighlightColor,
                  isLinkValue,
                );
              }
            }
          }
        }
      }
    }
  };
  const displayBriefNotes = (chapterBriefs) => {
    let chapterAnnotations = chapterBriefs;
    for (let i in chapterAnnotations) {
      dppAnotationId = chapterAnnotations[i].annotationId;
      if (document.getElementById(dppAnotationId)) {
        if (chapterAnnotations[i].noteText) {
          selectedNoteId = dppAnotationId;
          bodyRect = document.body.getBoundingClientRect();
          selectedHighlightColor = chapterAnnotations[i].highlightColorCode;
          let labelName = chapterAnnotations[i].labelName;
          let element = document.getElementById(selectedNoteId);
          let rect = element.getBoundingClientRect();
          yValue = rect.top;
          displayBriefOnRight(
            selectedNoteId,
            selectedHighlightColor,
            yValue,
            labelName,
            chapterAnnotations[i].noteText
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;"),
          );
        }
      }
    }
  };
  const removeHighlightFromPageNumbers = () => {
    let highlightTags = document.getElementsByTagName("highlight");
    let linkTags = document.getElementsByTagName("anchortag");
    let briefTags = document.getElementsByTagName("briefstag");
    if (highlightTags) {
      for (let i = 0; i < highlightTags.length; i++) {
        if (highlightTags[i].parentNode.tagName.toLowerCase() === "span") {
          if ($(highlightTags[i].parentNode).hasClass("cc-pagenum-begin")) {
            highlightTags[i].parentNode.innerHTML =
              highlightTags[i].textContent;
          }
        }
      }
    }
    if (linkTags) {
      for (let i = 0; i < linkTags.length; i++) {
        if (linkTags[i].parentNode.tagName.toLowerCase() === "span") {
          if ($(linkTags[i].parentNode).hasClass("cc-pagenum-begin")) {
            linkTags[i].parentNode.innerHTML = linkTags[i].textContent;
          }
        }
      }
    }
    if (briefTags) {
      for (let i = 0; i < briefTags.length; i++) {
        if (briefTags[i].parentNode.tagName.toLowerCase() === "span") {
          if ($(briefTags[i].parentNode).hasClass("cc-pagenum-begin")) {
            briefTags[i].parentNode.innerHTML = briefTags[i].textContent;
          }
        }
      }
    }
  };
  const highlightElement = (
    annotationVO,
    paraId,
    startOffset,
    endOffset,
    paraType,
    type,
    r,
  ) => {
    setCasePopOverUpdate(false);
    const element = document.getElementById(paraId);
    if (!element) {
      return;
    }
    let textNodeList = textNodesUnder(element);
    let charCount = 0;
    let takeHighlight = true;
    let firstSubHighlight = true;
    let highlightIconFlag = true;
    let ccHighLightStartOffset = 0;
    let ccHighLightEndOffset = 0,
      currHighlightedCount = 0;
    for (let i = 0; i < textNodeList.length; i++) {
      if (takeHighlight) {
        let textNodeEndOffset = textNodeList[i].textContent
          .replace(/(\r\n|\n|\r)/gm, "")
          .replace(/amp;/g, "")
          .replace(/&nbsp;/g, " ").length;
        if (paraType === "endPara" || paraType === "fullPara")
          ccHighLightStartOffset = 0;
        else {
          if (charCount + textNodeEndOffset < startOffset) {
            charCount = charCount + textNodeEndOffset;
            continue;
          }
        }
        if (paraType === "endPara" || paraType === "fullPara") {
          ccHighLightStartOffset = 0;
        } else {
          if (firstSubHighlight) {
            startOffset = parseFloat(startOffset);
            if (startOffset < 0) ccHighLightStartOffset = charCount;
            else if (parseFloat(startOffset) === 0 && charCount === 0)
              ccHighLightStartOffset = 0;
            else ccHighLightStartOffset = startOffset - charCount;
            firstSubHighlight = false;
          } else {
            ccHighLightStartOffset = 0;
          }
        }
        if (paraType === "startPara" || paraType === "fullPara") {
          ccHighLightEndOffset = textNodeEndOffset;
        } else {
          if (charCount + textNodeEndOffset < endOffset) {
            ccHighLightEndOffset = textNodeEndOffset;
          } else {
            ccHighLightEndOffset = endOffset - charCount;
            takeHighlight = false;
          }
        }
        if (ccHighLightEndOffset > textNodeEndOffset)
          ccHighLightEndOffset = textNodeEndOffset;
        try {
          let range = document.createRange();
          range.setStart(textNodeList[i], ccHighLightStartOffset);
          range.setEnd(textNodeList[i], ccHighLightEndOffset);
          let myHighlightWrapper = "";
          if (type === "highlight") {
            myHighlightWrapper = document.createElement("highlight");
            myHighlightWrapper.setAttribute("class", "highlightedText");
            myHighlightWrapper.setAttribute(
              "highlightParaStartOffset",
              annotationVO.highlightParaStartOffset,
            );
            myHighlightWrapper.setAttribute(
              "highlightParaEndOffset",
              annotationVO.highlightParaEndOffset,
            );
            myHighlightWrapper.setAttribute(
              "startOffset",
              annotationVO.highlightStartOffset,
            );
            myHighlightWrapper.setAttribute(
              "endOffset",
              annotationVO.highlightEndOffset,
            );
            myHighlightWrapper.setAttribute(
              "highlightStartParaId",
              annotationVO.highlightStartParaId,
            );
            myHighlightWrapper.setAttribute(
              "highlightEndParaId",
              annotationVO.highlightEndParaId,
            );
            myHighlightWrapper.setAttribute("role", "mark");
            if (
              annotationVO.noteText !== undefined &&
              annotationVO.noteText !== null
            ) {
              myHighlightWrapper.setAttribute(
                "noteText",
                annotationVO.noteText,
              );
            } else {
              myHighlightWrapper.setAttribute("noteText", " ");
            }
            if (
              annotationVO.sectionId !== undefined &&
              annotationVO.sectionId !== null
            ) {
              myHighlightWrapper.setAttribute(
                "sectionId",
                annotationVO.sectionId,
              );
            } else {
              myHighlightWrapper.setAttribute("sectionId", " ");
            }
            myHighlightWrapper.setAttribute("hid", annotationVO.annotationId);
          } else if (type === "briefstag") {
            myHighlightWrapper = document.createElement("briefstag");
            myHighlightWrapper.setAttribute("class", "briefElementText");
            myHighlightWrapper.setAttribute(
              "briefParastartOffset",
              annotationVO.highlightParaStartOffset,
            );
            myHighlightWrapper.setAttribute(
              "briefParaEndOffset",
              annotationVO.highlightParaEndOffset,
            );
            myHighlightWrapper.setAttribute(
              "briefStartOffset",
              annotationVO.highlightStartOffset,
            );
            myHighlightWrapper.setAttribute(
              "briefEndOffset",
              annotationVO.highlightEndOffset,
            );
            myHighlightWrapper.setAttribute(
              "briefStartParaId",
              annotationVO.highlightStartParaId,
            );
            myHighlightWrapper.setAttribute(
              "briefEndParaId",
              annotationVO.highlightEndParaId,
            );
            myHighlightWrapper.setAttribute("role", "mark");
            if (
              annotationVO.noteText !== undefined &&
              annotationVO.noteText !== null
            ) {
              myHighlightWrapper.setAttribute(
                "briefnote",
                annotationVO.noteText,
              );
            } else {
              myHighlightWrapper.setAttribute("briefnote", " ");
            }
            if (
              annotationVO.sectionId !== undefined &&
              annotationVO.sectionId !== null
            ) {
              myHighlightWrapper.setAttribute(
                "sectionId",
                annotationVO.sectionId,
              );
            } else {
              myHighlightWrapper.setAttribute("sectionId", " ");
            }
            myHighlightWrapper.setAttribute("bid", annotationVO.annotationId);
          } else if (type === "anchortag") {
            myHighlightWrapper = document.createElement("anchortag");
            myHighlightWrapper.setAttribute("class", "anchorElementText");
            myHighlightWrapper.setAttribute(
              "createdlinkurl",
              annotationVO.linkUrl,
            );
            myHighlightWrapper.setAttribute(
              "createdlinkcomments",
              annotationVO.linkDescription,
            );
            myHighlightWrapper.setAttribute(
              "linkeditingforproffessor",
              annotationVO.linkEditFlag,
            );
            myHighlightWrapper.setAttribute(
              "createdlinksharestatus",
              annotationVO.linkShareFlag,
            );
            myHighlightWrapper.setAttribute(
              "linkparastartoffset",
              annotationVO.highlightParaStartOffset,
            );
            myHighlightWrapper.setAttribute(
              "linkparaendoffset",
              annotationVO.highlightParaEndOffset,
            );
            myHighlightWrapper.setAttribute(
              "linkstartoffset",
              annotationVO.linkStartOffset,
            );
            myHighlightWrapper.setAttribute(
              "linkendoffset",
              annotationVO.linkEndOffset,
            );
            myHighlightWrapper.setAttribute(
              "linkstartparaid",
              annotationVO.highlightStartParaId,
            );
            myHighlightWrapper.setAttribute(
              "linkendparaid",
              annotationVO.highlightEndParaId,
            );
            myHighlightWrapper.setAttribute(
              "linkBackGroundColorCode",
              annotationVO.linkBackGroundColorCode,
            );
            myHighlightWrapper.setAttribute("role", "mark");
            if (
              annotationVO.sectionId !== undefined &&
              annotationVO.sectionId !== null
            ) {
              myHighlightWrapper.setAttribute(
                "sectionId",
                annotationVO.sectionId,
              );
            } else {
              myHighlightWrapper.setAttribute("sectionId", " ");
            }
            myHighlightWrapper.setAttribute("aid", annotationVO.annotationId);
          }
          let myHighlightWrapperId = "";
          if (paraType === "single") {
            myHighlightWrapper.id = annotationVO.annotationId;
            myHighlightWrapperId = annotationVO.annotationId;
          } else if (paraType === "startPara") {
            myHighlightWrapper.id = annotationVO.annotationId;
            myHighlightWrapperId = annotationVO.annotationId;
          } else if (paraType === "endPara" || paraType === "fullPara") {
            myHighlightWrapper.id = annotationVO.annotationId + "_" + r;
            myHighlightWrapperId = annotationVO.annotationId + "_" + r;
          }
          enclosingParaIdString = "";
          if (
            annotationVO.enclosingParaList !== null &&
            annotationVO.enclosingParaList !== undefined
          ) {
            let enclosingArray = [];
            if (typeof annotationVO.enclosingParaList == "string")
              enclosingParaIdString = annotationVO.highlightStartParaId;
            else {
              for (
                let paraIdIndex = 0;
                paraIdIndex < annotationVO.enclosingParaList.length;
                paraIdIndex++
              ) {
                let deEliminator =
                  paraIdIndex === annotationVO.enclosingParaList.length - 1
                    ? ""
                    : "|";
                enclosingParaIdString +=
                  annotationVO.enclosingParaList[paraIdIndex] + deEliminator;
              }
            }
          }
          myHighlightWrapper.setAttribute(
            "enclosingParaIdString",
            enclosingParaIdString,
          );
          if (type === "anchortag") {
            if (userVO.userRole === "Professor") {
              if (annotationVO.linkBackGroundColorCode !== undefined) {
                annotationVO.linkBackGroundColorCode.toLowerCase() ===
                "underline"
                  ? (myHighlightWrapper.style.cssText =
                      "text-decoration: underline;")
                  : (myHighlightWrapper.style.cssText =
                      "background-color: " +
                      annotationVO.linkBackGroundColorCode +
                      ";");
              }
            } else {
              myHighlightWrapper.style.cssText =
                "border-bottom:3px dashed #757575";
            }
          } else {
            if (annotationVO.highlightColorCode !== undefined) {
              if (
                annotationVO.highlightColorCode.toLowerCase() === "underline"
              ) {
                myHighlightWrapper.style.cssText =
                  "text-decoration: underline;";
                myHighlightWrapper.setAttribute("colorCodeId", "underLine");
              } else {
                myHighlightWrapper.style.cssText =
                  "background-color: " + annotationVO.highlightColorCode + ";";
                myHighlightWrapper.setAttribute(
                  "colorCodeId",
                  annotationVO.highlightColorCode,
                );
              }
            }
            let highlightIcon = document.createElement("span");
            highlightIcon.style.cssText =
              "height:15px; border:1px solid #CCCCCC; width:15px; position:absolute; right:0px;  background-color: " +
              annotationVO.highlightColorCode +
              ";";
          }

          let pem = new PrimitivoHighlighter(document.getElementById(paraId));
          let arr = pem.highlightRange(range, myHighlightWrapper);
          currHighlightedCount =
            currHighlightedCount +
            (ccHighLightEndOffset - ccHighLightStartOffset);

          removeHighlightFromPageNumbers();
          if (highlightIconFlag && arr.length > 0) highlightIconFlag = false;
          charCount = charCount + textNodeEndOffset;
        } catch (e) {
          console.error("There has been a problem", e);
        }
      }
    }
    if (type === "highlight") {
      const highlightElements = document.querySelectorAll(
        `[hid="${annotationVO.annotationId}"]`,
      );
      highlightElements.forEach((highlightElement) => {
        highlightElement.addEventListener("click", (e) => {
          highLightedTextClick(e);
        });
      });
    } else if (type === "briefstag") {
      const briefElements = document.querySelectorAll(
        `[bid="${annotationVO.annotationId}"]`,
      );
      briefElements.forEach((briefElement) => {
        briefElement.addEventListener("click", (e) => {
          briefTextClicked(e);
        });
      });
    } else if (type === "anchortag") {
      const anchorElementTextelements = document.querySelectorAll(
        `[aid="${annotationVO.annotationId}"]`,
      );
      anchorElementTextelements.forEach((anchorElementTextelement) => {
        anchorElementTextelement.addEventListener("click", (e) => {
          linkTextClick(e);
        });
      });
    }
  };
  const displayNotesOnRight = (
    noteText,
    noteId,
    topValue,
    boxColor,
    isLink,
  ) => {
    let allNotes = "";
    if (document.querySelector("#anchorElement" + noteId))
      document.querySelector("#anchorElement" + noteId).remove();
    let containerTop = document
      .getElementById("notes-container")
      .getBoundingClientRect().top;
    let clickableAnchorElement = document.createElement("A");
    clickableAnchorElement.id = "anchorElement" + noteId;
    clickableAnchorElement.setAttribute("noteText", noteText);
    if (boxColor !== undefined)
      clickableAnchorElement.setAttribute("colorcodeid", boxColor);
    clickableAnchorElement.setAttribute("aria-label", noteText);
    clickableAnchorElement.style.color = "#333333";
    let notesText = document.createElement("div");
    notesText.id = "notesDiv" + noteId;
    let timeCount = 1;
    let countOfAnnotationsInChapter = 300;
    countOfAnnotationsInChapter =
      localStorage.getItem("annotationListForChapter") !== null
        ? localStorage.getItem("annotationListForChapter").split(",").length
        : 1000;
    timeCount =
      countOfAnnotationsInChapter < 50
        ? 1
        : countOfAnnotationsInChapter > 50 && countOfAnnotationsInChapter < 150
          ? 800
          : 1000;
    if (noteText !== "" && noteText !== null && noteText !== undefined) {
      if (
        (noteText.length > 40 && noteText.split(" ").length < 5) ||
        (noteText.length > 40 && noteText.split(" ")[0].length > 20) ||
        (noteText.length > 25 && noteText.split(" ")[0].length > 20)
      ) {
        notesText.className = "notesText overlapCheckClass  ellipsis";
        notesText.style.width = "150px";
      } else {
        notesText.className = "notesText overlapCheckClass";
      }
    } else {
      notesText.className = "notesText";
    }
    notesText.style.top = topValue - containerTop - 2 + "px";
    if (noteText !== undefined) {
      notesText.title = noteText;
      notesText.innerHTML = noteText;
    }
    let iconOverValue = 15;
    let minimizeNoteBookLinkFlag1 = document
      .querySelector(".expandNoteBookLink")
      .getAttribute("aria-expanded");
    if (minimizeNoteBookLinkFlag1 === "true") {
      notesText.style.display = "none";
    } else if (minimizeNoteBookLinkFlag1 === "false") {
      notesText.style.display = "block";
    }
    let screenMode1 = localStorage.getItem("screenMode");
    if (screenMode1 === "split") {
      iconOverValue = 20;
    } else if (screenMode1 === "expand") {
      iconOverValue = 5;
    }
    let notesColor = document.createElement("span");
    notesColor.id = noteId;
    notesColor.className = "notesSpanBlock";
    notesColor.setAttribute(
      "style",
      "background-color:" +
        boxColor +
        " !important;" +
        " top:" +
        (topValue - containerTop) +
        "px" +
        ";",
    );
    setTimeout(() => {
      allNotes = document.querySelectorAll(".notesText");
      let i;
      let lastNoteHeight = 0;
      let lastNoteTopValue = 0;
      let IconTopValue = topValue - containerTop + "px";
      setTimeout(() => {
        if (
          allNotes !== null &&
          allNotes.length !== 0 &&
          allNotes.length !== undefined
        ) {
          for (i = 0; i < allNotes.length; i++) {
            lastNoteHeight = allNotes[i].offsetHeight + iconOverValue;
            if (
              parseInt(allNotes[i].style.top) == parseInt(notesText.style.top)
            ) {
              lastNoteTopValue = parseInt(allNotes[i].style.top);
              notesText.style.top =
                parseInt(allNotes[i].style.top) - 2 + lastNoteHeight + "px";
              notesColor.style.top =
                parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
              IconTopValue =
                parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
              if (
                document.querySelector(
                  "#" + clickableAnchorElement.id + (isLink === true)
                    ? " .linkIcon"
                    : " .notesIcon",
                )
              )
                document.querySelector(
                  "#" + clickableAnchorElement.id + (isLink === true)
                    ? " .linkIcon"
                    : " .notesIcon",
                ).style.top = IconTopValue;
              clickableAnchorElement.top =
                parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
            } else if (
              parseInt(allNotes[i].style.top) <
                parseInt(notesText.style.top) + lastNoteHeight &&
              parseInt(allNotes[i].style.top) >
                parseInt(notesText.style.top) - lastNoteHeight
            ) {
              if (parseInt(allNotes[i].style.top) > lastNoteTopValue) {
                lastNoteTopValue = parseInt(allNotes[i].style.top);
                notesText.style.top =
                  parseInt(allNotes[i].style.top) - 2 + lastNoteHeight + "px";
                notesColor.style.top =
                  parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                IconTopValue =
                  parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                if (
                  document.querySelector(
                    "#" + clickableAnchorElement.id + (isLink === true)
                      ? " .linkIcon"
                      : " .notesIcon",
                  )
                )
                  document.querySelector(
                    "#" + clickableAnchorElement.id + (isLink === true)
                      ? " .linkIcon"
                      : " .notesIcon",
                  ).style.top = IconTopValue;
                clickableAnchorElement.top =
                  parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
              }
            }
          }
        }
      }, 1000);
      document
        .getElementById("notes-container")
        .appendChild(clickableAnchorElement);
      ReactDOM.render(
        <i
          className={
            isLink === true
              ? "fas fa-link linkIcon"
              : "far fa-file-alt notesIcon"
          }
          style={{ top: IconTopValue }}
        />,
        document.getElementById(clickableAnchorElement.id),
      );
      clickableAnchorElement.appendChild(notesText);
      if (isLink === true) {
        clickableAnchorElement.setAttribute("linkcomments", boxColor);
        document
          .getElementById(clickableAnchorElement.id)
          .addEventListener("click", function (e) {
            linkNoteTextClicked(e);
          });
      } else {
        document
          .getElementById(clickableAnchorElement.id)
          .addEventListener("click", function (e) {
            noteTextClicked(e);
          });
      }
      if (document.getElementById("notesDiv" + noteId) !== null) {
        let fetchedAnnotationRect = null;
        lastNoteHeight = 0;
        let currentAnnotationRect = document
          .getElementById("notesDiv" + noteId)
          .getBoundingClientRect();
        if (allNotes !== null && allNotes.length !== 0) {
          for (i = 0; i < allNotes.length; i++) {
            lastNoteHeight = allNotes[i].offsetHeight + 5;
            fetchedAnnotationRect = document
              .getElementById(allNotes[i].id)
              .getBoundingClientRect();
            if (
              !(
                currentAnnotationRect.right < fetchedAnnotationRect.left ||
                currentAnnotationRect.left > fetchedAnnotationRect.right ||
                currentAnnotationRect.bottom < fetchedAnnotationRect.top ||
                currentAnnotationRect.top > fetchedAnnotationRect.bottom
              )
            ) {
              if (fetchedAnnotationRect.top < currentAnnotationRect.top) {
                if (
                  currentAnnotationRect.top - fetchedAnnotationRect.top - 10 <
                  parseInt($("#" + allNotes[i].id).css("line-height"))
                ) {
                  if (
                    document.getElementById(allNotes[i].id).innerHTML.length > 1
                  ) {
                    $(document.getElementById(allNotes[i].id), { clamp: 1 });
                  }
                } else if (
                  document.getElementById(allNotes[i].id).innerHTML.length > 1
                ) {
                  $(document.getElementById(allNotes[i].id), { clamp: 2 });
                }
              }
            }
          }
        }
        if (
          typeof localStorage.getItem("addNoteStartParaId") !== "undefined" &&
          localStorage.getItem("addNoteStartParaId") !== "" &&
          localStorage.getItem("addNoteStartParaId") !== null
        ) {
          let currentAnnotStartPara =
            localStorage.getItem("addNoteStartParaId");
          localStorage.setItem("addNoteStartParaId", "");
          if (currentAnnotStartPara !== "") {
            let currentAnnotParaHasHighlight = $(
              "#" + currentAnnotStartPara,
            ).find("highlight");
            let firstHighlightId = "";
            let firstHighlightPosition = 0;
            let currentNotePosition = 0;
            let currentNoteHeight = 0;
            let currentNoteTotalSpace = 0;
            let clampVal = 1;
            let noteLineHeight = parseInt(
              $("#notesDiv" + noteId).css("line-height"),
            );
            if (currentAnnotParaHasHighlight.length > 1) {
              for (let i = 1; i < currentAnnotParaHasHighlight.length; i++) {
                if (currentAnnotParaHasHighlight[i].id.indexOf("_") === -1) {
                  firstHighlightId = currentAnnotParaHasHighlight[i].id;
                  break;
                }
              }
              if (
                firstHighlightId !== "" &&
                typeof ($("#" + firstHighlightId) !== "undefined")
              ) {
                if (
                  typeof ($("#" + firstHighlightId).offset() !== "undefined")
                ) {
                  firstHighlightPosition = $("#" + firstHighlightId).offset()
                    .top;
                  currentNotePosition = $("#" + noteId).offset().top;
                  currentNoteHeight = $("#notesDiv" + noteId).height();
                  currentNoteTotalSpace =
                    currentNotePosition + currentNoteHeight;
                  if (currentNoteTotalSpace > firstHighlightPosition) {
                    if (
                      parseInt($("#" + noteId).attr("startOffset")) <
                      parseInt($("#" + firstHighlightId).attr("startOffset"))
                    ) {
                      if (
                        firstHighlightPosition - currentNotePosition >
                        2 * noteLineHeight
                      ) {
                        clampVal = 2;
                      } else if (
                        firstHighlightPosition - currentNotePosition >
                        noteLineHeight
                      ) {
                        clampVal = 1;
                      }
                      if ($("#notesDiv" + noteId).html().length > 10) {
                        $(document.getElementById("notesDiv" + noteId), {
                          clamp: clampVal,
                        });
                      }
                    }
                    localStorage.setItem("addNoteStartParaId", "");
                  }
                }
              }
            } else {
              localStorage.setItem("addNoteStartParaId", "");
              if (
                typeof localStorage.getItem("addNoteNextParaId") !==
                  "undefined" &&
                localStorage.getItem("addNoteNextParaId") !== "" &&
                localStorage.getItem("addNoteNextParaId") !== null
              ) {
                let nextAnnotStartPara =
                  localStorage.getItem("addNoteNextParaId");
                localStorage.setItem("addNoteNextParaId", "");
                if (nextAnnotStartPara !== "") {
                  let currentAnnotParaHasHighlight = $(
                    "#" + nextAnnotStartPara,
                  ).find("highlight");
                  let firstHighlightId = "";
                  let firstHighlightPosition = 0;
                  let currentNotePosition = 0;
                  let currentNoteHeight = 0;
                  let currentNoteTotalSpace = 0;
                  let clampVal = 1;
                  let noteLineHeight = parseInt(
                    $("#notesDiv" + noteId).css("line-height"),
                  );
                  if (currentAnnotParaHasHighlight.length > 0) {
                    for (
                      let i = 0;
                      i < currentAnnotParaHasHighlight.length;
                      i++
                    ) {
                      if (
                        currentAnnotParaHasHighlight[i].id.indexOf("_") === -1
                      ) {
                        firstHighlightId = currentAnnotParaHasHighlight[i].id;
                        break;
                      }
                    }
                    if (
                      typeof (
                        document.getElementById(firstHighlightId) != "undefined"
                      ) &&
                      typeof (
                        document.getElementById(firstHighlightId).offset() !==
                        "undefined"
                      )
                    ) {
                      firstHighlightPosition = $(
                        "#" + firstHighlightId,
                      ).offset().top;
                      currentNotePosition = $("#" + noteId).offset().top;
                      currentNoteHeight = $("#notesDiv" + noteId).height();
                      currentNoteTotalSpace =
                        currentNotePosition + currentNoteHeight;
                      if (currentNoteTotalSpace > firstHighlightPosition) {
                        if (
                          $("#notesDiv" + noteId)
                            .parent()
                            .offset().top <
                          $("#" + firstHighlightId)
                            .parent()
                            .offset().top
                        ) {
                          if (
                            firstHighlightPosition - currentNotePosition >
                            2 * noteLineHeight
                          ) {
                            clampVal = 2;
                          } else if (
                            firstHighlightPosition - currentNotePosition >
                            noteLineHeight
                          ) {
                            clampVal = 1;
                          }
                          if ($("#notesDiv" + noteId).html().length > 10)
                            $(document.getElementById("notesDiv" + noteId), {
                              clamp: clampVal,
                            });
                        }
                        localStorage.setItem("addNoteNextParaId", "");
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }, 2000);
    addingNote = false;
    setTimeout(() => {}, 2000);
  };
  const textNodesUnder = (el) => {
    let n,
      a = [],
      childEle = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        null,
        false,
      );
    while ((n = childEle.nextNode())) a.push(n);
    return a;
  };
  const highLightSelection = (e, newPlacement) => {
    setCopiedText("");
    setHighlightQuickUnderLine(false);
    setColorYellow(false);
    setColorGreen(false);
    setColorBlue(false);
    setColorPink(false);
    setColorOrange(false);
    setColorPurple(false);
    setColorCyan(false);
    setColorLightNavy(false);
    setColorLightCoral(false);
    setColorSandrift(false);
    setColorGainsboro(false);
    if (window.getSelection) {
      selection = window.getSelection();
    } else if (typeof document.selection !== "undefined") {
      selection = document.selection;
    }
    selectedContent = selection.toString();
    if (selection.toString().length > 0) {
      if (isAnnotatable === "true") {
        if (selection.toString() === "") return true;
        copySelectedText = selection.toString();
        let range = selection.getRangeAt(0);
        let selectionHTML = getSelectionHtml();
        let listOfDummyNode = $('highlight[id^="note"]');
        if (listOfDummyNode) {
          addingNote = false;
          updatingNote = false;
          addingLink = false;
          addingBrief = false;
          updatingLink = false;
          updatingBrief = false;
          for (let k = 0; k < listOfDummyNode.length; k++) {
            let highlightSpanTag = document.getElementById(
              listOfDummyNode[k].id,
            );
            let spanElement = document.createElement("span");
            spanElement.innerHTML = highlightSpanTag.innerText;
            spanElement.normalize();
            var parent = highlightSpanTag.parentNode;
            while (highlightSpanTag.firstChild)
              parent.insertBefore(
                highlightSpanTag.firstChild,
                highlightSpanTag,
              );
            parent.removeChild(highlightSpanTag);
          }
        }
        let isAnnotatingAcrossSection = false;
        if (selectionHTML.indexOf("</p>") !== -1) {
          let listOdSelectedNodes = $(selectionHTML);
          for (let k = 0; k < listOdSelectedNodes.length; k++) {
            let elementNode = listOdSelectedNodes[k];
            if (
              elementNode.nodeName.toLowerCase() === "div" &&
              elementNode.getAttribute("class") === "cc-section"
            ) {
              isAnnotatingAcrossSection = true;
              break;
            }
          }
        }
        if (
          !(
            isAnnotatingAcrossSection ||
            checkForTable(selectionHTML) ||
            selectionHTML.indexOf("highlightedText") !== -1 ||
            selectionHTML.indexOf("anchorElementText") !== -1 ||
            selectionHTML.indexOf("briefElementText") !== -1 ||
            selectionHTML.indexOf("</td>") !== -1
          )
        ) {
          if (selection.anchorOffset !== selection.focusOffset) {
            let getFocusNode = selection.focusNode;
            let getFocusElementPCase = getFocusNode;
            let getFocusElementPCaseSibiling = getFocusNode;
            let getFocusElementPCaseHead = getFocusNode;
            let getFocusElementPCaseHeadOnly = getFocusNode;
            while (!$(getFocusElementPCase).hasClass("cc-principal-case")) {
              getFocusElementPCase = getFocusElementPCase.parentNode;
              if (getFocusElementPCase !== null) {
                insidePrincipalCase = true;
              } else if (getFocusElementPCase === null) {
                insidePrincipalCase = false;
                break;
              }
            }
            while (
              !$(getFocusElementPCaseSibiling).hasClass("cc-principal-case")
            ) {
              getFocusElementPCaseSibiling =
                getFocusElementPCaseSibiling.parentNode;
              if (
                getFocusElementPCaseSibiling !== null &&
                getFocusElementPCaseSibiling !== undefined
              ) {
                if (
                  getFocusElementPCaseSibiling.previousElementSibling !== null
                ) {
                  if (
                    $(
                      getFocusElementPCaseSibiling.previousElementSibling,
                    ).hasClass("cc-principal-case") === true
                  ) {
                    isPrevElementPrincipalCase.current = {
                      prevElementIsPrincpialCase: true,
                      principalCaseId:
                        getFocusElementPCaseSibiling.previousElementSibling.getAttribute(
                          "id",
                        ),
                    };
                    break;
                  }
                }
              } else if (
                getFocusElementPCaseSibiling === null ||
                getFocusElementPCaseSibiling === undefined
              ) {
                break;
              }
            }
            if (insidePrincipalCase) {
              if (
                selectionHTML.indexOf("cc-principalCase-title") !== -1 &&
                selectionHTML.indexOf("epub-text-para") !== -1
              ) {
                showCopyPopoverAfterHighLight("epub-text-para");
                setIsCopyOnlyPopoverOpen(true);
                return;
              } else if (
                selectionHTML.indexOf("cc-principal-case-citation") !== -1 &&
                selectionHTML.indexOf("epub-text-para") !== -1
              ) {
                showCopyPopoverAfterHighLight("epub-text-para");
                setIsCopyOnlyPopoverOpen(true);
                return;
              } else {
                while (
                  !$(getFocusElementPCaseHead).hasClass(
                    "epub-law-heading-container",
                  )
                ) {
                  getFocusElementPCaseHead =
                    getFocusElementPCaseHead.parentNode;
                  if (getFocusElementPCaseHead !== null) {
                    pCaseWithHeadingCitation = true;
                  } else if (getFocusElementPCaseHead === null) {
                    pCaseWithHeadingCitation = false;
                    break;
                  }
                }
                while (
                  !$(getFocusElementPCaseHeadOnly).hasClass(
                    "cc-principalCase-title",
                  )
                ) {
                  getFocusElementPCaseHeadOnly =
                    getFocusElementPCaseHeadOnly.parentNode;
                  if (getFocusElementPCaseHeadOnly !== null) {
                    pCaseWithHeadingOnly = true;
                  } else if (getFocusElementPCaseHeadOnly === null) {
                    pCaseWithHeadingOnly = false;
                    break;
                  }
                }
              }
            }
            getFocusElement = getFocusNode;
            while (!$(getFocusElement).hasClass("cc-wrapper")) {
              if (getFocusElement.parentNode === null) {
                checkCopyElementBySelectionHTML(selectionHTML);
                setIsCopyOnlyPopoverOpen(true);
                return false;
              }
              getFocusElement = getFocusElement.parentNode;
            }
            annotationEndParaId = getFocusElement.id;
            if (updatingLink) {
              while (!$(getFocusNode).hasClass("anchorElementText")) {
                getFocusNode = getFocusNode.parentNode;
                if (getFocusNode !== null) {
                  if (
                    $(getFocusNode.parentNode).hasClass("content-holder-block")
                  )
                    break;
                }
              }
            }
            if (updatingBrief) {
              while (!$(getFocusNode).hasClass("briefElementText")) {
                getFocusNode = getFocusNode.parentNode;
                if (getFocusNode !== null) {
                  if (
                    $(getFocusNode.parentNode).hasClass("content-holder-block")
                  )
                    break;
                }
              }
            }
            let getAnchorNode = selection.anchorNode;
            let getAnchorElement = getAnchorNode;
            while (!$(getAnchorElement).hasClass("cc-wrapper")) {
              if (getAnchorElement.parentNode === null) {
                checkCopyElementBySelectionHTML(selectionHTML);
                setIsCopyOnlyPopoverOpen(true);
                return false;
              }
              getAnchorElement = getAnchorElement.parentNode;
            }
            annotationStartParaId = getAnchorElement.id;
            if (updatingLink) {
              while (!$(getAnchorNode).hasClass("anchorElementText")) {
                getAnchorNode = getAnchorNode.parentNode;
                if (getAnchorNode !== null) {
                  if (
                    $(getAnchorNode.parentNode).hasClass("content-holder-block")
                  )
                    break;
                }
              }
            }
            if (updatingBrief) {
              while (getAnchorNode.classList.contains("briefElementText")) {
                getAnchorNode = getAnchorNode.parentNode;
                if (getAnchorNode !== null) {
                  if (
                    $(getAnchorNode.parentNode).hasClass("content-holder-block")
                  )
                    break;
                }
              }
            }
            if (
              !$(getAnchorNode).hasClass("highlightedText") &&
              !$(getFocusNode).hasClass("highlightedText") &&
              !$(getAnchorNode).hasClass("briefElementText") &&
              !$(getFocusNode).hasClass("briefElementText") &&
              !$(getAnchorNode).hasClass("anchorElementText") &&
              !$(getFocusNode).hasClass("anchorElementText") &&
              !$(getAnchorNode.parentElement).hasClass("highlightedText") &&
              !$(getFocusNode.parentElement).hasClass("highlightedText") &&
              !$(getAnchorNode.parentElement).hasClass("briefElementText") &&
              !$(getFocusNode.parentElement).hasClass("briefElementText") &&
              !$(getAnchorNode.parentElement).hasClass("anchorElementText") &&
              !$(getFocusNode.parentElement).hasClass("anchorElementText")
            ) {
              highLightSpanId = 0;
              highLightSpanIdAcrossPara = [];
              selectedParaIds = [];
              let paraIdDictonary = {};
              let paraIDHTMLDictionary = {};
              let paraOuterHTMLDictionary = {};
              let wrapperDictionaryForSelecteedPara = {};
              let innerWrapperDictionaryForSelecteedPara = {};
              let listChildItems = {};
              let newListItem = {};
              let pageNumberElementDic = {};
              let featureChildItems = {};
              let listChildItemsFlag = false;
              paraLevelAnnotation = false;
              let selectedText;
              acrossParaLevelAnnotationFlag =
                annotationStartParaId === annotationEndParaId ? false : true;
              selectedText = range.cloneContents();
              for (let i = 0; i < selectedText.childNodes.length; i++) {
                if ($(selectedText.childNodes[i]).hasClass("cc-wrapper")) {
                  paraLevelAnnotation = true;
                  if (
                    $.inArray(
                      selectedText.childNodes[i].id,
                      selectedParaIds,
                    ) === -1
                  ) {
                    selectedParaIds.push(selectedText.childNodes[i].id);
                    paraIdDictonary[selectedText.childNodes[i].id] =
                      selectedText.childNodes[i].textContent;
                    paraIDHTMLDictionary[selectedText.childNodes[i].id] =
                      selectedText.childNodes[i].innerHTML;
                    paraOuterHTMLDictionary[selectedText.childNodes[i].id] =
                      selectedText.childNodes[i].outerHTML;
                  }
                }
                if (
                  !$(selectedText.childNodes[i]).hasClass("cc-wrapper") &&
                  selectedText.childNodes[i].hasChildNodes()
                ) {
                  let wrapperElement = document.createElement(
                    selectedText.childNodes[i].tagName.toLowerCase(),
                  );
                  wrapperElement.setAttribute(
                    "class",
                    selectedText.childNodes[i].className,
                  );
                  getAllSelectedParaDetails(
                    selectedText.childNodes[i],
                    selectedParaIds,
                    paraIdDictonary,
                    paraIDHTMLDictionary,
                    paraOuterHTMLDictionary,
                    wrapperDictionaryForSelecteedPara,
                    wrapperElement,
                    innerWrapperDictionaryForSelecteedPara,
                    listChildItems,
                    featureChildItems,
                    newListItem,
                    pageNumberElementDic,
                  );
                }
              }
              enclosingParaIdString = "";
              if (selectedParaIds.length > 0) {
                for (let r = 0; r < selectedParaIds.length; r++) {
                  let deEliminator =
                    r === selectedParaIds.length - 1 ? "" : "|";
                  enclosingParaIdString += selectedParaIds[r] + deEliminator;
                }
              }
              enclosingParaIdString = "";
              if (selectedParaIds.length > 0) {
                for (let r = 0; r < selectedParaIds.length; r++) {
                  let deEliminator =
                    r === selectedParaIds.length - 1 ? "" : "|";
                  enclosingParaIdString += selectedParaIds[r] + deEliminator;
                }
              }
              let highLightText = document.createElement("highlight");
              highLightText.id = "note" + highLightSpanId;
              highLightText.setAttribute("data-references", "popover");
              highLightText.setAttribute("data-toggle", "popover");
              highLightText.setAttribute("class", "highlightedText");
              highLightText.setAttribute("tabindex", "0");
              highLightText.setAttribute(
                "enclosingParaIdString",
                enclosingParaIdString,
              );
              highLightText.setAttribute(
                "highlightStartParaId",
                annotationStartParaId,
              );
              highLightText.setAttribute(
                "highlightEndParaId",
                annotationEndParaId,
              );
              highLightText.setAttribute("role", "mark");
              highLightText.appendChild(selectedText);
              highlightedTextWithoutHTML = "";
              if (annotationStartParaId !== annotationEndParaId) {
                if (selectedParaIds.length > 0) {
                  for (let r = 0; r < selectedParaIds.length; r++) {
                    let highLightTextForPara =
                      document.createElement("highlight");
                    highLightTextForPara.id = "note" + r;
                    highLightTextForPara.setAttribute(
                      "data-references",
                      "popover",
                    );
                    highLightTextForPara.setAttribute("data-toggle", "popover");
                    highLightTextForPara.setAttribute(
                      "class",
                      "highlightedText",
                    );
                    highLightTextForPara.setAttribute("tabindex", "0");
                    highLightTextForPara.setAttribute(
                      "aria-label",
                      paraIDHTMLDictionary[selectedParaIds[r]],
                    );
                    highLightTextForPara.setAttribute(
                      "enclosingParaIdString",
                      enclosingParaIdString,
                    );
                    highLightTextForPara.setAttribute(
                      "highlightStartParaId",
                      annotationStartParaId,
                    );
                    highLightTextForPara.setAttribute(
                      "highlightEndParaId",
                      annotationEndParaId,
                    );
                    highLightTextForPara.setAttribute("role", "mark");
                    highLightTextForPara.innerHTML =
                      paraIDHTMLDictionary[selectedParaIds[r]];
                    highLightSpanIdAcrossPara.push(r);
                    let pgNumbText = convertStringTOHTMLObject(
                      paraOuterHTMLDictionary[selectedParaIds[r]],
                    );
                    if (
                      pgNumbText.className.indexOf("cc-pagenum-begin") === -1
                    ) {
                      let textWithPageNumb = convertStringTOHTMLObject(
                        paraOuterHTMLDictionary[selectedParaIds[r]],
                      );
                      if (
                        $(textWithPageNumb).find(".cc-pagenum-begin").length > 0
                      ) {
                        let str = paraIdDictonary[selectedParaIds[r]];
                        for (
                          let pagIndexer = 0;
                          pagIndexer <
                          textWithPageNumb.querySelectorAll(".cc-pagenum-begin")
                            .length;
                          pagIndexer++
                        ) {
                          let pageNumberText =
                            $(textWithPageNumb).find(".cc-pagenum-begin")[
                              pagIndexer
                            ];
                          highlightedTextWithoutHTML += str.replace(
                            pageNumberText.textContent,
                            "",
                          );
                        }
                      } else
                        highlightedTextWithoutHTML +=
                          paraIdDictonary[selectedParaIds[r]];
                    }
                    if (r === 0) {
                      let tempParaStringWithOutHighlightTag =
                        document.getElementById(selectedParaIds[r]);
                      let startOffsetText =
                        tempParaStringWithOutHighlightTag.textContent;
                      startOffsetText = startOffsetText.replace(
                        /(\r\n|\n|\r)/gm,
                        "",
                      );
                      startOffsetText = startOffsetText.replace(/amp;/g, "");
                      startOffsetText = startOffsetText.replace(/&nbsp;/g, " ");
                      highlightStartOffset =
                        startOffsetText.length -
                        paraIDHTMLDictionary[selectedParaIds[r]].length;
                    } else {
                      let endOffsetText = highLightTextForPara.textContent;
                      endOffsetText = endOffsetText.replace(
                        /(\r\n|\n|\r)/gm,
                        "",
                      );
                      endOffsetText = endOffsetText.replace(/amp;/g, "");
                      endOffsetText = endOffsetText.replace(/&nbsp;/g, " ");
                      let trimmedText = endOffsetText.trim();
                      highlightEndOffset = endOffsetText.length;
                      if (endOffsetText.indexOf(trimmedText) !== -1) {
                        highlightEndOffset =
                          highlightEndOffset -
                          endOffsetText.indexOf(trimmedText);
                      }
                    }
                    document.getElementById(selectedParaIds[r]).innerHTML =
                      document
                        .getElementById(selectedParaIds[r])
                        .innerHTML.replace(
                          paraIDHTMLDictionary[selectedParaIds[r]],
                          highLightTextForPara.outerHTML,
                        );
                  }
                }
              } else {
                range.deleteContents();
                range.insertNode(highLightText);
              }
              if (annotationStartParaId === annotationEndParaId)
                selectedParaIds.push(annotationStartParaId);
              let noteHighlight = $("highlight[id^=note]");
              for (let indexer = 0; indexer < noteHighlight.length; indexer++) {
                if (
                  noteHighlight[indexer].parentNode.className.indexOf(
                    "cc-pagenum-begin",
                  ) >= 0
                )
                  noteHighlight[indexer].parentNode.innerHTML =
                    noteHighlight[indexer].innerHTML;
              }
              let spanStringElement = document.getElementById(
                "note" + highLightSpanId,
              );
              let annotatedSection = spanStringElement.parentNode;
              while (!$(annotatedSection).hasClass("cc-section")) {
                if (annotatedSection.parentNode)
                  annotatedSection = annotatedSection.parentNode;
                else break;
              }
              annotationSectionId =
                annotatedSection !== null && annotatedSection !== undefined
                  ? $(annotatedSection).hasClass("cc-section")
                    ? annotatedSection.id
                    : ""
                  : "";
              let sectionText = "";
              if ($(annotatedSection).hasClass("cc-section")) {
                if (
                  annotatedSection.getElementsByClassName("cc-section-title")
                    .length > 0
                ) {
                  annotationSectionTitle = removeTags(
                    annotatedSection.getElementsByClassName(
                      "cc-section-title",
                    )[0].innerHTML,
                  );
                } else if (
                  annotatedSection.getElementsByClassName(
                    "cc-principalCase-title",
                  ).length > 0
                ) {
                  annotationSectionTitle = removeTags(
                    annotatedSection.getElementsByClassName(
                      "cc-principalCase-title",
                    )[0].innerHTML,
                  );
                } else {
                  annotationSectionTitle = "";
                }
                sectionText = annotatedSection.outerHTML;
              } else {
                annotationSectionTitle = "";
              }
              let startParaNode = document.getElementById(
                annotationStartParaId,
              );
              let paraText = startParaNode.outerHTML;
              let spanString = spanStringElement.outerHTML;
              if (annotationStartParaId === annotationEndParaId) {
                let firstPart = paraText.split(spanString)[0];
                let startOffsetText = removeTags(firstPart);
                let tmp = document.createElement("DIV");
                tmp.innerHTML = firstPart;
                startOffsetText = tmp.textContent;
                startOffsetText = startOffsetText.replace(/(\r\n|\n|\r)/gm, "");
                startOffsetText = startOffsetText.replace(/amp;/g, "");
                startOffsetText = startOffsetText.replace(/&nbsp;/g, " ");
                highlightStartOffset = startOffsetText.length;
                let highlightedTextWithTags = document.getElementById(
                  "note" + highLightSpanId,
                );
                let highlightedText = highlightedTextWithTags.innerHTML;
                let spanLength =
                  highlightedTextWithTags.getElementsByTagName("span").length;
                let spanText, spanTextLength;
                for (let i = 0; i < spanLength; i++) {
                  let spanTag = document
                    .getElementById("note" + highLightSpanId)
                    .getElementsByTagName("span")[i];
                  if (spanTag.hasAttribute("id")) {
                    spanText = spanTag.innerHTML;
                    spanTextLength = spanText.length;
                  }
                }
                highlightedText = highlightedText.replace(/(\r\n|\n|\r)/gm, "");
                highlightedText = highlightedText.replace(/amp;/g, "");
                highlightedText = highlightedText.replace(/&nbsp;/g, " ");
                if (spanText) {
                  highlightedText = highlightedText.replace(spanText, "");
                  highlightedTextWithoutHTML = removeTags(highlightedText);
                  let tmp = document.createElement("DIV");
                  tmp.innerHTML = highlightedText;
                  highlightedTextWithoutHTML = tmp.textContent;
                  let highlightLength = highlightedTextWithoutHTML.length;
                  highlightEndOffset =
                    highlightStartOffset + highlightLength + spanTextLength;
                } else {
                  highlightedTextWithoutHTML = removeTags(highlightedText);
                  let tmp = document.createElement("DIV");
                  tmp.innerHTML = highlightedText;
                  highlightedTextWithoutHTML = tmp.textContent;
                  let highlightLength = highlightedTextWithoutHTML.length;
                  highlightEndOffset = highlightStartOffset + highlightLength;
                }
                idToBeReplaced = "note" + highLightSpanId;
                showHighLightPopoverAfterHighLight(
                  idToBeReplaced,
                  newPlacement,
                );
              } else {
                idToBeReplaced = "note" + highLightSpanId;
                showHighLightPopoverAfterHighLight(
                  idToBeReplaced,
                  newPlacement,
                );
              }
              let firstPartAtSectionLevel = sectionText.split(spanString)[0];
              let startOffsetTextAtSectionLevel = removeTags(
                firstPartAtSectionLevel,
              );
              startOffsetTextAtSectionLevel =
                startOffsetTextAtSectionLevel.replace(/(\r\n|\n|\r)/gm, "");
              startOffsetTextAtSectionLevel =
                startOffsetTextAtSectionLevel.replace(/amp;/g, "");
              startOffsetTextAtSectionLevel =
                startOffsetTextAtSectionLevel.replace(/&nbsp;/g, " ");
              highlightStartOffsetAtSectionLevel =
                startOffsetTextAtSectionLevel.length;
              linkStartOffset = startOffsetTextAtSectionLevel.length;
              briefStartOffsetAtSectionLevel =
                startOffsetTextAtSectionLevel.length;
              let highlightedTextWithTagsAtSectionLevel =
                document.getElementById("note" + highLightSpanId);
              let highlightedTextAtSectionLevel =
                highlightedTextWithTagsAtSectionLevel.innerHTML;
              let spanLengthAtSectionLevel =
                highlightedTextWithTagsAtSectionLevel.getElementsByTagName(
                  "span",
                ).length;
              let spanTextAtSectionLevel, spanTextLengthAtSectionLevel;
              for (let i = 0; i < spanLengthAtSectionLevel; i++) {
                let spanTag = document
                  .getElementById("note" + highLightSpanId)
                  .getElementsByTagName("span")[i];
                if (spanTag.hasAttribute("id")) {
                  spanTextAtSectionLevel = spanTag.innerHTML;
                  spanTextLengthAtSectionLevel = spanTextAtSectionLevel.length;
                }
              }
              highlightedTextAtSectionLevel =
                highlightedTextAtSectionLevel.replace(/(\r\n|\n|\r)/gm, "");
              highlightedTextAtSectionLevel =
                highlightedTextAtSectionLevel.replace(/amp;/g, "");
              highlightedTextAtSectionLevel =
                highlightedTextAtSectionLevel.replace(/&nbsp;/g, " ");
              if (spanTextAtSectionLevel) {
                highlightedTextAtSectionLevel =
                  highlightedTextAtSectionLevel.replace(
                    spanTextAtSectionLevel,
                    "",
                  );
                highlightedTextWithoutHTMLAtSectionLevel = removeTags(
                  highlightedTextAtSectionLevel,
                );
                let highlightLength1 =
                  highlightedTextWithoutHTMLAtSectionLevel.length;
                highlightEndOffsetAtSectionLevel =
                  highlightStartOffsetAtSectionLevel +
                  highlightLength1 +
                  spanTextLengthAtSectionLevel;
                briefEndOffsetAtSectionLevel = highlightEndOffsetAtSectionLevel;
              } else {
                highlightedTextWithoutHTMLAtSectionLevel = removeTags(
                  highlightedTextAtSectionLevel,
                );
                let highlightLength1 =
                  highlightedTextWithoutHTMLAtSectionLevel.length;
                highlightEndOffsetAtSectionLevel =
                  highlightStartOffsetAtSectionLevel + highlightLength1;
                briefEndOffsetAtSectionLevel = highlightEndOffsetAtSectionLevel;
              }
              linkEndOffset = highlightEndOffsetAtSectionLevel;
            } else {
            }
          }
        } else {
          if (selectionHTML.indexOf("highlightedText") !== -1) {
            showCopyPopoverAfterHighLight("highlight");
            setIsCopyOnlyPopoverOpen(true);
          }
          if (selectionHTML.indexOf("briefElementText") !== -1) {
            showCopyPopoverAfterHighLight("highlight");
            setIsCopyOnlyPopoverOpen(true);
          } else if (selectionHTML.indexOf("anchortag") !== -1) {
            showCopyPopoverAfterHighLight("highlight");
            setIsCopyOnlyPopoverOpen(true);
          } else if (checkForTable(selectionHTML)) {
            showCopyPopoverAfterHighLight("table");
            setIsCopyOnlyPopoverOpen(true);
          } else if (selectionHTML.indexOf("cc-section") !== -1) {
            showCopyPopoverAfterHighLight("cc-section");
            setIsCopyOnlyPopoverOpen(true);
          } else {
            showCopyPopoverAfterHighLight("highlight");
            setIsCopyOnlyPopoverOpen(true);
          }
        }
      } else {
        setNotificationOpen(true);
        setNotificationContent("Highlighting is only enabled within chapters.");
      }
    }
    setTimeout(() => {
      window.getSelection().removeAllRanges();
    }, 50);
  };
  const checkCopyElementBySelectionHTML = (selectionHTML) => {
    if (
      selectionHTML.indexOf("highlightedText") !== -1 ||
      selectionHTML.indexOf("briefElementText") !== -1 ||
      selectionHTML.indexOf("anchortag") !== -1
    ) {
      showCopyPopoverAfterHighLight("highlight");
    } else if (checkForTable(selectionHTML)) {
      showCopyPopoverAfterHighLight("table");
    } else if (selectionHTML.indexOf("cc-section") !== -1) {
      showCopyPopoverAfterHighLight("cc-section");
    } else if (selectionHTML.indexOf("epub-image") !== -1) {
      showCopyPopoverAfterHighLight("epub-image");
    } else {
      showCopyPopoverAfterHighLight("highlight");
    }
  };
  const getSelectionHtml = () => {
    let html = "";
    if (typeof window.getSelection != "undefined") {
      let sel = window.getSelection();
      if (sel.rangeCount) {
        let container = document.createElement("div");
        for (let i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        html = container.innerHTML;
      }
    } else if (typeof document.selection != "undefined") {
      if (document.selection.type == "Text") {
        html = document.selection.createRange().htmlText;
      }
    }
    return html;
  };
  const checkForTable = (selectionHTML) => {
    if (
      selectionHTML.indexOf("</th>") >= 0 ||
      selectionHTML.indexOf("</td>") >= 0 ||
      selectionHTML.indexOf("</tr>") >= 0 ||
      selectionHTML.indexOf("</tbody>") >= 0 ||
      selectionHTML.indexOf("</table>") >= 0
    )
      return true;
    else return false;
  };
  const convertStringTOHTMLObject = (htmlString) => {
    let temp = document.createElement("DIV");
    temp.innerHTML = htmlString;
    return temp.children[0];
  };
  const showHighLightPopoverAfterHighLight = (idToBeReplaced, newPlacement) => {
    if (idToBeReplaced === null) idToBeReplaced = "note0";
    if (document.getElementById("note" + highLightSpanId) !== null)
      document.getElementById("note" + highLightSpanId).id = idToBeReplaced;
    selectedNoteId = idToBeReplaced;
    selectionElement = document.getElementById(selectedNoteId);
    setAnchorEl(selectionElement);
    setTimeout(() => {
      let listOfDummyNode = $('highlight[id^="note"]');
      if (listOfDummyNode.length === undefined) {
        $(listOfDummyNode).addClass("ereader-selection-text-color");
      }
      if (listOfDummyNode.length > 1) {
        repaintSelectedText(listOfDummyNode);
      }
      if (listOfDummyNode.length === 1) selectText("note0");
      selectedHighlightColor = "";
    }, 500);
    if (highlightQuickOn) {
      document.querySelector(".colorPalateBtnContainer").style.display = "none";
      if (insidePrincipalCase) {
        saveBriefHighlights(highlightQuickColor, "", "");
      } else {
        saveHighlights(highlightQuickColor);
      }
    } else {
      if (insidePrincipalCase) {
        if (userVO.userRole === "Professor") {
          setIsPopoverOpenProfessor(true);
          setCasePopOver(true);
          setPlacement(newPlacement);
          setNoteValue("");
          setProflink("");
        } else {
          setIsPopoverOpen(true);
          setCasePopOver(true);
          setPlacement(newPlacement);
          setNoteValue("");
        }
      } else {
        if (userVO.userRole === "Professor") {
          setIsPopoverOpenProfessor(true);
          setPlacement(newPlacement);
          setCasePopOver(false);
          setNoteValue("");
          setProflink("");
        } else {
          setIsPopoverOpen(true);
          setPlacement(newPlacement);
          setCasePopOver(false);
          setNoteValue("");
        }
      }
    }
    document.querySelector(".colorPalateBtnContainer").style.display = "none";
  };
  const showCopyPopoverAfterHighLight = (tagName) => {
    const htmlElementsForCopyPopover = document.getElementsByTagName(tagName);
    if (tagName !== "highlight" && tagName !== "table") {
      const htmlElementt = document.getElementsByClassName(tagName).item(0);
      if (htmlElementt) {
        htmlElementt.setAttribute("id", "highlightId");
        selectionElement = document.getElementById("highlightId");
        setAnchorEl(selectionElement);
      }
    } else if (htmlElementsForCopyPopover.length) {
      if (tagName === "highlight") {
        let idValue = htmlElementsForCopyPopover[0].id;
        selectedNoteId = idValue;
        selectionElement = document.getElementById(selectedNoteId);
        setAnchorEl(selectionElement);
      } else if (tagName === "table") {
        htmlElementsForCopyPopover.item(0).setAttribute("id", "tableId");
        selectionElement = document.getElementById("tableId");
        setAnchorEl(selectionElement);
      }
    }
  };
  const saveHighlights = (color, noteval) => {
    setSaveHighlightLoading(true);
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastReadBookId: bookId,
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadParagraphId: "para01",
          lastReadSubSectionId: "subsec01",
          lastReadPageNum: lastReadPageNum,
        },
        sessionVO: getSessionVO(),
      },
      annotationVO: {
        bookId: bookId,
        chapterId: chapterId,
        chapterTitle: chapterTitle,
        highlightColorCode: color,
        pageNumber: lastReadPageNum,
        sectionId: annotationSectionId,
        enclosingParaList: selectedParaIds,
        sectionTitle: annotationSectionTitle,
        highlightEndParaId: annotationEndParaId,
        highlightText: highlightedTextWithoutHTML,
        highlightParaEndOffset: highlightEndOffset,
        highlightStartParaId: annotationStartParaId,
        highlightParaStartOffset: highlightStartOffset,
        highlightEndOffset: highlightEndOffsetAtSectionLevel,
        highlightStartOffset: highlightStartOffsetAtSectionLevel,
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/addChapterHighlights`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data.annotationVO) {
            dppAnotationId = data.annotationVO.annotationId;
            reqData.annotationVO.annotationId = dppAnotationId;
            reqData.annotationVO.annotationStatus = "added";
            reqData.annotationVO.dppContentType = "annotation";
            reqData.annotationVO.sectionId = isPrevElementPrincipalCase.current
              .prevElementIsPrincpialCase
              ? isPrevElementPrincipalCase.current.principalCaseId
              : annotationSectionId;
            if (noteValue && noteValue.trim().length > 0)
              reqData.annotationVO.noteText = noteValue;
            addHighlightToRedux(reqData.annotationVO);
          }
          let highLightColor = color;
          let annotationResponse = {
            highlightEndOffset: "",
            highlightStartOffset: "",
            enclosingParaList: selectedParaIds,
            highlightColorCode: highLightColor,
            highlightEndParaId: annotationEndParaId,
            highlightText: highlightedTextWithoutHTML,
            highlightParaEndOffset: highlightEndOffset,
            highlightStartParaId: annotationStartParaId,
            annotationId: data.annotationVO.annotationId,
            dppContentId: data.annotationVO.annotationId,
            highlightParaStartOffset: highlightStartOffset,
          };
          selectedNoteId = dppAnotationId;
          if (data.annotationVO.annotationId) {
            dppAnotationId = data.annotationVO.annotationId;
            if (highLightSpanIdAcrossPara.length === 0) {
              highLightSpanId = 0;
              document.getElementById("note" + highLightSpanId).id =
                dppAnotationId;
              let tempVariableforDppAnotationId =
                document.getElementById(dppAnotationId);
              tempVariableforDppAnotationId.addEventListener(
                "click",
                function (e) {
                  highLightedTextClick(e);
                },
              );
              tempVariableforDppAnotationId.setAttribute(
                "startOffset",
                highlightStartOffsetAtSectionLevel,
              );
              tempVariableforDppAnotationId.setAttribute(
                "endOffset",
                highlightEndOffsetAtSectionLevel,
              );
              tempVariableforDppAnotationId.setAttribute("tabindex", "0");
              tempVariableforDppAnotationId.setAttribute(
                "highlightParaStartOffset",
                highlightStartOffset,
              );
              tempVariableforDppAnotationId.setAttribute(
                "hid",
                data.annotationVO.annotationId,
              );
              tempVariableforDppAnotationId.setAttribute(
                "highlightParaEndOffset",
                highlightEndOffset,
              );
              tempVariableforDppAnotationId.setAttribute(
                "highlightStartParaId",
                annotationStartParaId,
              );
              tempVariableforDppAnotationId.setAttribute(
                "highlightEndParaId",
                annotationEndParaId,
              );
              tempVariableforDppAnotationId.setAttribute(
                "enclosingParaIdString",
                "",
              );
              $(dppAnotationId).removeClass("ereader-selection-text-color");
              if (highLightColor !== undefined) {
                if (highLightColor.toLowerCase() === "underline") {
                  document
                    .getElementById(dppAnotationId)
                    .setAttribute(
                      "style",
                      "text-decoration:underline !important",
                    );
                } else {
                  document
                    .getElementById(dppAnotationId)
                    .setAttribute(
                      "style",
                      "background-color:" + highLightColor + " !important",
                    );
                }
              }
              document
                .getElementById(dppAnotationId)
                .setAttribute("colorCodeId", highLightColor);
              document
                .getElementById(dppAnotationId)
                .setAttribute("sectionId", annotationSectionId);
              document
                .getElementById(dppAnotationId)
                .setAttribute("sectionTitle", annotationSectionTitle);
              if (noteval !== undefined && noteval !== null) {
                document
                  .getElementById(dppAnotationId)
                  .setAttribute("noteText", noteval);
              } else {
                document
                  .getElementById(dppAnotationId)
                  .setAttribute("noteText", " ");
              }
              selectedHighlightColor = highLightColor;
              if (
                typeof tempVariableforDppAnotationId.children !== "undefined" &&
                tempVariableforDppAnotationId.children != null
              ) {
                if (tempVariableforDppAnotationId.children.length > 0) {
                  let highlightTags = [tempVariableforDppAnotationId];
                  let nonMultiTags = [];
                  for (let i = 0; i < highlightTags.length; i++) {
                    if (highlightTags[i].id.indexOf("_") === -1)
                      nonMultiTags.push(highlightTags[i]);
                  }
                  let annotationListInDOM = nonMultiTags;
                  for (let i = 0; i < annotationListInDOM.length; i++) {
                    let highlightStartPara = annotationListInDOM[i];
                    multiParaAnnotationStartParaStartOffset = parseInt(
                      highlightStartPara.getAttribute(
                        "highlightParaStartOffset",
                      ),
                    );
                    multiParaAnnotationStartParaEndOffset = parseInt(
                      highlightStartPara.getAttribute("highlightParaEndOffset"),
                    );
                    multiParaHighlightIndexer = 0;
                    highlightTagFirstPart = '<highlight id="';
                    multiParaAnnotationID = highlightStartPara.id;
                    highlightTagLastPart =
                      '" className="highlightedText" style="' +
                      highlightStartPara.getAttribute("style") +
                      '" data-references="popover" data-toggle="popover" data-original-title="" tabindex="0" title="" highlightParaStartOffset="' +
                      highlightStartPara.getAttribute(
                        "highlightParaStartOffset",
                      ) +
                      '" highlightParaEndOffset="' +
                      highlightStartPara.getAttribute(
                        "highlightParaEndOffset",
                      ) +
                      '" startOffset="' +
                      highlightStartPara.getAttribute("startOffset") +
                      '" endOffset="' +
                      highlightStartPara.getAttribute("endOffset") +
                      '" highlightStartparaid="' +
                      highlightStartPara.getAttribute("highlightStartparaid") +
                      '" highlightendparaid="' +
                      highlightStartPara.getAttribute("highlightendparaid") +
                      '"  enclosingParaIdString="' +
                      enclosingParaIdString +
                      '">';
                    let paraId = highlightStartPara.getAttribute(
                      "highlightStartParaId",
                    );
                    let paraNode = document.getElementById(paraId);
                    MARK = false;
                    addAnnotationMarkup(paraNode, paraId);
                    addAnnotationMarkupByOffestAndLengthForSinglePara(
                      paraNode,
                      paraId,
                    );
                  }
                  setTimeout(() => {
                    for (let i = 0; i < annotationListInDOM.length; i++) {
                      let splittedSinglePara = $(
                        "highlight[id^=" + annotationListInDOM[i].id + "]",
                      );
                      for (let j = 0; j < splittedSinglePara.length; j++) {
                        document
                          .getElementById(splittedSinglePara[j].id)
                          .addEventListener("click", function (e) {
                            highLightedTextClick(e);
                          });
                      }
                    }
                  }, 500);
                  for (let i = 0; i < annotationListInDOM.length; i++) {
                    let splittedMultiParaAnnotation = $(
                      "highlight[id^=" + annotationListInDOM[i].id + "]",
                    );
                    for (
                      let j = 0;
                      j < splittedMultiParaAnnotation.length;
                      j++
                    ) {
                      if (
                        splittedMultiParaAnnotation[j].children[0] !==
                          undefined &&
                        splittedMultiParaAnnotation[
                          j
                        ].children[0].tagName.toLowerCase() === "highlight" &&
                        splittedMultiParaAnnotation[j].children.length === 1
                      ) {
                        splittedMultiParaAnnotation[j].innerHTML =
                          splittedMultiParaAnnotation[j].children[0].innerHTML;
                      }
                    }
                  }
                }
              }
            } else {
              for (let j = 0; j < highLightSpanIdAcrossPara.length; j++) {
                let dppAnotationIdIndexer =
                  dppAnotationId + "_" + highLightSpanIdAcrossPara[j];
                if (j === 0) {
                  dppAnotationIdIndexer = dppAnotationId;
                }

                if (
                  document.getElementById(
                    "note" + highLightSpanIdAcrossPara[j],
                  ) !== null
                ) {
                  document.getElementById(
                    "note" + highLightSpanIdAcrossPara[j],
                  ).id = dppAnotationIdIndexer;
                  let tempVariableforDppAnotationIdIndexer =
                    document.getElementById(dppAnotationIdIndexer);
                  tempVariableforDppAnotationIdIndexer.addEventListener(
                    "click",
                    function (e) {
                      highLightedTextClick(e);
                    },
                  );
                  tempVariableforDppAnotationIdIndexer.setAttribute(
                    "startOffset",
                    highlightStartOffsetAtSectionLevel,
                  );
                  tempVariableforDppAnotationIdIndexer.setAttribute(
                    "endOffset",
                    highlightEndOffsetAtSectionLevel,
                  );
                  tempVariableforDppAnotationIdIndexer.setAttribute(
                    "tabindex",
                    "0",
                  );
                  tempVariableforDppAnotationIdIndexer.setAttribute(
                    "highlightParaStartOffset",
                    highlightStartOffset,
                  );
                  tempVariableforDppAnotationIdIndexer.setAttribute(
                    "highlightParaEndOffset",
                    highlightEndOffset,
                  );
                  tempVariableforDppAnotationIdIndexer.setAttribute(
                    "highlightStartParaId",
                    annotationStartParaId,
                  );
                  tempVariableforDppAnotationIdIndexer.setAttribute(
                    "highlightEndParaId",
                    annotationEndParaId,
                  );
                  tempVariableforDppAnotationIdIndexer.setAttribute(
                    "hid",
                    data.annotationVO.annotationId,
                  );
                  let enclosingString = "";
                  if (selectedParaIds.length > 0) {
                    for (let k = 0; k < selectedParaIds.length; k++) {
                      if (k === selectedParaIds.length - 1)
                        enclosingString += selectedParaIds[k];
                      else enclosingString += selectedParaIds[k] + "|";
                    }
                  }
                  tempVariableforDppAnotationIdIndexer.setAttribute(
                    "enclosingParaIdString",
                    enclosingString,
                  );
                  $("#" + dppAnotationIdIndexer).removeClass(
                    "ereader-selection-text-color",
                  );
                  if (highLightColor !== undefined) {
                    if (highLightColor.toLowerCase() === "underline") {
                      document
                        .getElementById(dppAnotationIdIndexer)
                        .setAttribute(
                          "style",
                          "text-decoration:underline !important",
                        );
                    } else {
                      document
                        .getElementById(dppAnotationIdIndexer)
                        .setAttribute(
                          "style",
                          "background-color:" + highLightColor + " !important",
                        );
                    }
                  }
                  document
                    .getElementById(dppAnotationIdIndexer)
                    .setAttribute("colorCodeId", highLightColor);
                  document
                    .getElementById(dppAnotationIdIndexer)
                    .setAttribute("sectionId", annotationSectionId);
                  document
                    .getElementById(dppAnotationIdIndexer)
                    .setAttribute("sectionTitle", annotationSectionTitle);
                  selectedHighlightColor = highLightColor;
                  if (noteval !== undefined && noteval !== null) {
                    document
                      .getElementById(dppAnotationIdIndexer)
                      .setAttribute("noteText", noteval);
                  } else {
                    document
                      .getElementById(dppAnotationIdIndexer)
                      .setAttribute("noteText", " ");
                  }
                  if (
                    typeof tempVariableforDppAnotationIdIndexer.children !==
                      "undefined" &&
                    tempVariableforDppAnotationIdIndexer.children != null
                  ) {
                    if (
                      tempVariableforDppAnotationIdIndexer.children.length > 0
                    ) {
                      let highlightTags = [
                        tempVariableforDppAnotationIdIndexer,
                      ];
                      let nonMultiTags = [];
                      for (let i = 0; i < highlightTags.length; i++) {
                        if (highlightTags[i].id.indexOf("_") === -1)
                          nonMultiTags.push(highlightTags[i]);
                      }
                      let annotationListInDOM = nonMultiTags;
                      for (let i = 0; i < annotationListInDOM.length; i++) {
                        let highlightStartPara = annotationListInDOM[i];
                        multiParaAnnotationStartParaStartOffset = parseInt(
                          highlightStartPara.getAttribute(
                            "highlightParaStartOffset",
                          ),
                        );
                        multiParaAnnotationStartParaEndOffset = parseInt(
                          highlightStartPara.getAttribute(
                            "highlightParaEndOffset",
                          ),
                        );
                        multiParaHighlightIndexer = 0;
                        highlightTagFirstPart = '<highlight id="';
                        multiParaAnnotationID = highlightStartPara.id;
                        highlightTagLastPart =
                          '" className="highlightedText" style="' +
                          highlightStartPara.getAttribute("style") +
                          '" data-references="popover" data-toggle="popover" data-original-title="" tabindex="0" title="" highlightParaStartOffset="' +
                          highlightStartPara.getAttribute(
                            "highlightParaStartOffset",
                          ) +
                          '" highlightParaEndOffset="' +
                          highlightStartPara.getAttribute(
                            "highlightParaEndOffset",
                          ) +
                          '" startOffset="' +
                          highlightStartPara.getAttribute("startOffset") +
                          '" endOffset="' +
                          highlightStartPara.getAttribute("endOffset") +
                          '" highlightStartparaid="' +
                          highlightStartPara.getAttribute(
                            "highlightStartparaid",
                          ) +
                          '" highlightendparaid="' +
                          highlightStartPara.getAttribute(
                            "highlightendparaid",
                          ) +
                          '"  enclosingParaIdString="' +
                          enclosingParaIdString +
                          '">';
                        let paraId = highlightStartPara.getAttribute(
                          "highlightStartParaId",
                        );
                        MARK = false;
                      }
                      setTimeout(() => {
                        for (let i = 0; i < annotationListInDOM.length; i++) {
                          let splittedSinglePara = $(
                            "highlight[id^=" + annotationListInDOM[i].id + "]",
                          );
                          for (let l = 0; l < splittedSinglePara.length; l++) {
                            document
                              .getElementById(splittedSinglePara[l].id)
                              .addEventListener("click", function (e) {
                                highLightedTextClick(e);
                              });
                          }
                        }
                      }, 500);
                      for (let i = 0; i < annotationListInDOM.length; i++) {
                        let splittedMultiParaAnnotation = $(
                          "highlight[id^=" + annotationListInDOM[i].id + "]",
                        );
                        for (
                          let l = 0;
                          l < splittedMultiParaAnnotation.length;
                          l++
                        ) {
                          if (
                            splittedMultiParaAnnotation[l].children[0] !==
                              undefined &&
                            splittedMultiParaAnnotation[
                              l
                            ].children[0].tagName.toLowerCase() ===
                              "highlight" &&
                            splittedMultiParaAnnotation[l].children.length === 1
                          ) {
                            splittedMultiParaAnnotation[l].innerHTML =
                              splittedMultiParaAnnotation[
                                l
                              ].children[0].innerHTML;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            let secOutline = "outlineSection_" + annotationSectionId;
            if (document.getElementById(secOutline) !== null) {
            }
            window.getSelection().removeAllRanges();
          }
          let pgNumber = $("highlight[id^=" + dppAnotationId + "]");
          for (let tt = 0; tt < pgNumber.length; tt++) {
            if (
              pgNumber[tt].parentNode !== null &&
              pgNumber[tt].parentNode.className !== null &&
              pgNumber[tt].parentNode.className.indexOf("cc-pagenum-begin") >= 0
            )
              pgNumber[tt].parentNode.innerHTML = pgNumber[tt].innerHTML;
          }
          if (addingNote) {
            addChapterNote(noteval);
          }
          if (globalChapterAnnotationList === "") {
            globalChapterAnnotationList = [];
            globalChapterAnnotationList.push(annotationResponse);
          } else {
            globalChapterAnnotationList = [
              ...globalChapterAnnotationList,
              annotationResponse,
            ];
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        setSaveHighlightLoading(false);
        addHighlightChangeMsg(color);
      })
      .catch((error) => {
        setSaveHighlightLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const addAnnotationMarkup = (node, id) => {
    $(node)
      .contents()
      .each(function () {
        let n = $(this);
        if (this.nodeType == 3 && MARK) {
          multiParaHighlightIndexer++;
          $(this).wrap(
            highlightTagFirstPart +
              multiParaAnnotationID +
              "_" +
              multiParaHighlightIndexer +
              highlightTagLastPart +
              "</highlight>",
          );
        }
        if (this.nodeType == 1) {
          if (this.nodeName.toLowerCase() == "highlight") {
            if ($(n).hasClass("highlightedText") && $(n).attr("id") == id) {
              MARK = true;
              addAnnotationMarkup(n, id);
            } else {
              MARK = false;
              addAnnotationMarkup(n, id);
            }
          }
          addAnnotationMarkup(n, id);
        }
      });
  };
  const addAnnotationMarkupByOffestAndLengthForSinglePara = (
    highlightStartPara,
    id,
  ) => {
    $(highlightStartPara)
      .contents()
      .each(function () {
        let n = $(this);
        if (this.nodeType == 1) {
          addAnnotationMarkupByOffestAndLengthForSinglePara(n, id);
        } else if (this.nodeType == 3) {
          multiParaHighlightIndexer++;
          if (!MARK && multiParaAnnotationStartParaStartOffset < this.length) {
            multiParaHighlightIndexer++;
            $(this).replaceWith(
              this.textContent.substring(
                0,
                multiParaAnnotationStartParaStartOffset,
              ) +
                highlightTagFirstPart +
                multiParaAnnotationID +
                "_" +
                multiParaHighlightIndexer +
                highlightTagLastPart +
                this.textContent.substring(
                  multiParaAnnotationStartParaStartOffset,
                  this.length,
                ) +
                "</highlight>",
            );
            MARK = true;
            multiParaAnnotationStartParaEndOffset =
              multiParaAnnotationStartParaEndOffset -
              this.length +
              multiParaAnnotationStartParaStartOffset;
          } else if (
            MARK &&
            multiParaAnnotationStartParaEndOffset > this.length
          ) {
            multiParaHighlightIndexer++;
            $(this).wrap(
              highlightTagFirstPart +
                multiParaAnnotationID +
                "_" +
                multiParaHighlightIndexer +
                highlightTagLastPart +
                "</highlight>",
            );
            multiParaAnnotationStartParaEndOffset =
              multiParaAnnotationStartParaEndOffset - this.length;
          } else if (
            MARK &&
            multiParaAnnotationStartParaEndOffset <= this.length
          ) {
            multiParaHighlightIndexer++;
            if (
              this.textContent.substring(
                0,
                multiParaAnnotationStartParaEndOffset,
              ).length > 0
            )
              $(this).replaceWith(
                highlightTagFirstPart +
                  multiParaAnnotationID +
                  "_" +
                  multiParaHighlightIndexer +
                  highlightTagLastPart +
                  this.textContent.substring(
                    0,
                    multiParaAnnotationStartParaEndOffset,
                  ) +
                  "</highlight>" +
                  this.textContent.substring(
                    multiParaAnnotationStartParaEndOffset,
                    this.length,
                  ) +
                  "</highlight>",
              );
            multiParaAnnotationStartParaStartOffset = -1;
            multiParaAnnotationStartParaEndOffset = -1;
          } else {
            multiParaAnnotationStartParaStartOffset =
              multiParaAnnotationStartParaStartOffset - this.length;
            multiParaAnnotationStartParaEndOffset =
              multiParaAnnotationStartParaEndOffset - this.length;
          }
        }
      });
  };
  const addChapterNote = (noteval) => {
    setLoading(true);
    if (selectedParaIds.length === 0) {
      let enclosingIds = [];
      let enclosingString = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("enclosingparaidstring");
      if (enclosingString.length > 0) {
        while (enclosingString.length > 0) {
          if (enclosingString.indexOf("|") !== -1) {
            enclosingIds.push(
              enclosingString.substring(0, enclosingString.indexOf("|")),
            );
            enclosingString = enclosingString.substring(
              enclosingString.indexOf("|") + 1,
            );
          } else {
            enclosingIds.push(enclosingString);
            enclosingString = "";
          }
        }
      } else {
        enclosingIds.push(annotationStartParaId);
      }
      selectedParaIds = enclosingIds;
    }
    if (isPopoverOpenUpdate || isPopoverOpenProfessorUpdate) {
      highlightStartOffset = parseInt(
        document
          .getElementById(selectedNoteIdUpdate)
          .getAttribute("highlightparastartoffset"),
      );
      highlightEndOffset = parseInt(
        document
          .getElementById(selectedNoteIdUpdate)
          .getAttribute("highlightparaendoffset"),
      );
      annotationStartParaId = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("highlightstartparaid");
      annotationEndParaId = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("highlightendparaid");
      annotationSectionId = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("sectionid");
      annotationSectionTitle = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("sectiontitle");
      selectedNoteId = selectedNoteIdUpdate;
    }
    if (document.getElementById(selectedNoteIdUpdate)) {
      annotationSectionId = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("sectionid");
      annotationSectionTitle = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("sectiontitle");
    }
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadPageNum: "",
          lastReadSectionId: "",
          lastReadBookId: bookId,
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastReadParagraphId: "para01",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadSubSectionId: "subsec01",
        },
        sessionVO: getSessionVO(),
      },
      annotationVO: {
        bookId: bookId,
        noteText: noteval,
        chapterId: chapterId,
        chapterTitle: chapterTitle,
        pageNumber: lastReadPageNum,
        annotationId: selectedNoteId,
        sectionId: annotationSectionId,
        enclosingParaList: selectedParaIds,
        highlightEndParaId: annotationEndParaId,
        highlightParaEndOffset: highlightEndOffset,
        highlightStartParaId: annotationStartParaId,
        highlightParaStartOffset: highlightStartOffset,
        sectionTitle: annotationSectionTitle ? annotationSectionTitle : " ",
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/addChapterNote`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          reqData.annotationVO.annotationStatus = "updatedNote";
          reqData.annotationVO.dppContentType = "annotation";
          if (noteval) reqData.annotationVO.noteText = noteval;
          addHighlightToRedux(reqData.annotationVO);
          yValue = document
            .getElementById(selectedNoteId)
            .getBoundingClientRect().top;
          selectedHighlightColor = "#aee6fe";
          if (!selectedHighlightColor) {
            selectedHighlightColor =
              document.getElementById(selectedNoteId).style.backgroundColor;
          }
          const addElements = document.querySelectorAll(
            `[hid="${selectedNoteId}"]`,
          );
          addElements.forEach((element) => {
            element.setAttribute("noteText", noteval);
          });
          displayNotesOnRight(
            noteval,
            selectedNoteId,
            yValue,
            selectedHighlightColor,
            false,
          );
          setIsPopoverOpenUpdate(false);
          setIsPopoverOpenProfessorUpdate(false);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        setLoading(false);
      })
      .catch((error) => {
        setIsPopoverOpenUpdate(false);
        setIsPopoverOpenProfessorUpdate(false);
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const colorBtnPressed = (e, color) => {
    outlineOnly = false;
    let removeCloseIcon = document.querySelectorAll(
      ".color-pallete .colorButton",
    );
    for (let i = 0; i < removeCloseIcon.length; i++) {
      ReactDOM.unmountComponentAtNode(
        document.getElementById(removeCloseIcon[i].id),
      );
    }
    setHighlightQuickUnderLine(false);
    colorCodeId = e.currentTarget.id;
    let addCloseIcon = document.getElementById(e.currentTarget.id);
    e.currentTarget.id === "underLine"
      ? setHighlightQuickUnderLine(true)
      : ReactDOM.render(
          <GrFormClose className="selected-icon" />,
          addCloseIcon,
        );
    let noteVal = noteValue;
    addingNote = noteVal !== "" ? true : false;
    if (casePopOver) {
      let labelValue = "";
      let exists = false;
      if (userVO.userRole === "Professor" && profLink.trim() !== "") {
        let linkSharedWithStd1 = document.getElementById("shareit").checked;
        saveCreatedLink(profLink, linkSharedWithStd1, noteVal, color);
        setIsPopoverOpenProfessor(false);
      } else {
        if (!exists) {
          saveBriefHighlights(color, noteVal, labelValue);
          setIsPopoverOpenProfessor(false);
        } else {
          labelColor = color;
          briefNote = noteVal;
          setIsBriefOpen(true);
          outlineOnly = true;
        }
      }
    } else {
      if (userVO.userRole === "Professor") {
        if (profLink.trim() === "") {
          saveHighlights(color, noteVal);
        } else if (profLink.trim() !== "") {
          let linkSharedWithStd = document.getElementById("shareit").checked;
          saveCreatedLink(profLink, linkSharedWithStd, noteVal, color);
        }
        setIsPopoverOpenProfessor(false);
      } else {
        saveHighlights(color, noteVal);
        setIsPopoverOpen(false);
      }
    }
  };
  const removeHighLightColor = (e) => {
    setLoading(true);
    let colorBtId = e.currentTarget.id;
    if (colorBtId === "underLine") {
      setHighlightQuickUnderLine(false);
    } else {
      ReactDOM.unmountComponentAtNode(document.getElementById(colorBtId));
      if (colorBtId === "color-yellow") {
        setColorYellow(false);
      } else if (colorBtId === "color-green") {
        setColorGreen(false);
      } else if (colorBtId === "color-blue") {
        setColorBlue(false);
      } else if (colorBtId === "color-pink") {
        setColorPink(false);
      } else if (colorBtId === "color-orange") {
        setColorOrange(false);
      } else if (colorBtId === "color-purple") {
        setColorPurple(false);
      } else if (colorBtId === "color-cyan") {
        setColorCyan(false);
      } else if (colorBtId === "color-lightNavy") {
        setColorLightNavy(false);
      } else if (colorBtId === "color-lightCoral") {
        setColorLightCoral(false);
      } else if (colorBtId === "color-sandrift") {
        setColorSandrift(false);
      } else if (colorBtId === "color-gainsboro") {
        setColorGainsboro(false);
      }
    }
    if (updateLinkFlag) {
      updateLink("");
      updateLinkFlag = false;
      setIsPopoverOpenProfessorUpdate(false);
    } else {
      if (
        (isPopoverOpenUpdate || isPopoverOpenProfessorUpdate) &&
        casePopOverUpdate
      ) {
        selectedNoteIdUpdate = selectedNoteIdUpdate1;
      }
      let reqData = {
        userVO: {
          userId: userId,
          userRole: userRole,
          userRoleId: userRoleId,
          userActivityVO: {
            lastReadSectionId: "",
            lastReadBookId: bookId,
            lastViewedOutlineId: "",
            pageNavigatingTo: "EReader",
            lastReadChapterId: chapterId,
            lastReadParagraphId: "para01",
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "EReader",
            lastReadPageNum: lastReadPageNum,
            lastReadSubSectionId: "subsec01",
          },
          sessionVO: getSessionVO(),
        },
        annotationVO: {
          bookId: bookId,
          chapterTitle: "",
          chapterId: chapterId,
          annotationType: annotationType,
          annotationId: selectedNoteIdUpdate,
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      fetch(
        `${localStorage.getItem("ENV")}/manageAnnotationService/deleteChapterHighlights`,
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "true") {
            if (typeof data.sessionAuthenticationToken != "undefined") {
              localStorage.setItem(
                "sessionAuthenticationToken",
                data.sessionAuthenticationToken,
              );
            }
            reqData.annotationVO.annotationStatus = "deleted";
            reqData.annotationVO.sectionId = document
              .getElementById(selectedNoteIdUpdate)
              .getAttribute("sectionid");
            addHighlightToRedux(reqData.annotationVO);
            addBriefToRedux(reqData.annotationVO);
            if (
              (isPopoverOpenUpdate || isPopoverOpenProfessorUpdate) &&
              casePopOverUpdate
            ) {
              let relatedHighLightTags = $(
                "briefstag[id^=" + selectedNoteIdUpdate + "]",
              );
              for (let i = 0; i < relatedHighLightTags.length; i++) {
                let highlightSpanTag = document.getElementById(
                  relatedHighLightTags[i].id,
                );
                let spanElement = document.createElement("span");
                spanElement.innerHTML = highlightSpanTag.innerText;
                spanElement.normalize();
                var parent = highlightSpanTag.parentNode;
                while (highlightSpanTag.firstChild)
                  parent.insertBefore(
                    highlightSpanTag.firstChild,
                    highlightSpanTag,
                  );
                parent.removeChild(highlightSpanTag);
              }
              let spnNotesCollection = $(
                "span[id='colSpan" + selectedNoteIdUpdate + "']",
              );
              let briefTextClassElements = $(".labelNoteWrapper");
              let briefTextElementsCount = briefTextClassElements.length;
              if (briefTextElementsCount > 0 && spnNotesCollection.length > 0) {
                for (let i = 0; i < briefTextClassElements.length; i++) {
                  if (
                    briefTextClassElements[i].id.substring(
                      12,
                      briefTextClassElements[i].id.length,
                    ) ===
                    spnNotesCollection[0].id.substring(
                      7,
                      spnNotesCollection[0].id.length,
                    )
                  ) {
                    briefTextClassElements[i].parentNode.remove();
                    break;
                  }
                }
              }
            } else if (
              (isPopoverOpenUpdate || isPopoverOpenProfessorUpdate) &&
              !casePopOverUpdate
            ) {
              let relatedHighLightTags = $(
                "highlight[id^=" + selectedNoteIdUpdate + "]",
              );
              for (let i = 0; i < relatedHighLightTags.length; i++) {
                let highlightSpanTag = document.getElementById(
                  relatedHighLightTags[i].id,
                );
                let spanElement = document.createElement("span");
                spanElement.innerHTML = highlightSpanTag.innerText;
                spanElement.normalize();
                var parent = highlightSpanTag.parentNode;
                while (highlightSpanTag.firstChild)
                  parent.insertBefore(
                    highlightSpanTag.firstChild,
                    highlightSpanTag,
                  );
                parent.removeChild(highlightSpanTag);
              }

              let notesTextClassElements = $(".notesText");
              for (let i = 0; i < notesTextClassElements.length; i++) {
                if (
                  notesTextClassElements[i].id.substring(
                    8,
                    notesTextClassElements[i].id.length,
                  ) === selectedNoteIdUpdate
                ) {
                  notesTextClassElements[i].parentNode.remove();
                  break;
                }
              }
              let notesSpanBlockClassElements = $(".notesSpanBlock");
              for (let i = 0; i < notesSpanBlockClassElements.length; i++) {
                if (
                  notesSpanBlockClassElements[i].id === selectedNoteIdUpdate
                ) {
                  notesSpanBlockClassElements[i].parentNode.removeChild(
                    notesSpanBlockClassElements[i],
                  );
                  break;
                }
              }
              for (let p = 0; p < globalChapterAnnotationList.length; p++) {
                if (
                  selectedNoteId === globalChapterAnnotationList[p].annotationId
                ) {
                  globalChapterAnnotationList.splice(p, 1);
                }
              }
            }
            setIsPopoverOpenUpdate(false);
            setIsPopoverOpenProfessorUpdate(false);
          } else if (data.wkErrorCode) {
            handleException(data);
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const handleNoteValue = (e) => {
    setNoteValue(e.target.value);
  };
  const handleNoteValueUpdate = (e) => {
    setNoteValueUpdate(e.target.value);
    setIsNoteUpdated(true);
  };
  const handleHLQuickToolInputs = (QuickHLONFlag, colorCode) => {
    setHighlightQuickOn(QuickHLONFlag);
    setHighlightQuickColor(colorCode);
  };
  const onChangeBriefLabelsEvent = (e) => {
    let label = e.target.value;
    setCurrentBriefLabel(label);
    if (label !== "" && label !== undefined && label !== null) {
      let noteVal = noteValue !== "" ? noteValue : "";
      addingNote = noteVal !== "" ? true : false;
      let labelColor = e.currentTarget.selectedOptions[0].getAttribute("name");
      if (isPopoverOpenUpdate || isPopoverOpenProfessorUpdate) {
        updateChapterBrief(labelColor, noteVal, label);
      } else {
        saveBriefHighlights(labelColor, noteVal, label);
      }
    }
    setIsPopoverOpenUpdate(false);
    setIsPopoverOpenProfessorUpdate(false);
  };
  const selectText = (element) => {
    let doc = document;
    let text = doc.getElementById(element);
    if (doc.body.createTextRange) {
      let range = doc.body.createTextRange();
      range.moveToElementText(text);
      range.select();
    } else if (window.getSelection) {
      let selection = window.getSelection();
      let range = doc.createRange();
      range.selectNodeContents(text);
      if (!acrossParaLevelAnnotationFlag) selection.addRange(range);
    }
  };
  const repaintSelectedText = (listOfDummyNode) => {
    let doc = document;
    let text;
    for (let i = 0; i < listOfDummyNode.length; i++) {
      let range = doc.createRange();
      $(listOfDummyNode[i]).addClass("ereader-selection-text-color");
    }
  };
  const removeTags = (html) => {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent;
  };
  const getAllSelectedParaDetails = (
    node,
    selectedParaIds,
    paraIdDictonary,
    paraIDHTMLDictionary,
    paraOuterHTMLDictionary,
    wrapperDictionaryForSelecteedPara,
    parentWrapperElement,
    innerWrapperDictionaryForSelecteedPara,
    listChildItems,
    featureChildItems,
    newListItem,
    pageNumberElementDic,
  ) => {
    if (node !== null && node !== undefined) {
      let wrapperElement = parentWrapperElement;
      if (
        node.id !== null &&
        node.id.length > 0 &&
        node.className.indexOf("cc-wrapper") >= 0
      ) {
        if ($.inArray(node.id, selectedParaIds) == -1) {
          selectedParaIds.push(node.id);
          paraIdDictonary[node.id] = node.textContent;
          paraIDHTMLDictionary[node.id] = node.innerHTML;
          paraOuterHTMLDictionary[node.id] = node.outerHTML;
          wrapperDictionaryForSelecteedPara[node.id] = wrapperElement.outerHTML;
          innerWrapperDictionaryForSelecteedPara[node.id] =
            wrapperElement.outerHTML;
          if (
            listChildItems[node.id] !== null &&
            node.previousElementSibling !== null &&
            node.previousElementSibling.tagName !== undefined &&
            node.previousElementSibling.tagName.toLowerCase() !== "li"
          )
            newListItem[node.id] = wrapperElement.outerHTML;
        }
      } else {
        if (node.hasChildNodes()) {
          if (node.className.indexOf("cc-pagenum-begin") >= 0) {
            pageNumberElementDic[selectedParaIds[selectedParaIds.length - 1]] =
              node;
          }
          for (let i = 0; i < node.children.length; i++) {
            if (node.tagName.toLowerCase().indexOf("li") >= 0) {
              let tempChildItem = $(node).find(".cc-wrapper");
              for (let k = 0; k < tempChildItem.length; k++) {
                if (!(tempChildItem[k].id in listChildItems))
                  listChildItems[tempChildItem[k].id] = tempChildItem;
              }
            }
            if (node.className.indexOf("epub-feature") >= 0) {
              let tempChildItem = $(node).find(".cc-wrapper");
              for (let k = 0; k < tempChildItem.length; k++) {
                if (!(tempChildItem[k].id in featureChildItems))
                  featureChildItems[tempChildItem[k].id] = tempChildItem;
              }
            }
            if (
              node.children[i].className !== undefined &&
              node.children[i].className.length > 0 &&
              node.children[i].className.indexOf("cc-wrapper") >= 0
            ) {
              if (
                node.children[i].parentNode !== null &&
                node.children[i].parentNode !== undefined
              ) {
                let tempNode = node.children[i].parentNode;
                let tempParentNode = document.createElement(
                  node.children[i].parentNode.tagName,
                );

                tempParentNode.setAttribute(
                  "class",
                  node.children[i].parentNode.className,
                );

                while (tempNode.parentNode.className !== undefined) {
                  let finalNode = document.createElement(
                    tempNode.parentNode.tagName,
                  );
                  finalNode.setAttribute(
                    "class",
                    tempNode.parentNode.className,
                  );
                  finalNode.innerHTML = tempParentNode.outerHTML;
                  tempParentNode = finalNode;
                  tempNode = tempNode.parentNode;
                }

                wrapperElement = tempParentNode;
              } else {
                wrapperElement = parentWrapperElement;
              }
            } else {
              let numberOfChildWrapper = wrapperElement.children.length;
              let tempwrapperElement = document.createElement(
                node.children[i].tagName.toLowerCase(),
              );
              tempwrapperElement.setAttribute("class", node.className);

              if (numberOfChildWrapper !== null && numberOfChildWrapper > 0) {
                wrapperElement = setInnerHTML(
                  wrapperElement,
                  tempwrapperElement,
                );
              } else {
                wrapperElement.innerHTML = tempwrapperElement.outerHTML;
              }
            }

            if (wrapperElement) {
              wrapperElement.innerHTML = wrapperElement.innerHTML.replace(
                /(<br\s*\/?>\s*){2,}/gi,
                "<br>",
              );
            }
            if (node.children[i].className.indexOf("cc-pagenum-begin") >= 0) {
              pageNumberElementDic[
                selectedParaIds[selectedParaIds.length - 1]
              ] = node.children[i];
            }
            getAllSelectedParaDetails(
              node.children[i],
              selectedParaIds,
              paraIdDictonary,
              paraIDHTMLDictionary,
              paraOuterHTMLDictionary,
              wrapperDictionaryForSelecteedPara,
              wrapperElement,
              innerWrapperDictionaryForSelecteedPara,
              listChildItems,
              featureChildItems,
              newListItem,
              pageNumberElementDic,
            );
          }
        }
      }
    }
  };
  const setInnerHTML = (epubWrapper, enclosingPara) => {
    if (epubWrapper.children.length > 0) {
      setInnerHTML(epubWrapper.children[0], enclosingPara);
    } else epubWrapper.innerHTML = enclosingPara.outerHTML;
    return epubWrapper;
  };
  const saveBriefHighlights = (color, noteval, labelValue) => {
    if (color != null) {
      setIsBriefOpen(false);
      setSaveHighlightLoading(true);
      briefStartOffsetAtSectionLevel = highlightStartOffsetAtSectionLevel;
      briefEndOffsetAtSectionLevel = highlightEndOffsetAtSectionLevel;
      briefStartParaId = annotationStartParaId;
      briefEndParaId = annotationEndParaId;
      briefParaStartOffset = highlightStartOffset;
      briefParaEndOffset = highlightEndOffset;
      let briefNoteValue = noteval;
      let labelTextValue = labelValue;
      let briefStartOffsetVal = parseInt(
        document.getElementById(selectedNoteId).getAttribute("startOffset"),
      );
      let briefEndOffsetVal = parseInt(
        document.getElementById(selectedNoteId).getAttribute("endOffset"),
      );
      let briefColorSelected = color,
        annotationResponse1 = {};
      let reqData = {
        userVO: {
          userId: userId,
          userRole: userRole,
          userRoleId: userRoleId,
          userActivityVO: {
            lastReadSectionId: "",
            lastReadBookId: bookId,
            lastViewedOutlineId: "",
            pageNavigatingTo: "EReader",
            lastReadChapterId: chapterId,
            pageNavigatingFrom: "EReader",
            lastActivityCode: "BOOKSHELF",
            lastReadParagraphId: "para01",
            lastReadPageNum: lastReadPageNum,
            lastReadSubSectionId: "subsec01",
          },
          sessionVO: getSessionVO(),
        },
        briefVO: {
          bookId: bookId,
          chapterTitle: "",
          noteText: noteval,
          chapterId: chapterId,
          labelName: labelTextValue,
          pageNumber: lastReadPageNum,
          sectionId: annotationSectionId,
          highlightEndParaId: briefEndParaId,
          enclosingParaList: selectedParaIds,
          sectionTitle: annotationSectionTitle,
          highlightStartParaId: briefStartParaId,
          highlightText: highlightedTextWithoutHTML,
          highlightParaEndOffset: briefParaEndOffset,
          highlightParaStartOffset: briefParaStartOffset,
          highlightEndOffset: briefEndOffsetAtSectionLevel,
          highlightStartOffset: briefStartOffsetAtSectionLevel,
          highlightColorCode: briefColorSelected.toLowerCase(),
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      fetch(
        `${localStorage.getItem("ENV")}/manageCases/addChapterBriefHighlight`,
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "true") {
            addingBrief = false;
            pCaseWithHeadingCitation = false;
            pCaseWithHeadingOnly = false;
            addBriefPopoverShown = false;
            if (highLightSpanIdAcrossPara.length === 0) {
              let briefTag = document.getElementById(selectedNoteId);
              if (briefTag !== null) {
                briefSpanId = 0;
                let spanElement = document.createElement("briefsTag");
                spanElement.innerHTML = briefTag.innerHTML;
                spanElement.id = selectedNoteId;
                spanElement.className = "briefElementText";
                spanElement.setAttribute("data-references", "popover");
                spanElement.setAttribute("data-toggle", "popover");
                spanElement.setAttribute("tabindex", "0");
                spanElement.setAttribute("data-original-title", "");
                spanElement.setAttribute(
                  "briefStartOffset",
                  briefStartOffsetAtSectionLevel,
                );
                spanElement.setAttribute(
                  "briefEndOffset",
                  briefEndOffsetAtSectionLevel,
                );
                spanElement.setAttribute(
                  "briefParaStartOffset",
                  briefParaStartOffset,
                );
                spanElement.setAttribute(
                  "briefParaEndOffset",
                  briefParaEndOffset,
                );
                spanElement.setAttribute(
                  "enclosingParaIdString",
                  enclosingParaIdString,
                );
                spanElement.setAttribute("briefStartParaId", briefStartParaId);
                spanElement.setAttribute("briefEndParaId", briefEndParaId);
                spanElement.setAttribute("briefLabelName", labelTextValue);
                spanElement.setAttribute("briefNote", briefNoteValue);
                spanElement.setAttribute("sectionid", annotationSectionId);
                spanElement.setAttribute(
                  "sectiontitle",
                  annotationSectionTitle,
                );
                spanElement.addEventListener("click", function (e) {
                  briefTextClicked(e);
                });
                spanElement.normalize();
                briefTag.parentNode.replaceChild(spanElement, briefTag);
                if (briefColorSelected !== undefined) {
                  if (briefColorSelected.toLowerCase() === "underline") {
                    spanElement.setAttribute(
                      "style",
                      "text-decoration:underline !important",
                    );
                    spanElement.setAttribute("colorCodeId", "underLine");
                  } else {
                    spanElement.setAttribute(
                      "style",
                      "background-color:" + briefColorSelected + "!important",
                    );
                    spanElement.setAttribute("colorCodeId", briefColorSelected);
                  }
                }
              }
            } else if (highLightSpanIdAcrossPara.length > 0) {
              for (let r = 0; r < highLightSpanIdAcrossPara.length; r++) {
                selectedNoteId = "note" + r;
                let briefTag = document.getElementById(selectedNoteId);
                let spanElement = document.createElement("briefsTag");
                spanElement.innerHTML = briefTag.innerHTML;
                spanElement.id = selectedNoteId;
                spanElement.className = "briefElementText";
                spanElement.setAttribute("data-references", "popover");
                spanElement.setAttribute("data-toggle", "popover");
                spanElement.setAttribute("tabindex", "0");
                spanElement.setAttribute("data-original-title", "");
                spanElement.setAttribute(
                  "briefStartOffset",
                  briefStartOffsetAtSectionLevel,
                );
                spanElement.setAttribute(
                  "briefEndOffset",
                  briefEndOffsetAtSectionLevel,
                );
                spanElement.setAttribute(
                  "briefParaStartOffset",
                  briefParaStartOffset,
                );
                spanElement.setAttribute(
                  "briefParaEndOffset",
                  briefParaEndOffset,
                );
                spanElement.setAttribute(
                  "enclosingParaIdString",
                  enclosingParaIdString,
                );
                spanElement.setAttribute("briefStartParaId", briefStartParaId);
                spanElement.setAttribute("briefEndParaId", briefEndParaId);
                spanElement.setAttribute("briefLabelName", labelTextValue);
                spanElement.setAttribute("briefNote", briefNoteValue);
                spanElement.setAttribute("sectionid", annotationSectionId);
                spanElement.setAttribute(
                  "sectiontitle",
                  annotationSectionTitle,
                );
                spanElement.addEventListener("click", function (e) {
                  briefTextClicked(e);
                });
                spanElement.normalize();
                briefTag.parentNode.replaceChild(spanElement, briefTag);
                if (briefColorSelected !== undefined) {
                  if (briefColorSelected.toLowerCase() === "underline") {
                    spanElement.setAttribute(
                      "style",
                      "text-decoration:underline !important",
                    );
                    spanElement.setAttribute("colorCodeId", "underline");
                  } else {
                    spanElement.setAttribute(
                      "style",
                      "background-color:" + briefColorSelected + "!important",
                    );
                    spanElement.setAttribute("colorCodeId", briefColorSelected);
                  }
                }
              }
            } else {
              setIsPopoverOpen(false);
              setIsPopoverOpenProfessor(false);
            }
            if (data.briefVO) {
              annotationResponse1 = {
                annotationId: data.briefVO.annotationId,
                dppContentId: data.briefVO.annotationId,
                enclosingParaList: selectedParaIds,
                highlightColorCode: briefColorSelected,
                highlightEndOffset: "",
                highlightEndParaId: annotationEndParaId,
                highlightParaEndOffset: highlightEndOffset,
                highlightParaStartOffset: highlightStartOffset,
                highlightStartOffset: "",
                highlightStartParaId: annotationStartParaId,
                highlightText: highlightedTextWithoutHTML,
              };
              dppAnotationId = data.briefVO.annotationId;
              var reduxAnnotationVO = {
                bookId: bookId,
                chapterTitle: "",
                chapterId: chapterId,
                labelName: labelTextValue,
                pageNumber: lastReadPageNum,
                sectionId: annotationSectionId,
                enclosingParaList: selectedParaIds,
                highlightEndParaId: briefEndParaId,
                sectionTitle: annotationSectionTitle,
                highlightStartParaId: briefStartParaId,
                highlightText: highlightedTextWithoutHTML,
                highlightParaEndOffset: briefParaEndOffset,
                highlightParaStartOffset: briefParaStartOffset,
                highlightEndOffset: briefEndOffsetAtSectionLevel,
                highlightStartOffset: briefStartOffsetAtSectionLevel,
                highlightColorCode: briefColorSelected.toLowerCase(),
              };
              reduxAnnotationVO.annotationId = dppAnotationId;
              reduxAnnotationVO.annotationStatus = "added";
              reduxAnnotationVO.dppContentType = "brief";
              reqData.briefVO.annotationId = dppAnotationId;
              reqData.briefVO.dppContentType = "brief";
              reqData.briefVO.annotationStatus = "added";
              if (noteval && noteval.trim().length > 0)
                reduxAnnotationVO.noteText = noteval;
              else reqData.briefVO.noteText = null;
              addHighlightToRedux(reduxAnnotationVO);
              addBriefToRedux(reqData.briefVO);
              if (highLightSpanIdAcrossPara.length === 0) {
                highLightSpanId = 0;
                document.getElementById("note" + highLightSpanId).id =
                  dppAnotationId;
                let tempVarFordppAnotationId =
                  document.getElementById(dppAnotationId);
                tempVarFordppAnotationId.addEventListener(
                  "click",
                  function (e) {
                    briefTextClicked(e);
                  },
                );
                tempVarFordppAnotationId.setAttribute(
                  "startOffset",
                  briefStartOffsetVal,
                );
                tempVarFordppAnotationId.setAttribute(
                  "endOffset",
                  briefEndOffsetVal,
                );
              } else if (highLightSpanIdAcrossPara.length > 0) {
                for (let r = 0; r < highLightSpanIdAcrossPara.length; r++) {
                  if (r === 0) {
                    document.getElementById("note" + r).id = dppAnotationId;
                    let tempVarFordppAnotationId =
                      document.getElementById(dppAnotationId);
                    tempVarFordppAnotationId.addEventListener(
                      "click",
                      function (e) {
                        briefTextClicked(e);
                      },
                    );
                    tempVarFordppAnotationId.setAttribute(
                      "startOffset",
                      briefStartOffsetVal,
                    );
                    tempVarFordppAnotationId.setAttribute(
                      "endOffset",
                      briefEndOffsetVal,
                    );
                  } else {
                    document.getElementById("note" + r).id =
                      dppAnotationId + "_" + [r];
                    let tempVardppAnotationIdWithR = document.getElementById(
                      dppAnotationId + "_" + [r],
                    );
                    tempVardppAnotationIdWithR.setAttribute(
                      "startOffset",
                      briefStartOffsetVal,
                    );
                    tempVardppAnotationIdWithR.setAttribute(
                      "endOffset",
                      briefEndOffsetVal,
                    );
                  }
                }
                let enclosingString = "";
                if (selectedParaIds.length > 0) {
                  for (let k = 0; k < selectedParaIds.length; k++) {
                    if (k === selectedParaIds.length - 1)
                      enclosingString += selectedParaIds[k];
                    else enclosingString += selectedParaIds[k] + "|";
                  }
                }
                document
                  .getElementById(dppAnotationId)
                  .setAttribute("enclosingParaIdString", enclosingString);
              }
              selectedNoteId = dppAnotationId;
              insideAddBriefFunction = 0;
            }
            yValue = document
              .getElementById(selectedNoteId)
              .getBoundingClientRect().top;
            addingBrief = false;
            addBriefPopoverShown = false;
            if (addingNote) {
              localStorage.setItem("addBriefStartParaId", briefStartParaId);
              if (typeof ($("#" + briefStartParaId).next() !== "undefined")) {
                if (
                  $("#" + briefStartParaId)
                    .next()
                    .is("p")
                ) {
                  localStorage.setItem(
                    "addBriefNextParaId",
                    $("#" + briefStartParaId)
                      .next()
                      .attr("id"),
                  );
                }
              }
              briefNoteValue = noteval;
              displayBriefOnRight(
                selectedNoteId,
                briefColorSelected,
                yValue,
                labelTextValue,
                briefNoteValue,
              );
              setTimeout(() => {}, 800);
            }
            setIsPopoverOpen(false);
            setIsPopoverOpenProfessor(false);
            setSaveHighlightLoading(false);
            if (globalChapterBriefList === "") {
              globalChapterBriefList = [];
              globalChapterBriefList.push(annotationResponse1);
            } else {
              globalChapterBriefList = [
                ...globalChapterBriefList,
                annotationResponse1,
              ];
            }
          } else if (data.wkErrorCode) {
            handleException(data);
          }
          addHighlightChangeMsg(color);
        })
        .catch((error) => {
          setSaveHighlightLoading(true);
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const displayBriefOnRight = (
    briefId,
    briefColor,
    topValue,
    labelText,
    briefNote,
  ) => {
    if (labelText != null && labelText != undefined && labelText != "") {
      labelText = labelText.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    if ($("#briefAnchorElement" + briefId)) {
      $("#briefAnchorElement" + briefId).remove();
    }
    let lineHeight = $(".ereader-content").css("line-height");
    let containerTop = document
      .getElementById("notes-container")
      .getBoundingClientRect().top;
    let clickableAnchorElement = document.createElement("A");
    clickableAnchorElement.id = "briefAnchorElement" + briefId;
    clickableAnchorElement.setAttribute("labelName", labelText);
    clickableAnchorElement.setAttribute("briefNote", briefNote);
    clickableAnchorElement.style.color = "#333333";
    let bLabelText = document.createElement("div");
    bLabelText.id = "labelDiv" + briefId;
    bLabelText.className = "labelText  ellipsis";
    bLabelText.style.width = $("#notes-container").width() + "px";
    bLabelText.style.top = topValue - containerTop - 2 + "px";
    bLabelText.innerHTML = labelText;
    bLabelText.setAttribute("labelName", labelText);
    bLabelText.setAttribute("briefNote", briefNote);
    bLabelText.title = labelText;
    let bNotesText = document.createElement("div");
    bNotesText.id = "notesDiv" + briefId;
    bNotesText.innerHTML = briefNote;
    bNotesText.setAttribute("labelName", labelText);
    bNotesText.setAttribute("briefNote", briefNote);
    bNotesText.title = briefNote;
    if (bLabelText) {
      bNotesText.style.top = bLabelText.style.top + parseInt(lineHeight) + "px";
    } else {
      bNotesText.style.top = topValue - containerTop - 2 + "px";
    }
    let labelNoteWrapper = document.createElement("div");
    labelNoteWrapper.id = "briefWrapDiv" + briefId;
    labelNoteWrapper.className = "labelNoteWrapper overlapCheckClass";
    labelNoteWrapper.className = "labelNoteWrapper overlapCheckClass";
    labelNoteWrapper.setAttribute("labelName", labelText);
    labelNoteWrapper.setAttribute("briefNote", briefNote);
    labelNoteWrapper.style.top = topValue - containerTop - 2 + "px";
    labelNoteWrapper.appendChild(bLabelText);
    labelNoteWrapper.appendChild(bNotesText);
    let briefNColor = document.createElement("div");
    briefNColor.innerHTML = briefNote;
    briefNColor.title = briefNote;
    briefNColor.id = "colSpan" + briefId;
    briefNColor.setAttribute(
      "style",
      " top:" + (topValue - containerTop) + "px" + ";",
    );
    briefNColor.style.top = labelNoteWrapper.style.top;
    if (
      (briefNote.length > 40 && briefNote.split(" ").length < 5) ||
      (briefNote.length > 40 && briefNote.split(" ")[0].length > 20) ||
      (briefNote.length > 25 && briefNote.split(" ")[0].length > 20)
    ) {
      briefNColor.className = "briefNotesText  ellipsis";
      briefNColor.style.width = "150px";
    } else {
      briefNColor.className = "briefNotesText";
    }
    let iconOverValueB = 15;
    let minimizeNoteBookLinkFlag2 = document
      .querySelector(".expandNoteBookLink")
      .getAttribute("aria-expanded");
    if (minimizeNoteBookLinkFlag2 === "true") {
      briefNColor.style.display = "none";
    } else if (minimizeNoteBookLinkFlag2 === "false") {
      briefNColor.style.display = "block";
    }
    let screenMode2 = localStorage.getItem("screenMode");
    if (screenMode2 === "split") {
      iconOverValueB = 20;
    } else if (screenMode2 === "expand") {
      iconOverValueB = 5;
    }
    let countOfBriefInChapter = 300;
    countOfBriefInChapter =
      localStorage.getItem("briefAnnotationListForChapter") !== null
        ? localStorage.getItem("briefAnnotationListForChapter").split(",")
            .length
        : 1000;
    timeCount =
      countOfBriefInChapter < 50
        ? 1
        : countOfBriefInChapter > 50 && countOfBriefInChapter <= 150
          ? 800
          : 1000;
    setTimeout(() => {
      let allBrief = $(".briefNotesText");
      if (typeof allBrief !== "undefined") {
        if (allBrief.length > 0) {
          allBrief.sort(function (a, b) {
            if (parseInt(a.style.top) > parseInt(b.style.top)) return 1;
            if (parseInt(a.style.top) < parseInt(b.style.top)) return -1;
            return 0;
          });
        }
      }
      let i;
      let lastBriefTopValue = 0;
      let lastBriefHeight = 0;
      let IconTopValueB = topValue - containerTop + "px";
      setTimeout(() => {
        for (i = 0; i < allBrief.length; i++) {
          lastBriefHeight = allBrief[i].offsetHeight + iconOverValueB;
          if (
            parseInt(allBrief[i].style.top) ==
            parseInt(labelNoteWrapper.style.top)
          ) {
            lastBriefTopValue = parseInt(allBrief[i].style.top);
            labelNoteWrapper.style.top =
              parseInt(allBrief[i].style.top) - 2 + lastBriefHeight + "px";
            briefNColor.style.top =
              parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
            clickableAnchorElement.top =
              parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
            IconTopValueB =
              parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
            document.querySelector(
              "#" + clickableAnchorElement.id + " .notesIcon",
            ).style.top = IconTopValueB;
            clickableAnchorElement.top =
              parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
          } else if (
            parseInt(allBrief[i].style.top) <
              parseInt(labelNoteWrapper.style.top) + lastBriefHeight &&
            parseInt(allBrief[i].style.top) >
              parseInt(labelNoteWrapper.style.top) - lastBriefHeight
          ) {
            if (parseInt(allBrief[i].style.top) > lastBriefTopValue) {
              lastBriefTopValue = parseInt(allBrief[i].style.top);
              labelNoteWrapper.style.top =
                parseInt(allBrief[i].style.top) - 2 + lastBriefHeight + "px";
              briefNColor.style.top =
                parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
              IconTopValueB =
                parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
              document.querySelector(
                "#" + clickableAnchorElement.id + " .notesIcon",
              ).style.top = IconTopValueB;
              clickableAnchorElement.top =
                parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
            }
          }
        }
      }, timeCount);
      document
        .getElementById("notes-container")
        .appendChild(clickableAnchorElement);
      ReactDOM.render(
        <i
          className="far fa-file-alt notesIcon"
          style={{ top: IconTopValueB }}
        />,
        document.getElementById(clickableAnchorElement.id),
      );
      clickableAnchorElement.appendChild(briefNColor);
      document
        .getElementById(clickableAnchorElement.id)
        .addEventListener("click", function (e) {
          briefNoteTextClicked(e);
        });
      if (document.getElementById("briefWrapDiv" + briefId) !== null) {
        let currentAnnotationRect = document
          .getElementById("briefWrapDiv" + briefId)
          .getBoundingClientRect();
        let fetchedAnnotationRect = null;
        lastBriefHeight = 0;
        let elemToClamp = null;
        for (i = 0; i < allBrief.length; i++) {
          lastBriefHeight = allBrief[i].offsetHeight + 5;
          elemToClamp = "notesDiv" + allBrief[i].id.slice(12);
          fetchedAnnotationRect = document
            .getElementById(allBrief[i].id)
            .getBoundingClientRect();
          if (
            !(
              currentAnnotationRect.right < fetchedAnnotationRect.left ||
              currentAnnotationRect.left > fetchedAnnotationRect.right ||
              currentAnnotationRect.bottom < fetchedAnnotationRect.top ||
              currentAnnotationRect.top > fetchedAnnotationRect.bottom
            )
          ) {
            if (
              parseInt(lastBriefHeight) >=
              parseInt($("#" + allBrief[i].id).css("line-height"))
            ) {
              document.getElementById(elemToClamp).style.width =
                $("#notes-container").width() + "px";
              document.getElementById(elemToClamp).className =
                "briefNotesText  ellipsis";
            }
          }
        }
        if (
          typeof localStorage.getItem("addBriefStartParaId") !== "undefined" &&
          localStorage.getItem("addBriefStartParaId") !== "" &&
          localStorage.getItem("addBriefStartParaId") !== null
        ) {
          let currentAnnotStartPara = localStorage.getItem(
            "addBriefStartParaId",
          );
          localStorage.setItem("addBriefStartParaId", "");
          if (currentAnnotStartPara !== "") {
            let currentAnnotParaHasHighlight = $(
              "#" + currentAnnotStartPara,
            ).find("briefstag");
            let firstHighlightId = "";
            let firstHighlightPosition = 0;
            let currentNotePosition = 0;
            let currentNoteHeight = 0;
            let currentNoteTotalSpace = 0;
            let clampVal = 1;
            let noteLineHeight = parseInt(
              $("#notesDiv" + briefId).css("line-height"),
            );
            if (currentAnnotParaHasHighlight.length > 1) {
              for (let i = 1; i < currentAnnotParaHasHighlight.length; i++) {
                if (currentAnnotParaHasHighlight[i].id.indexOf("_") === -1) {
                  firstHighlightId = currentAnnotParaHasHighlight[i].id;
                  break;
                }
              }
              if (
                firstHighlightId !== "" &&
                typeof ($("#" + firstHighlightId) !== "undefined")
              ) {
                if (
                  typeof ($("#" + firstHighlightId).offset() !== "undefined")
                ) {
                  firstHighlightPosition = $("#" + firstHighlightId).offset()
                    .top;
                  currentNotePosition = $("#" + briefId).offset().top;
                  currentNoteHeight = $("#briefWrapDiv" + briefId).height();
                  currentNoteTotalSpace =
                    currentNotePosition + currentNoteHeight;
                  if (currentNoteTotalSpace > firstHighlightPosition) {
                    if (
                      parseInt($("#" + briefId).attr("startOffset")) <
                      parseInt($("#" + firstHighlightId).attr("startOffset"))
                    ) {
                      if (
                        firstHighlightPosition - currentNotePosition >
                        2 * noteLineHeight
                      ) {
                        clampVal = 1;
                      } else if (
                        firstHighlightPosition - currentNotePosition >
                        noteLineHeight
                      ) {
                        clampVal = 1;
                      }
                      if ($("#notesDiv" + briefId).html().length > 10) {
                      }
                    }
                    localStorage.setItem("addBriefStartParaId", "");
                  }
                }
              }
            } else {
              localStorage.setItem("addBriefStartParaId", "");
              if (
                typeof localStorage.getItem("addBriefNextParaId") !==
                  "undefined" &&
                localStorage.getItem("addBriefNextParaId") !== "" &&
                localStorage.getItem("addBriefNextParaId") !== null
              ) {
                let currentAnnotStartPara =
                  localStorage.getItem("addBriefNextParaId");
                localStorage.setItem("addBriefNextParaId", "");
                if (currentAnnotStartPara !== "") {
                  let currentAnnotParaHasHighlight = $(
                    "#" + currentAnnotStartPara,
                  ).find("briefstag");
                  let firstHighlightId = "";
                  let firstHighlightPosition = 0;
                  let currentNotePosition = 0;
                  let currentNoteHeight = 0;
                  let currentNoteTotalSpace = 0;
                  let clampVal = 1;
                  let noteLineHeight = parseInt(
                    $("#notesDiv" + briefId).css("line-height"),
                  );
                  if (currentAnnotParaHasHighlight.length > 0) {
                    for (
                      let i = 0;
                      i < currentAnnotParaHasHighlight.length;
                      i++
                    ) {
                      if (
                        currentAnnotParaHasHighlight[i].id.indexOf("_") === -1
                      ) {
                        firstHighlightId = currentAnnotParaHasHighlight[i].id;
                        break;
                      }
                    }
                    if (typeof ($("#" + firstHighlightId) !== "undefined")) {
                      if (
                        typeof (
                          $("#" + firstHighlightId).offset() !== "undefined"
                        )
                      ) {
                        firstHighlightPosition = $(
                          "#" + firstHighlightId,
                        ).offset().top;
                        currentNotePosition = $("#" + briefId).offset().top;
                        currentNoteHeight = $(
                          "#briefWrapDiv" + briefId,
                        ).height();
                        currentNoteTotalSpace =
                          currentNotePosition + currentNoteHeight;
                        if (currentNoteTotalSpace > firstHighlightPosition) {
                          if (
                            firstHighlightPosition - currentNotePosition >
                            2 * noteLineHeight
                          ) {
                            clampVal = 2;
                          } else if (
                            firstHighlightPosition - currentNotePosition >
                            noteLineHeight
                          ) {
                            clampVal = 1;
                          }
                          if ($("#notesDiv" + briefId).html().length > 10) {
                          }
                          localStorage.setItem("addBriefNextParaId", "");
                        }
                        if ($("#notesDiv" + briefId).html().length > 10) {
                        }
                        localStorage.setItem("addBriefNextParaId", "");
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }, timeCount);
    addingBrief = false;
    setTimeout(() => {}, 2000);
  };
  const handleClickAwayFromPopover = () => {
    if (isBriefOpen) {
      setIsBriefOpen(false);
    } else {
      let noteVal = noteValue,
        labelValue;
      addingNote = noteVal !== "" ? true : false;
      if (addingNote) {
        if (casePopOver) {
          labelValue = document
            .getElementById("viewingInput_Labels")
            .value.replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
        }
        casePopOver
          ? saveBriefHighlights("#EDE48C", noteVal, labelValue)
          : saveHighlights("#EDE48C", noteVal);
      } else if (!outlineOnly) {
        let listOfDummyNode = $('highlight[id^="note"]');
        for (let k = 0; k < listOfDummyNode.length; k++) {
          let highlightSpanTag = document.getElementById(listOfDummyNode[k].id);
          let spanElement = document.createElement("span");
          spanElement.innerHTML = highlightSpanTag.innerHTML;
          spanElement.normalize();
          var parent = highlightSpanTag.parentNode;
          while (highlightSpanTag.firstChild)
            parent.insertBefore(highlightSpanTag.firstChild, highlightSpanTag);
          parent.removeChild(highlightSpanTag);
        }
      }
      setIsPopoverOpen(false);
      setIsCopyOnlyPopoverOpen(false);
    }
  };
  const highLightedTextClick = (e) => {
    setCasePopOverUpdate(false);
    setCopiedText("");
    setStudLinkFlag(false);
    setLinkDesStud(false);
    setStudlink("");
    noteIsEmpty = false;
    updateLinkFlagStud = false;
    updateLinkFlag = false;
    if (typeof e === "string") {
      selectedNoteIdUpdate = e;
    } else {
      let selectedId = e.currentTarget.id;
      let selection,
        selectedNoteIdWithIndexer = "";
      if (window.getSelection) selection = window.getSelection();
      else if (typeof document.selection !== "undefined")
        selection = document.selection;
      copySelectedText = selection.toString();
      bodyRect = document.body.getBoundingClientRect();
      let selectionElement = selection.anchorNode;
      selectedNoteIdUpdate = e.currentTarget.getAttribute("hid");
    }
    let existingNoteValue = document.getElementById(selectedNoteIdUpdate)
      ? document.getElementById(selectedNoteIdUpdate).getAttribute("noteText")
        ? document
            .getElementById(selectedNoteIdUpdate)
            .getAttribute("noteText")
            .trim()
        : ""
      : "";
    if (existingNoteValue === "" || existingNoteValue === null) {
      noteIsEmpty = true;
      setNoteValueUpdate("");
    }
    if (userVO.userRole === "Professor") {
      setAnchorElUpdate(document.getElementById(selectedNoteIdUpdate));
      setIsPopoverOpenProfessorUpdate(true);
      setShowLink(false);
    } else {
      setAnchorElUpdate(document.getElementById(selectedNoteIdUpdate));
      setIsPopoverOpenUpdate(true);
    }
    setPlacementUpdate("bottom");
    setNoteValueUpdate(existingNoteValue);
    if (
      selectedNoteIdUpdate !== undefined &&
      selectedNoteIdUpdate !== null &&
      selectedNoteIdUpdate !== ""
    ) {
      if (globalChapterAnnotationList) {
        highlightedTextWithoutHTML = "";
        let textContentWithoutHTMLTags = "";
        for (let p = 0; p < globalChapterAnnotationList.length; p++) {
          if (
            selectedNoteIdUpdate === globalChapterAnnotationList[p].annotationId
          ) {
            textContentWithoutHTMLTags =
              globalChapterAnnotationList[p].highlightText;
            highlightedTextWithoutHTML = textContentWithoutHTMLTags;
            if (textContentWithoutHTMLTags !== "") {
              copySelectedText = highlightedTextWithoutHTML.toString();
            }
            break;
          }
        }
      }
      let removeCloseIcon = document.querySelectorAll(
        ".color-pallete .colorButton",
      );
      for (let i = 0; i < removeCloseIcon.length; i++) {
        ReactDOM.unmountComponentAtNode(
          document.getElementById(removeCloseIcon[i].id),
        );
      }
      setHighlightQuickUnderLine(false);
      selectedColor = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("colorCodeId");
      if (
        selectedColor !== undefined &&
        selectedColor !== null &&
        selectedColor !== ""
      ) {
        if (
          document.querySelector(
            "button[colorcode='" + selectedColor.toUpperCase() + "']",
          ) !== null
        ) {
          if (selectedColor.toLowerCase() === "underline") {
            setHighlightQuickUnderLine(true);
          } else {
            let selectedColorId = document.querySelector(
              "button[colorcode='" + selectedColor.toUpperCase() + "']",
            ).id;
            ReactDOM.render(
              <GrFormClose className="selected-icon" />,
              document.getElementById(selectedColorId),
            );
            if (selectedColorId === "color-yellow") {
              setColorYellow(true);
            } else if (selectedColorId === "color-green") {
              setColorGreen(true);
            } else if (selectedColorId === "color-blue") {
              setColorBlue(true);
            } else if (selectedColorId === "color-pink") {
              setColorPink(true);
            } else if (selectedColorId === "color-orange") {
              setColorOrange(true);
            } else if (selectedColorId === "color-purple") {
              setColorPurple(true);
            } else if (selectedColorId === "color-cyan") {
              setColorCyan(true);
            } else if (selectedColorId === "color-lightNavy") {
              setColorLightNavy(true);
            } else if (selectedColorId === "color-lightCoral") {
              setColorLightCoral(true);
            } else if (selectedColorId === "color-sandrift") {
              setColorSandrift(true);
            } else if (selectedColorId === "color-gainsboro") {
              setColorGainsboro(true);
            }
          }
        }
      }
    }
  };
  React.useImperativeHandle(ref, () => ({
    highLightedTextClick,
    briefTextClicked,
    linkTextClick,
    displayNotesOnRight,
    displayBriefOnRight,
    displayLinksOnLeft,
  }));
  const colorBtnPressedUpdate = (e, newColor) => {
    if (updateLinkFlagStud !== true) {
      let removeCloseIcon = document.querySelectorAll(
        ".color-pallete .colorButton",
      );
      for (let i = 0; i < removeCloseIcon.length; i++) {
        ReactDOM.unmountComponentAtNode(
          document.getElementById(removeCloseIcon[i].id),
        );
      }
      setHighlightQuickUnderLine(false);
      colorCodeId = e.currentTarget.id;
      let addCloseIcon = document.getElementById(e.currentTarget.id);
      e.currentTarget.id === "underLine"
        ? setHighlightQuickUnderLine(true)
        : ReactDOM.render(
            <GrFormClose className="selected-icon" />,
            addCloseIcon,
          );
      let noteVal = noteValueUpdate;
      addingNote = noteVal !== "" ? true : false;
      if (casePopOverUpdate) {
        let labelValue = "";
        let exists = false;
        if (!exists) {
          updateChapterBrief(newColor, noteVal, labelValue);
          setIsPopoverOpenUpdate(false);
          setIsPopoverOpenProfessorUpdate(false);
        } else {
          labelColor = newColor;
          briefNote = noteVal;
          setIsBriefOpen(true);
        }
      } else {
        if (userVO.userRole === "Professor") {
          if (updateLinkFlag === true) {
            updateLink(newColor);
          } else {
            updateHighlights(newColor, selectedColor, noteVal);
          }
          setIsPopoverOpenProfessorUpdate(false);
        } else {
          let existingColor = selectedColor;
          updateHighlights(newColor, existingColor, noteVal);
          setIsPopoverOpenUpdate(false);
        }
      }
    } else {
      setIsPopoverOpenUpdate(false);
    }
    updateLinkFlagStud = false;
  };
  const handleClickAwayFromPopoverUpdate = () => {
    if (updateLinkFlagStud !== true) {
      if (isBriefOpen) {
        setIsBriefOpen(false);
      } else {
        let noteVal = noteValueUpdate;
        let updatedNoteText = noteValueUpdate.trim().length;
        if (casePopOverUpdate) {
          if (existingNoteValueBrief.trim() !== noteVal.trim()) {
            if (
              (noteIsEmpty === true && updatedNoteText > 0) ||
              (noteIsEmpty === false && updatedNoteText === 0) ||
              (noteIsEmpty === false && updatedNoteText > 0)
            ) {
              updateChapterBrief(
                document
                  .getElementById(selectedNoteIdUpdate1)
                  .getAttribute("colorcodeid"),
                noteVal,
              );
            } else {
              setIsPopoverOpenUpdate(false);
              setCasePopOverUpdate(false);
            }
          } else {
            setIsPopoverOpenUpdate(false);
            setCasePopOverUpdate(false);
          }
        } else {
          if (noteIsEmpty === true && updatedNoteText > 0) {
            addChapterNote(noteValueUpdate);
          } else if (
            noteIsEmpty === false &&
            isNoteUpdated === true &&
            updatedNoteText !== 0
          ) {
            updateChapterNote();
            setIsNoteUpdated(false);
          } else if (noteIsEmpty === false && updatedNoteText === 0) {
            deleteChapterNote();
          } else {
            setIsPopoverOpenUpdate(false);
          }
        }
      }
    } else {
      setIsPopoverOpenUpdate(false);
    }
    updateLinkFlagStud = true;
  };
  const updateHighlights = (newColor, existingColor, noteVal) => {
    if (existingColor !== newColor) {
      setLoading(true);
      highlightStartOffset = parseInt(
        document
          .getElementById(selectedNoteIdUpdate)
          .getAttribute("highlightparastartoffset"),
      );
      highlightEndOffset = parseInt(
        document
          .getElementById(selectedNoteIdUpdate)
          .getAttribute("highlightparaendoffset"),
      );
      highlightStartOffsetAtSectionLevel = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("startoffset");
      highlightEndOffsetAtSectionLevel = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("endoffset");
      annotationStartParaId = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("highlightstartparaid");
      annotationEndParaId = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("highlightendparaid");
      annotationSectionId = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("sectionid");
      annotationSectionTitle = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("sectiontitle");
      let encParaString = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("enclosingparaidstring");
      let encParaIdArray = [];
      encParaIdArray =
        convertEnclosingParaStringIdToEnclosingParaArray(encParaString);
      let relatedHighLightTags = $(
        "highlight[id^=" + selectedNoteIdUpdate + "]",
      );
      let withSpanCount = 0,
        withoutSpanCount = 0;
      if (globalChapterAnnotationList) {
        let textContentWithoutHTMLTags = "";
        for (let p = 0; p < globalChapterAnnotationList.length; p++) {
          if (
            selectedNoteIdUpdate === globalChapterAnnotationList[p].annotationId
          ) {
            textContentWithoutHTMLTags =
              globalChapterAnnotationList[p].highlightText;
            highlightedTextWithoutHTML = textContentWithoutHTMLTags;
            break;
          }
        }
      }
      let actualSelectedNoteId = selectedNoteIdUpdate;
      if (selectedNoteIdUpdate.indexOf("_") !== -1)
        actualSelectedNoteId = selectedNoteIdUpdate.substring(
          0,
          selectedNoteIdUpdate.indexOf("_"),
        );
      selectedParaIds = encParaIdArray;
      let reqData = {
        userVO: {
          userId: userId,
          userRole: userRole,
          userRoleId: userRoleId,
          userActivityVO: {
            lastReadSectionId: "",
            lastReadBookId: bookId,
            lastViewedOutlineId: "",
            pageNavigatingTo: "EReader",
            lastReadChapterId: chapterId,
            lastReadParagraphId: "para01",
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "EReader",
            lastReadPageNum: lastReadPageNum,
            lastReadSubSectionId: "subsec01",
          },
          sessionVO: getSessionVO(),
        },
        annotationVO: {
          bookId: bookId,
          chapterId: chapterId,
          chapterTitle: chapterTitle,
          pageNumber: lastReadPageNum,
          highlightColorCode: newColor,
          sectionId: annotationSectionId,
          enclosingParaList: encParaIdArray,
          annotationId: actualSelectedNoteId,
          sectionTitle: annotationSectionTitle,
          highlightEndParaId: annotationEndParaId,
          highlightText: highlightedTextWithoutHTML,
          highlightParaEndOffset: highlightEndOffset,
          highlightStartParaId: annotationStartParaId,
          highlightParaStartOffset: highlightStartOffset,
          highlightEndOffset: highlightEndOffsetAtSectionLevel,
          highlightStartOffset: highlightStartOffsetAtSectionLevel,
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      fetch(
        `${localStorage.getItem("ENV")}/manageAnnotationService/updateChapterHighlights`,
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "true") {
            if (typeof data.sessionAuthenticationToken != "undefined") {
              localStorage.setItem(
                "sessionAuthenticationToken",
                data.sessionAuthenticationToken,
              );
            }
            let highLightColor = newColor;
            let relatedHighLightTagsToRepaint = $(
              "highlight[id^=" + selectedNoteIdUpdate + "]",
            );
            for (let j = 0; j < relatedHighLightTagsToRepaint.length; j++) {
              if (highLightColor !== undefined) {
                if (highLightColor.toLowerCase() === "underline") {
                  $("highlight#" + relatedHighLightTagsToRepaint[j].id).attr(
                    "style",
                    "text-decoration: underline !important;",
                  );
                  $("highlight#" + relatedHighLightTagsToRepaint[j].id).attr(
                    "colorCodeId",
                    "underline",
                  );
                } else {
                  $("highlight#" + relatedHighLightTagsToRepaint[j].id).attr(
                    "style",
                    "background-color:" + highLightColor + " !important;",
                  );
                  $("highlight#" + relatedHighLightTagsToRepaint[j].id).attr(
                    "colorCodeId",
                    highLightColor,
                  );
                }
              }
            }
            selectedHighlightColor = highLightColor;
            let updatedNoteText = noteValueUpdate.trim().length;
            reqData.annotationVO.annotationStatus = "updated";
            reqData.annotationVO.dppContentType = "annotation";
            if (updatedNoteText > 0) reqData.annotationVO.noteText = noteValue;
            addHighlightToRedux(reqData.annotationVO);
            if (noteIsEmpty === true && updatedNoteText > 0) {
              addChapterNote(noteValueUpdate);
            } else if (
              noteIsEmpty === false &&
              isNoteUpdated === true &&
              updatedNoteText !== 0
            ) {
              updateChapterNote();
              setIsNoteUpdated(false);
            } else if (noteIsEmpty === false && updatedNoteText === 0) {
              deleteChapterNote();
            }
          } else if (data.wkErrorCode) {
            handleException(data);
          }
          setIsPopoverOpenUpdate(false);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const convertEnclosingParaStringIdToEnclosingParaArray = (
    enclosingString,
  ) => {
    let enclosingIds = [];
    if (enclosingString.length > 0) {
      while (enclosingString.length > 0) {
        if (enclosingString.indexOf("|") !== -1) {
          enclosingIds.push(
            enclosingString.substring(0, enclosingString.indexOf("|")),
          );
          enclosingString = enclosingString.substring(
            enclosingString.indexOf("|") + 1,
          );
        } else {
          enclosingIds.push(enclosingString);
          enclosingString = "";
        }
      }
    } else enclosingIds.push(annotationStartParaId);
    return enclosingIds;
  };
  const updateChapterNote = () => {
    setLoading(true);
    highlightStartOffset = parseInt(
      document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("highlightparastartoffset"),
    );
    highlightEndOffset = parseInt(
      document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("highlightparaendoffset"),
    );
    highlightStartOffsetAtSectionLevel = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("startoffset");
    highlightEndOffsetAtSectionLevel = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("endoffset");
    annotationStartParaId = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("highlightstartparaid");
    annotationEndParaId = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("highlightendparaid");
    annotationSectionId = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("sectionid");
    annotationSectionTitle = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("sectiontitle");
    let enclosingString = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("enclosingparaidstring");
    let enclosingIds = [];
    if (enclosingString.length > 0) {
      while (enclosingString.length > 0) {
        if (enclosingString.indexOf("|") !== -1) {
          enclosingIds.push(
            enclosingString.substring(0, enclosingString.indexOf("|")),
          );
          enclosingString = enclosingString.substring(
            enclosingString.indexOf("|") + 1,
          );
        } else {
          enclosingIds.push(enclosingString);
          enclosingString = "";
        }
      }
    } else enclosingIds.push(annotationStartParaId);
    let actualSelectedNoteId = selectedNoteIdUpdate;
    if (selectedNoteIdUpdate.indexOf("_") !== -1)
      actualSelectedNoteId = selectedNoteIdUpdate.substring(
        0,
        selectedNoteIdUpdate.indexOf("_"),
      );
    let modifiedNoteText = noteValueUpdate;
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadBookId: bookId,
          lastReadSectionId: "",
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadParagraphId: "para01",
          lastReadPageNum: lastReadPageNum,
          lastReadSubSectionId: "subsec01",
        },
        sessionVO: getSessionVO(),
      },
      annotationVO: {
        bookId: bookId,
        chapterId: chapterId,
        chapterTitle: chapterTitle,
        noteText: modifiedNoteText,
        pageNumber: lastReadPageNum,
        sectionId: annotationSectionId,
        enclosingParaList: enclosingIds,
        annotationId: actualSelectedNoteId,
        sectionTitle: annotationSectionTitle,
        highlightEndParaId: annotationEndParaId,
        highlightParaEndOffset: highlightEndOffset,
        highlightStartParaId: annotationStartParaId,
        highlightParaStartOffset: highlightStartOffset,
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/updateChapterNote`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          reqData.annotationVO.annotationStatus = "updatedNote";
          reqData.annotationVO.dppContentType = "annotation";
          reqData.annotationVO.noteText = modifiedNoteText;
          addHighlightToRedux(reqData.annotationVO);
          yValue = document
            .getElementById(selectedNoteIdUpdate)
            .getBoundingClientRect().top;
          const noteElements = document.querySelectorAll(
            `[hid="${actualSelectedNoteId}"]`,
          );
          noteElements.forEach((noteElement) => {
            noteElement.setAttribute("noteText", modifiedNoteText);
          });
          let selectedHighlightColor = "";
          let notesTextClassElements = $(".notesText");
          for (let i = 0; i < notesTextClassElements.length; i++) {
            if (
              notesTextClassElements[i].id.substring(
                8,
                notesTextClassElements[i].id.length,
              ) === selectedNoteIdUpdate
            ) {
              notesTextClassElements[i].parentNode.removeChild(
                notesTextClassElements[i],
              );
              break;
            }
          }
          let notesSpanBlockClassElements = $(".notesSpanBlock");
          for (let i = 0; i < notesSpanBlockClassElements.length; i++) {
            if (notesSpanBlockClassElements[i].id === selectedNoteIdUpdate) {
              notesSpanBlockClassElements[i].parentNode.removeChild(
                notesSpanBlockClassElements[i],
              );
              break;
            }
          }
          updatingNote = false;
          localStorage.setItem("addNoteStartParaId", annotationStartParaId);
          if (typeof ($("#" + annotationStartParaId).next() !== "undefined")) {
            if (
              $("#" + annotationStartParaId)
                .next()
                .is("p")
            ) {
              localStorage.setItem(
                "addNoteNextParaId",
                $("#" + annotationStartParaId)
                  .next()
                  .attr("id"),
              );
            }
          }
          displayNotesOnRight(
            modifiedNoteText,
            selectedNoteIdUpdate,
            yValue,
            selectedHighlightColor,
            false,
          );
          setTimeout(function () {}, 800);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        setIsPopoverOpenUpdate(false);
        setLoading(false);
      })
      .catch((error) => {
        setIsPopoverOpenUpdate(false);
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const deleteChapterNote = () => {
    setLoading(true);
    highlightStartOffset = parseInt(
      document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("highlightparastartoffset"),
    );
    highlightEndOffset = parseInt(
      document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("highlightparaendoffset"),
    );
    let enclosingIds = [];
    let enclosingString = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("enclosingParaIdString");
    let startParaId = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("highlightStartParaId");
    let endParaId = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("highlightEndParaId");
    annotationSectionId = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("sectionid");
    annotationSectionTitle = document
      .getElementById(selectedNoteIdUpdate)
      .getAttribute("sectiontitle");
    if (enclosingString.length > 0) {
      while (enclosingString.length > 0) {
        if (enclosingString.indexOf("|") !== -1) {
          enclosingIds.push(
            enclosingString.substring(0, enclosingString.indexOf("|")),
          );
          enclosingString = enclosingString.substring(
            enclosingString.indexOf("|") + 1,
          );
        } else {
          enclosingIds.push(enclosingString);
          enclosingString = "";
        }
      }
    } else enclosingIds.push(startParaId);
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastReadBookId: bookId,
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastReadParagraphId: "para01",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadPageNum: lastReadPageNum,
          lastReadSubSectionId: "subsec01",
        },
        sessionVO: getSessionVO(),
      },
      annotationVO: {
        bookId: bookId,
        chapterId: chapterId,
        chapterTitle: chapterTitle,
        highlightEndParaId: endParaId,
        sectionId: annotationSectionId,
        enclosingParaList: enclosingIds,
        highlightStartParaId: startParaId,
        annotationId: selectedNoteIdUpdate,
        sectionTitle: annotationSectionTitle,
        highlightParaEndOffset: highlightEndOffset,
        highlightParaStartOffset: highlightStartOffset,
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/deleteChapterNote`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          document
            .getElementById(selectedNoteIdUpdate)
            .setAttribute("noteText", " ");
          let notesTextClassElements =
            document.getElementsByClassName("notesText");
          for (let i = 0; i < notesTextClassElements.length; i++) {
            if (
              notesTextClassElements[i].id.substring(
                8,
                notesTextClassElements[i].id.length,
              ) === selectedNoteIdUpdate
            ) {
              notesTextClassElements[i].parentNode.remove();
              break;
            }
          }
          reqData.annotationVO.annotationStatus = "deletedNote";
          reqData.annotationVO.noteText = undefined;
          addHighlightToRedux(reqData.annotationVO);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        setLoading(false);
        setIsPopoverOpenUpdate(false);
      })
      .catch((error) => {
        setIsPopoverOpenUpdate(false);
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const briefTextClicked = (e) => {
    setStudLinkFlag(false);
    setLinkDesStud(false);
    updateLinkFlagStud = false;
    updateLinkFlag = false;
    annotationType = "brief";
    if (typeof e === "string") {
      selectedNoteIdUpdate1 = e;
    } else {
      existingNoteValueBrief = "";
      let selection;
      let selectedNoteIdWithIndexer = "";
      if (window.getSelection) selection = window.getSelection();
      else if (typeof document.selection !== "undefined")
        selection = document.selection;
      bodyRect = document.body.getBoundingClientRect();
      let selectionElement = selection.anchorNode;
      if (
        selectionElement !== null &&
        selectionElement.parentNode !== null &&
        typeof selectionElement !== "undefined"
      ) {
        while (!$(selectionElement.parentNode).hasClass("briefElementText")) {
          if (
            selectionElement.parentNode !== null &&
            typeof selectionElement.parentNode !== "undefined" &&
            selectionElement.parentNode !== null
          ) {
            if (
              typeof selectionElement.parentNode.id !== "undefined" &&
              !(selectionElement.parentNode.id.indexOf("_") == -1)
            ) {
              selectedNoteIdWithIndexer = selectionElement.parentNode.id;
              selectionElement.parentNode.id =
                selectionElement.parentNode.id.substring(
                  0,
                  selectionElement.parentNode.id.indexOf("_"),
                );
            }
          }
          selectionElement = selectionElement.parentNode;
        }
      }
      if (
        selectionElement !== null &&
        selectionElement.parentNode !== null &&
        typeof selectionElement.parentNode.id !== "undefined" &&
        !(selectionElement.parentNode.id.indexOf("_") == -1)
      ) {
        selectedNoteIdWithIndexer = selectionElement.parentNode.id;
        selectedNoteIdUpdate1 = selectionElement.parentNode.id.substring(
          0,
          selectionElement.parentNode.id.indexOf("_"),
        );
      } else if (
        selectionElement.parentNode &&
        selectionElement.parentNode.id
      ) {
        selectedNoteIdUpdate1 = selectionElement.parentNode.id;
      }
    }
    existingNoteValueBrief = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("briefnote")
      .trim();
    if (existingNoteValueBrief === "" || existingNoteValueBrief === null) {
      noteIsEmpty = true;
      setNoteValueUpdate("");
    } else {
      noteIsEmpty = false;
      setNoteValueUpdate(existingNoteValueBrief);
    }
    if (
      selectedNoteIdUpdate1 !== undefined &&
      selectedNoteIdUpdate1 !== null &&
      selectedNoteIdUpdate1 !== ""
    ) {
      if (globalChapterBriefList) {
        let textContentWithoutHTMLTags = "";
        for (let p = 0; p < globalChapterBriefList.length; p++) {
          if (
            selectedNoteIdUpdate1 === globalChapterBriefList[p].annotationId
          ) {
            textContentWithoutHTMLTags =
              globalChapterBriefList[p].highlightText;
            highlightedTextWithoutHTML = textContentWithoutHTMLTags;
            break;
          }
        }
        copySelectedText = highlightedTextWithoutHTML.toString();
      }
      if (userVO.userRole === "Professor") {
        setAnchorElUpdate(document.getElementById(selectedNoteIdUpdate1));
        setIsPopoverOpenProfessorUpdate(true);
        setCasePopOverUpdate(true);
        setShowLink(false);
      } else {
        setAnchorElUpdate(document.getElementById(selectedNoteIdUpdate1));
        setIsPopoverOpenUpdate(true);
        setCasePopOverUpdate(true);
      }
      setPlacementUpdate("bottom");
      let removeCloseIcon = document.querySelectorAll(
        ".color-pallete .colorButton",
      );
      for (let i = 0; i < removeCloseIcon.length; i++) {
        ReactDOM.unmountComponentAtNode(
          document.getElementById(removeCloseIcon[i].id),
        );
      }
      setHighlightQuickUnderLine(false);
      selectedColor = document
        .getElementById(selectedNoteIdUpdate1)
        .getAttribute("colorCodeId");
      if (
        selectedColor !== undefined &&
        selectedColor !== null &&
        selectedColor !== ""
      ) {
        let labelVOList2 = JSON.parse(localStorage.getItem("labelVOList"));
        if (labelVOList2 !== null && labelVOList2 !== undefined) {
          labelVOList2 = labelVOList2
            ? Array.isArray(labelVOList2)
              ? labelVOList2
              : [labelVOList2]
            : null;
          labelVOList2 = labelVOList2
            ? labelVOList2.filter(
                (entry) => entry.labelName && entry.labelName.trim() !== "",
              )
            : null;
        }
        let labelvalue = labelVOList2.filter(
          (le) => le.colorCode === selectedColor.toLowerCase(),
        );
        if (
          labelvalue !== undefined &&
          labelvalue !== null &&
          labelvalue.length !== 0
        ) {
          setCurrentBriefLabel(labelvalue[0].labelName);
        }
        if (
          document.querySelector(
            "button[colorcode='" + selectedColor.toUpperCase() + "']",
          ) !== null
        ) {
          if (selectedColor.toLowerCase() === "underline") {
            setHighlightQuickUnderLine(true);
          } else {
            let selectedColorId = document.querySelector(
              "button[colorcode='" + selectedColor.toUpperCase() + "']",
            ).id;
            ReactDOM.render(
              <GrFormClose className="selected-icon" />,
              document.getElementById(selectedColorId),
            );
            if (selectedColorId === "color-yellow") {
              setColorYellow(true);
            } else if (selectedColorId === "color-green") {
              setColorGreen(true);
            } else if (selectedColorId === "color-blue") {
              setColorBlue(true);
            } else if (selectedColorId === "color-pink") {
              setColorPink(true);
            } else if (selectedColorId === "color-orange") {
              setColorOrange(true);
            } else if (selectedColorId === "color-purple") {
              setColorPurple(true);
            } else if (selectedColorId === "color-cyan") {
              setColorCyan(true);
            } else if (selectedColorId === "color-lightNavy") {
              setColorLightNavy(true);
            } else if (selectedColorId === "color-lightCoral") {
              setColorLightCoral(true);
            } else if (selectedColorId === "color-sandrift") {
              setColorSandrift(true);
            } else if (selectedColorId === "color-gainsboro") {
              setColorGainsboro(true);
            }
          }
        }
      }
    }
  };
  const updateChapterBrief = (newColor, noteVal, labelValue) => {
    setLoading(true);
    let existingNoteText = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("briefnote");
    let existingLabelText = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("brieflabelname");
    let existingColorCode = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("colorcodeid");
    let updatedNoteText = noteVal;
    let updatedColorCode = newColor;
    let updatedLabelText = labelValue;
    briefParaStartOffset = parseInt(
      document
        .getElementById(selectedNoteIdUpdate1)
        .getAttribute("briefparastartoffset"),
    );
    briefParaEndOffset = parseInt(
      document
        .getElementById(selectedNoteIdUpdate1)
        .getAttribute("briefparaendoffset"),
    );
    briefStartOffsetAtSectionLevel = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("briefstartoffset");
    briefEndOffsetAtSectionLevel = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("briefendoffset");
    briefStartParaId = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("briefstartparaid");
    briefEndParaId = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("briefendparaid");
    annotationSectionId = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("sectionid");
    annotationSectionTitle = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("sectiontitle");
    let encParaString = document
      .getElementById(selectedNoteIdUpdate1)
      .getAttribute("enclosingparaidstring");
    let encParaIdArray = [];
    encParaIdArray =
      convertEnclosingParaStringIdToEnclosingParaArray(encParaString);
    if (globalChapterBriefList) {
      let textContentWithoutHTMLTags = "";
      for (let p = 0; p < globalChapterBriefList.length; p++) {
        if (selectedNoteIdUpdate1 === globalChapterBriefList[p].annotationId) {
          textContentWithoutHTMLTags = globalChapterBriefList[p].highlightText;
          highlightedTextWithoutHTML = textContentWithoutHTMLTags;
          break;
        }
      }
    }
    briefedTextWithoutHTML = highlightedTextWithoutHTML;
    if (document.getElementById(selectedNoteIdUpdate))
      annotationSectionId = document
        .getElementById(selectedNoteIdUpdate)
        .getAttribute("sectionid");
    let actualSelectedNoteId = selectedNoteIdUpdate1;
    if (selectedNoteIdUpdate1.indexOf("_") !== -1)
      actualSelectedNoteId = selectedNoteIdUpdate1.substring(
        0,
        selectedNoteIdUpdate1.indexOf("_"),
      );
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastReadBookId: bookId,
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadParagraphId: "para01",
          lastReadPageNum: lastReadPageNum,
          lastReadSubSectionId: "subsec01",
        },
        sessionVO: getSessionVO(),
      },
      briefVO: {
        bookId: bookId,
        chapterId: chapterId,
        noteText: updatedNoteText,
        chapterTitle: chapterTitle,
        pageNumber: lastReadPageNum,
        labelName: updatedLabelText,
        sectionId: annotationSectionId,
        enclosingParaList: encParaIdArray,
        highlightEndParaId: briefEndParaId,
        annotationId: actualSelectedNoteId,
        sectionTitle: annotationSectionTitle,
        highlightStartParaId: briefStartParaId,
        highlightText: highlightedTextWithoutHTML,
        highlightParaEndOffset: briefParaEndOffset,
        highlightParaStartOffset: briefParaStartOffset,
        highlightColorCode: updatedColorCode.toLowerCase(),
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageCases/updateChapterBrief`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          reqData.briefVO.annotationStatus = "updated";
          reqData.briefVO.dppContentType = "brief";
          if (isNoteUpdated === true) {
            if (noteValueUpdate.trim() === "") {
              reqData.briefVO.annotationStatus = "deletedNote";
              reqData.briefVO.noteText = undefined;
            } else {
              reqData.briefVO.noteText = updatedNoteText;
              reqData.briefVO.annotationStatus = "updatedNote";
            }
          }
          let req1 = JSON.parse(JSON.stringify(reqData));
          addHighlightToRedux(reqData.briefVO);
          let value = colorCodeListEbook1.some(
            (elem) => elem.colorCode === existingColorCode.toUpperCase(),
          );
          if (value === false) req1.briefVO.annotationStatus = "added";
          addBriefToRedux(req1.briefVO);
          let relatedBriefTagsToRepaint = $(
            "briefstag[id^=" + actualSelectedNoteId + "]",
          );
          let highLightColor = updatedColorCode;
          for (let j = 0; j < relatedBriefTagsToRepaint.length; j++) {
            if (highLightColor !== undefined) {
              if (highLightColor.toLowerCase() === "underline") {
                $("briefstag#" + relatedBriefTagsToRepaint[j].id).attr(
                  "style",
                  "text-decoration: underline !important;",
                );
              } else {
                $("briefstag#" + relatedBriefTagsToRepaint[j].id).attr(
                  "style",
                  "background-color:" + highLightColor + " !important;",
                );
              }
            }
            $("briefstag#" + relatedBriefTagsToRepaint[j].id).attr(
              "brieflabelname",
              updatedLabelText,
            );
            $("briefstag#" + relatedBriefTagsToRepaint[j].id).attr(
              "briefnote",
              updatedNoteText,
            );
            $("briefstag#" + relatedBriefTagsToRepaint[j].id).attr(
              "colorcodeId",
              highLightColor,
            );
          }
          selectedHighlightColor = highLightColor;
          yValue = document
            .getElementById(actualSelectedNoteId)
            .getBoundingClientRect().top;
          if (!selectedHighlightColor)
            selectedHighlightColor =
              document.getElementById(actualSelectedNoteId).style
                .backgroundColor;
          let noteVal = noteValueUpdate;
          let updatedNoteText1 = noteValueUpdate.trim().length;
          if (noteIsEmpty === false && updatedNoteText1 === 0) {
            let spnNotesCollection = $(
              "span[id='colSpan" + actualSelectedNoteId + "']",
            );
            let briefTextClassElements =
              document.getElementsByClassName("labelNoteWrapper");
            let briefTextElementsCount = briefTextClassElements.length;
            if (briefTextElementsCount > 0 && spnNotesCollection.length > 0) {
              for (let i = 0; i < briefTextClassElements.length; i++) {
                if (
                  briefTextClassElements[i].id.substring(
                    12,
                    briefTextClassElements[i].id.length,
                  ) ===
                  spnNotesCollection[0].id.substring(
                    7,
                    spnNotesCollection[0].id.length,
                  )
                ) {
                  updatingBrief = true;
                  briefTextClassElements[i].parentNode.remove();
                  break;
                }
              }
            }
            if (typeof spnNotesCollection !== "undefined") {
              if (typeof spnNotesCollection[0] !== "undefined") {
                let briefSpanBlockClassElements = $(".briefSpanBlock");
                for (let i = 0; i < briefSpanBlockClassElements.length; i++) {
                  if (
                    briefSpanBlockClassElements[i].id.substring(
                      7,
                      briefSpanBlockClassElements[0].id.length,
                    ) ===
                    spnNotesCollection[0].id.substring(
                      7,
                      spnNotesCollection[0].id.length,
                    )
                  ) {
                    briefSpanBlockClassElements[i].parentNode.remove();
                    break;
                  }
                }
              }
            }
          }
          if (
            (noteIsEmpty === true && updatedNoteText1 > 0) ||
            (noteIsEmpty === false && noteVal.trim() !== "")
          ) {
            localStorage.setItem("addBriefStartParaId", briefStartParaId);
            if (typeof ($("#" + briefStartParaId).next() !== "undefined")) {
              if (
                $("#" + briefStartParaId)
                  .next()
                  .is("p")
              ) {
                localStorage.setItem(
                  "addBriefNextParaId",
                  $("#" + briefStartParaId)
                    .next()
                    .attr("id"),
                );
              }
            }
            displayBriefOnRight(
              actualSelectedNoteId,
              selectedHighlightColor,
              yValue,
              updatedLabelText,
              noteVal,
            );
            setTimeout(function () {}, 800);
          } else {
            const element = document.getElementById(
              "briefAnchorElement" + actualSelectedNoteId,
            );
            if (element !== undefined && element !== null)
              ReactDOM.unmountComponentAtNode(element);
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        setLoading(false);
        setCasePopOverUpdate(false);
        setIsPopoverOpenUpdate(false);
        setIsPopoverOpenProfessorUpdate(false);
        setIsNoteUpdated(false);
      })
      .catch((error) => {
        setIsPopoverOpenUpdate(false);
        setIsPopoverOpenProfessorUpdate(false);
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const handleProflink = (e) => {
    setProflink(e.target.value);
    if (e.target.value.trim() === "") {
      document.getElementById("sharewithStud").style.opacity = "0.4";
      document.getElementById("sharewithStud").style.pointerEvents = "none";
    } else {
      document.getElementById("sharewithStud").style.opacity = "1";
      document.getElementById("sharewithStud").style.pointerEvents = "unset";
    }
  };
  const handleClickAwayFromPopoverProfessor = () => {
    if (isBriefOpen) {
      setIsBriefOpen(false);
    } else {
      let noteVal = noteValue,
        labelValue;
      if (profLink.trim() === "") {
        addingNote = noteVal !== "" ? true : false;
        if (addingNote) {
          if (casePopOver) {
            labelValue = document
              .getElementById("viewingInput_Labels")
              .value.replace(/</g, "&lt;")
              .replace(/>/g, "&gt;");
          }
          casePopOver
            ? saveBriefHighlights("#EDE48C", noteVal, labelValue)
            : saveHighlights("#EDE48C", noteVal);
        } else if (!outlineOnly) {
          let listOfDummyNode = $('highlight[id^="note"]');
          for (let k = 0; k < listOfDummyNode.length; k++) {
            let highlightSpanTag = document.getElementById(
              listOfDummyNode[k].id,
            );
            let spanElement = document.createElement("span");
            spanElement.innerHTML = highlightSpanTag.innerText;
            spanElement.normalize();
            var parent = highlightSpanTag.parentNode;
            while (highlightSpanTag.firstChild)
              parent.insertBefore(
                highlightSpanTag.firstChild,
                highlightSpanTag,
              );
            parent.removeChild(highlightSpanTag);
          }
        }
      } else if (profLink.trim() !== "" && updateLinkFlag === false) {
        let linkSharedWithStd = document.getElementById("shareit").checked;
        saveCreatedLink(profLink, linkSharedWithStd, noteVal, "");
      }
      setIsPopoverOpenProfessor(false);
    }
  };
  const handleClickAwayFromPopoverProfessorUpdate = () => {
    if (updateLinkFlag) {
      let sharenewFlag = document.getElementById("shareit").checked;
      if (
        existingLinkValue === profLink &&
        existingLinkValueDes === noteValueUpdate &&
        sharewithStudFlag === sharenewFlag
      ) {
        existingLinkValue = "";
        existingLinkValueDes = "";
        sharewithStudFlag = false;
      } else if (profLink === "") {
        deleteLink();
      } else {
        updateLink();
      }
      setIsPopoverOpenProfessorUpdate(false);
      updateLinkFlag = false;
    } else {
      if (isBriefOpen) {
        setIsBriefOpen(false);
      } else {
        let noteVal = noteValueUpdate;
        let updatedNoteText = noteValueUpdate.trim().length;
        if (casePopOverUpdate) {
          if (existingNoteValueBrief.trim() !== noteVal.trim()) {
            if (
              (noteIsEmpty === true && updatedNoteText > 0) ||
              (noteIsEmpty === false && updatedNoteText === 0) ||
              (noteIsEmpty === false && updatedNoteText > 0)
            ) {
              updateChapterBrief(
                document
                  .getElementById(selectedNoteIdUpdate1)
                  .getAttribute("colorcodeid"),
                noteVal,
              );
            } else {
              setIsPopoverOpenProfessorUpdate(false);
              setCasePopOverUpdate(false);
            }
          } else {
            setIsPopoverOpenProfessorUpdate(false);
            setCasePopOverUpdate(false);
          }
        } else {
          if (noteIsEmpty === true && updatedNoteText > 0) {
            addChapterNote(noteValueUpdate);
          } else if (
            noteIsEmpty === false &&
            isNoteUpdated === true &&
            updatedNoteText !== 0
          ) {
            updateChapterNote();
            setIsNoteUpdated(false);
          } else if (noteIsEmpty === false && updatedNoteText === 0) {
            deleteChapterNote();
          } else {
            setIsPopoverOpenProfessorUpdate(false);
          }
        }
      }
    }
    setIsPopoverOpenProfessorUpdate(false);
  };
  const saveCreatedLink = (profLink, linkSharedWithStd, noteDes, color) => {
    setLoading(true);
    let linkUrlIndex = profLink.indexOf("://"),
      createdLinkUrl = "";
    createdLinkUrl =
      linkUrlIndex !== -1
        ? profLink.substr(0, linkUrlIndex).toLowerCase() +
          profLink.substr(linkUrlIndex)
        : `https://${profLink}`;
    let linkSharedWithClass = linkSharedWithStd.toString();
    let linkStartOffset = parseInt(
      document.getElementById(selectedNoteId).getAttribute("startOffset"),
    );
    let linkEndOffset = parseInt(
      document.getElementById(selectedNoteId).getAttribute("endOffset"),
    );
    let createdLinkComments = noteDes.trim(),
      annotationResponseLink = {};
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastReadBookId: bookId,
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadPageNum: lastReadPageNum,
        },
        sessionVO: getSessionVO(),
      },
      annotationVO: {
        bookId: bookId,
        chapterId: chapterId,
        linkFontColorCode: "",
        linkUrl: createdLinkUrl,
        chapterTitle: chapterTitle,
        sectionId: annotationSectionId,
        linkBackGroundColorCode: color,
        linkShareFlag: linkSharedWithClass,
        enclosingParaList: selectedParaIds,
        sectionTitle: annotationSectionTitle,
        linkDescription: createdLinkComments,
        highlightEndParaId: annotationEndParaId,
        highlightParaEndOffset: highlightEndOffset,
        highlightStartParaId: annotationStartParaId,
        linkHighlightText: highlightedTextWithoutHTML,
        highlightParaStartOffset: highlightStartOffset,
        linkEndOffset: highlightEndOffsetAtSectionLevel,
        linkStartOffset: highlightStartOffsetAtSectionLevel,
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/addChapterLink`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          let linkEditingForproffessor = "true";
          if (highLightSpanIdAcrossPara.length === 0) {
            let linkTag = document.getElementById(selectedNoteId);
            let linkSpanId = 0;
            let spanElement = document.createElement("anchorTag");
            spanElement.innerHTML = linkTag.innerHTML;
            spanElement.id = selectedNoteId;
            spanElement.className = "anchorElementText";
            spanElement.setAttribute("data-references", "popover");
            spanElement.setAttribute("data-toggle", "popover");
            spanElement.setAttribute("tabindex", "0");
            spanElement.setAttribute("data-original-title", "");
            spanElement.setAttribute(
              "linkStartOffset",
              highlightStartOffsetAtSectionLevel,
            );
            spanElement.setAttribute(
              "linkEndOffset",
              highlightEndOffsetAtSectionLevel,
            );
            spanElement.setAttribute(
              "linkParaStartOffset",
              highlightStartOffset,
            );
            spanElement.setAttribute("linkParaEndOffset", highlightEndOffset);
            spanElement.setAttribute(
              "enclosingParaIdString",
              enclosingParaIdString,
            );
            spanElement.setAttribute("linkStartParaId", annotationStartParaId);
            spanElement.setAttribute("linkEndParaId", annotationEndParaId);
            spanElement.setAttribute("createdLinkUrl", createdLinkUrl);
            spanElement.setAttribute(
              "createdLinkComments",
              createdLinkComments,
            );
            spanElement.setAttribute(
              "createdLinkShareStatus",
              linkSharedWithClass,
            );
            spanElement.setAttribute("linkBackGroundColorCode", color);
            spanElement.setAttribute("linkEditingForproffessor", "true");
            spanElement.setAttribute("sectionId", annotationSectionId);
            spanElement.setAttribute("sectionTitle", annotationSectionTitle);
            spanElement.addEventListener("click", function (e) {
              linkTextClick(e);
            });
            spanElement.normalize();
            linkTag.parentNode.replaceChild(spanElement, linkTag);
            if (color !== undefined) {
              if (color.toLowerCase() == "underline") {
                $(spanElement).css("text-decoration", "underline");
              } else {
                $(spanElement).css("backgroundColor", color);
              }
            }
          } else if (highLightSpanIdAcrossPara.length > 0) {
            for (let r = 0; r < highLightSpanIdAcrossPara.length; r++) {
              selectedNoteId = "note" + r;
              let linkTag = document.getElementById(selectedNoteId);
              let spanElement = document.createElement("anchorTag");
              spanElement.innerHTML = linkTag.innerHTML;
              spanElement.id = selectedNoteId;
              spanElement.className = "anchorElementText";
              spanElement.setAttribute("data-references", "popover");
              spanElement.setAttribute("data-toggle", "popover");
              spanElement.setAttribute("tabindex", "0");
              spanElement.setAttribute("data-original-title", "");
              spanElement.setAttribute(
                "linkStartOffset",
                highlightStartOffsetAtSectionLevel,
              );
              spanElement.setAttribute(
                "linkEndOffset",
                highlightEndOffsetAtSectionLevel,
              );
              spanElement.setAttribute(
                "linkParaStartOffset",
                highlightStartOffset,
              );
              spanElement.setAttribute("linkParaEndOffset", highlightEndOffset);
              spanElement.setAttribute(
                "enclosingParaIdString",
                enclosingParaIdString,
              );
              spanElement.setAttribute(
                "linkStartParaId",
                annotationStartParaId,
              );
              spanElement.setAttribute("linkEndParaId", annotationEndParaId);
              spanElement.setAttribute("createdLinkUrl", createdLinkUrl);
              spanElement.setAttribute(
                "createdLinkComments",
                createdLinkComments,
              );
              spanElement.setAttribute(
                "createdLinkShareStatus",
                linkSharedWithClass,
              );
              spanElement.setAttribute("linkBackGroundColorCode", color);
              spanElement.setAttribute("linkEditingForproffessor", "true");
              spanElement.setAttribute("sectionId", annotationSectionId);
              spanElement.setAttribute("sectionTitle", annotationSectionTitle);
              spanElement.addEventListener("click", function (e) {
                linkTextClick(e);
              });
              spanElement.normalize();
              linkTag.parentNode.replaceChild(spanElement, linkTag);
              if (color !== undefined) {
                if (color.toLowerCase() == "underline") {
                  $(spanElement).css("text-decoration", "underline");
                } else {
                  $(spanElement).css("backgroundColor", color);
                }
              }
            }
          }
          if (data.annotationVO) {
            annotationResponseLink = {
              annotationId: data.annotationVO.annotationId,
              dppContentId: data.annotationVO.annotationId,
              enclosingParaList: selectedParaIds,
              highlightColorCode: color,
              highlightEndOffset: "",
              highlightEndParaId: annotationEndParaId,
              highlightParaEndOffset: highlightEndOffset,
              highlightParaStartOffset: highlightStartOffset,
              highlightStartOffset: "",
              highlightStartParaId: annotationStartParaId,
              linkHighlightText: highlightedTextWithoutHTML,
            };
            dppAnotationId = data.annotationVO.annotationId;
            reqData.annotationVO.annotationId = dppAnotationId;
            reqData.annotationVO.annotationStatus = "added";
            reqData.annotationVO.dppContentType = "link";
            if (noteValue && noteValue.trim().length > 0)
              reqData.annotationVO.noteText = noteValue;
            addHighlightToRedux(reqData.annotationVO);
            if (highLightSpanIdAcrossPara.length === 0) {
              document.getElementById("note" + highLightSpanId).id =
                dppAnotationId;
              document
                .getElementById(dppAnotationId)
                .addEventListener("mouseup", function (e) {
                  linkTextClick(e);
                });
              document
                .getElementById(dppAnotationId)
                .setAttribute(
                  "startOffset",
                  highlightStartOffsetAtSectionLevel,
                );
              document
                .getElementById(dppAnotationId)
                .setAttribute("endOffset", highlightEndOffsetAtSectionLevel);
            } else if (highLightSpanIdAcrossPara.length > 0) {
              for (let r = 0; r < highLightSpanIdAcrossPara.length; r++) {
                if (r === 0) {
                  document.getElementById("note" + r).id = dppAnotationId;
                  document
                    .getElementById(dppAnotationId)
                    .addEventListener("mouseup", function (e) {
                      linkTextClick(e);
                    });
                  document
                    .getElementById(dppAnotationId)
                    .setAttribute("startOffset", linkStartOffset);
                  document
                    .getElementById(dppAnotationId)
                    .setAttribute("endOffset", linkEndOffset);
                } else {
                  document.getElementById("note" + r).id =
                    dppAnotationId + "_" + [r];
                  document
                    .getElementById(dppAnotationId + "_" + [r])
                    .addEventListener("mouseup", function (e) {
                      linkTextClick(e);
                    });
                  document
                    .getElementById(dppAnotationId + "_" + [r])
                    .setAttribute("startOffset", linkStartOffset);
                  document
                    .getElementById(dppAnotationId + "_" + [r])
                    .setAttribute("endOffset", linkEndOffset);
                }
              }
              let enclosingString = "";
              if (selectedParaIds.length > 0) {
                for (let k = 0; k < selectedParaIds.length; k++) {
                  if (k === selectedParaIds.length - 1)
                    enclosingString += selectedParaIds[k];
                  else enclosingString += selectedParaIds[k] + "|";
                }
              }
              document
                .getElementById(dppAnotationId)
                .setAttribute("enclosingParaIdString", enclosingString);
            }
            selectedNoteId = dppAnotationId;
          }
          yValue = document
            .getElementById(selectedNoteId)
            .getBoundingClientRect().top;
          if (linkSharedWithClass === "false") {
            displayNotesOnRight(
              createdLinkComments,
              selectedNoteId,
              yValue,
              createdLinkComments,
              true,
            );
          } else {
            displayLinksOnLeft(
              selectedNoteId,
              yValue,
              createdLinkUrl,
              createdLinkComments,
              linkSharedWithClass,
              linkEditingForproffessor,
            );
          }
          setLoading(false);
          if (globalChapterLinkList === "") {
            globalChapterLinkList = [];
            globalChapterLinkList.push(annotationResponseLink);
          } else {
            globalChapterLinkList = [
              ...globalChapterLinkList,
              annotationResponseLink,
            ];
          }
        } else {
          if (data.httpErrorCode === "400") {
            setNotificationOpen(true);
            setNotificationContent(data.errorMessg);
          } else if (data.wkErrorCode) {
            handleException(data);
          }
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const linkTextClick = (e) => {
    setCasePopOver(false);
    setCopiedText("");
    setNoteValueUpdate("");
    setIsPopoverOpenProfessor(false);
    sharewithStudFlag = false;
    updateLinkFlagStud = false;
    updateLinkFlag = false;
    if (typeof e === "string") {
      selectedNoteIdlink = e;
    } else {
      let selectedNoteIdWithIndexer = "";
      if (window.getSelection) selection = window.getSelection();
      else if (typeof document.selection !== "undefined")
        selection = document.selection;
      copySelectedText = selection.toString();
      bodyRect = document.body.getBoundingClientRect();
      let selectionElement = selection.anchorNode;
      if (
        selectionElement !== null &&
        selectionElement.parentNode !== null &&
        typeof selectionElement !== "undefined"
      ) {
        while (!$(selectionElement.parentNode).hasClass("anchorElementText")) {
          if (
            selectionElement.parentNode !== null &&
            typeof selectionElement.parentNode.id !== "undefined" &&
            !(selectionElement.parentNode.id.indexOf("_") == -1) &&
            selectionElement.parentNode !== null
          ) {
            selectedNoteIdWithIndexer = selectionElement.parentNode.id;
            selectionElement.parentNode.id =
              selectionElement.parentNode.id.substring(
                0,
                selectionElement.parentNode.id.indexOf("_"),
              );
          }
          selectionElement = selectionElement.parentNode;
        }
      }
      if (
        selectionElement !== null &&
        selectionElement.parentNode !== null &&
        typeof selectionElement.parentNode.id !== "undefined" &&
        !(selectionElement.parentNode.id.indexOf("_") == -1)
      ) {
        selectedNoteIdWithIndexer = selectionElement.parentNode.id;
        selectedNoteIdlink = selectionElement.parentNode.id.substring(
          0,
          selectionElement.parentNode.id.indexOf("_"),
        );
      } else if (
        selectionElement.parentNode &&
        selectionElement.parentNode.id
      ) {
        selectedNoteIdlink = selectionElement.parentNode.id;
      }
    }
    if (
      selectedNoteIdlink !== undefined &&
      selectedNoteIdlink !== null &&
      selectedNoteIdlink !== ""
    ) {
      if (globalChapterLinkList) {
        let textContentWithoutHTMLTags = "";
        for (let p = 0; p < globalChapterLinkList.length; p++) {
          if (selectedNoteIdlink === globalChapterLinkList[p].annotationId) {
            textContentWithoutHTMLTags =
              globalChapterLinkList[p].linkHighlightText;
            highlightedTextWithoutHTML = textContentWithoutHTMLTags;
            break;
          }
        }
        if (
          highlightedTextWithoutHTML !== "" &&
          highlightedTextWithoutHTML !== undefined
        ) {
          copySelectedText = highlightedTextWithoutHTML.toString();
        }
      }
    }
    let existingLink = document
      .getElementById(selectedNoteIdlink)
      .getAttribute("createdlinkurl")
      .trim();
    let existingLinkDes = document
      .getElementById(selectedNoteIdlink)
      .getAttribute("createdlinkcomments");
    let createdlinksharestatus = document
      .getElementById(selectedNoteIdlink)
      .getAttribute("createdlinksharestatus");
    existingLinkValue = existingLink;
    existingLinkValueDes = existingLinkDes;
    if (
      selectedNoteIdlink !== undefined &&
      selectedNoteIdlink !== null &&
      selectedNoteIdlink !== ""
    ) {
      setAnchorElUpdate(document.getElementById(selectedNoteIdlink));
      if (userVO.userRole === "Professor") {
        setIsPopoverOpenProfessorUpdate(true);
        setShowLink(true);
        document.getElementById("shareit").checked = false;
        setPlacement("bottom");
        if (existingLink !== "" && existingLink !== undefined) {
          setProflink(existingLink);
        }
        if (
          existingLinkDes !== "" &&
          existingLinkDes !== undefined &&
          existingLinkDes !== "undefined"
        ) {
          setNoteValueUpdate(existingLinkDes);
        }
        if (createdlinksharestatus === "true") {
          document.getElementById("shareit").checked = true;
          sharewithStudFlag = true;
        }
        updateLinkFlag = true;
      } else if (userVO.userRole === "Student") {
        setIsPopoverOpenUpdate(true);
        setPlacement("bottom");
        if (existingLink !== "" && existingLink !== undefined) {
          setStudLinkFlag(true);
          setStudlink(existingLink);
        }
        if (
          existingLinkDes !== "" &&
          existingLinkDes !== undefined &&
          existingLinkDes !== "undefined"
        ) {
          setNoteValueUpdate(existingLinkDes);
          setLinkDesStud(true);
          let i = document.getElementsByClassName("note-text-area")[0];
          if (i !== undefined) {
            i.setAttribute("disabled", true);
          }
        } else {
          setLinkDesStud(false);
        }
        updateLinkFlagStud = true;
      }
      let removeCloseIcon = document.querySelectorAll(
        ".color-pallete .colorButton",
      );
      for (let i = 0; i < removeCloseIcon.length; i++) {
        ReactDOM.unmountComponentAtNode(
          document.getElementById(removeCloseIcon[i].id),
        );
      }
      setHighlightQuickUnderLine(false);
      selectedColor = document
        .getElementById(selectedNoteIdlink)
        .getAttribute("linkbackgroundcolorcode");
      if (
        selectedColor !== undefined &&
        selectedColor !== null &&
        selectedColor !== ""
      ) {
        if (
          document.querySelector(
            "button[colorcode='" + selectedColor.toUpperCase() + "']",
          ) !== null
        ) {
          if (selectedColor.toLowerCase() === "underline") {
            setHighlightQuickUnderLine(true);
          } else {
            let selectedColorId = document.querySelector(
              "button[colorcode='" + selectedColor.toUpperCase() + "']",
            ).id;
            ReactDOM.render(
              <GrFormClose className="selected-icon" />,
              document.getElementById(selectedColorId),
            );
            if (selectedColorId === "color-yellow") {
              setColorYellow(true);
            } else if (selectedColorId === "color-green") {
              setColorGreen(true);
            } else if (selectedColorId === "color-blue") {
              setColorBlue(true);
            } else if (selectedColorId === "color-pink") {
              setColorPink(true);
            } else if (selectedColorId === "color-orange") {
              setColorOrange(true);
            } else if (selectedColorId === "color-purple") {
              setColorPurple(true);
            } else if (selectedColorId === "color-cyan") {
              setColorCyan(true);
            } else if (selectedColorId === "color-lightNavy") {
              setColorLightNavy(true);
            } else if (selectedColorId === "color-lightCoral") {
              setColorLightCoral(true);
            } else if (selectedColorId === "color-sandrift") {
              setColorSandrift(true);
            } else if (selectedColorId === "color-gainsboro") {
              setColorGainsboro(true);
            }
          }
        }
      }
    }
  };
  const updateLink = (color) => {
    setLoading(true);
    let modifiedLinkText = profLink;
    let modifiedLinkComments = noteValueUpdate
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    let messageBoxChecked = document.getElementById("shareit").checked;
    let existingColor = document
      .getElementById(selectedNoteIdlink)
      .getAttribute("linkbackgroundcolorcode");
    annotationStartParaId = document
      .getElementById(selectedNoteIdlink)
      .getAttribute("linkStartParaId");
    annotationEndParaId = document
      .getElementById(selectedNoteIdlink)
      .getAttribute("linkEndParaId");
    let annotationSectionId = document
      .getElementById(selectedNoteIdlink)
      .getAttribute("sectionId");
    let annotationSectionTitle = document
      .getElementById(selectedNoteIdlink)
      .getAttribute("sectionTitle");
    linkStartOffset = parseInt(
      document
        .getElementById(selectedNoteIdlink)
        .getAttribute("linkStartOffset"),
    );
    linkEndOffset = parseInt(
      document.getElementById(selectedNoteIdlink).getAttribute("linkEndOffset"),
    );
    let linkParaStartOffset = parseInt(
      document
        .getElementById(selectedNoteIdlink)
        .getAttribute("linkParaStartOffset"),
    );
    let linkParaEndOffset = parseInt(
      document
        .getElementById(selectedNoteIdlink)
        .getAttribute("linkParaEndOffset"),
    );
    let startParaId = annotationStartParaId,
      endParaId = annotationEndParaId,
      linkEditingForproffessor = "true";
    let encParaString = document
      .getElementById(selectedNoteIdlink)
      .getAttribute("enclosingparaidstring");
    let encParaIdArray = [];
    encParaIdArray =
      convertEnclosingParaStringIdToEnclosingParaArray(encParaString);
    let actualSelectedNoteId = selectedNoteIdlink;
    if (selectedNoteIdlink.indexOf("_") !== -1) {
      actualSelectedNoteId = selectedNoteIdlink.substring(
        0,
        selectedNoteIdlink.indexOf("_"),
      );
    }
    color = color !== undefined ? color : existingColor;
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastReadBookId: bookId,
          pageNavigatingTo: "EReader",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadChapterId: chapterTitle,
          lastReadPageNum: lastReadPageNum,
        },
        sessionVO: getSessionVO(),
      },
      annotationVO: {
        bookId: bookId,
        linkColorCode: "",
        chapterId: chapterId,
        linkUrl: modifiedLinkText,
        chapterTitle: chapterTitle,
        linkEndOffset: linkEndOffset,
        sectionId: annotationSectionId,
        linkStartOffset: linkStartOffset,
        annotationId: selectedNoteIdlink,
        enclosingParaList: encParaIdArray,
        sectionTitle: annotationSectionTitle,
        linkDescription: modifiedLinkComments,
        highlightEndParaId: annotationEndParaId,
        highlightParaEndOffset: linkParaEndOffset,
        linkShareFlag: messageBoxChecked.toString(),
        highlightStartParaId: annotationStartParaId,
        highlightParaStartOffset: linkParaStartOffset,
        linkBackGroundColorCode: color !== undefined ? color : existingColor,
        linkHighlightText:
          document.getElementById(selectedNoteIdlink).textContent,
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/updateChapterLink`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          dppAnotationId = data.annotationVO.annotationId;
          reqData.annotationVO.annotationId = dppAnotationId;
          reqData.annotationVO.annotationStatus = "updatedLink";
          reqData.annotationVO.dppContentType = "link";
          if (noteValue && noteValue.trim().length > 0)
            reqData.annotationVO.noteText = noteValue;
          addHighlightToRedux(reqData.annotationVO);
          let relatedAnchorTagsToRepaint = $(
            "anchortag[id^=" + selectedNoteIdlink + "]",
          );
          for (let j = 0; j < relatedAnchorTagsToRepaint.length; j++) {
            document
              .querySelector(
                "anchortag[id='" + relatedAnchorTagsToRepaint[j].id + "']",
              )
              .setAttribute("createdlinkcomments", modifiedLinkComments);
            document
              .querySelector(
                "anchortag[id='" + relatedAnchorTagsToRepaint[j].id + "']",
              )
              .setAttribute(
                "createdlinksharestatus",
                messageBoxChecked.toString(),
              );
            document
              .querySelector(
                "anchortag[id='" + relatedAnchorTagsToRepaint[j].id + "']",
              )
              .setAttribute("createdlinkurl", modifiedLinkText);
            document
              .querySelector(
                "anchortag[id='" + relatedAnchorTagsToRepaint[j].id + "']",
              )
              .setAttribute("linkBackGroundColorCode", color);
            document
              .querySelector(
                "anchortag[id='" + relatedAnchorTagsToRepaint[j].id + "']",
              )
              .style.removeProperty("textDecoration");
            if (color !== undefined) {
              color.toLowerCase() === "underline"
                ? (document.querySelector(
                    "anchortag[id='" + relatedAnchorTagsToRepaint[j].id + "']",
                  ).style.textDecoration = "underline")
                : (document.querySelector(
                    "anchortag[id='" + relatedAnchorTagsToRepaint[j].id + "']",
                  ).style.backgroundColor = color);
            }
          }
          yValue = document
            .getElementById(selectedNoteIdlink)
            .getBoundingClientRect().top;
          if (messageBoxChecked.toString() === "false") {
            let notesTextClassElements = $(".linksText");
            for (let i = 0; i < notesTextClassElements.length; i++) {
              if (
                notesTextClassElements[i].id.substring(
                  7,
                  notesTextClassElements[i].id.length,
                ) === selectedNoteIdlink
              ) {
                notesTextClassElements[i].parentNode.remove();
                displayNotesOnRight(
                  modifiedLinkComments,
                  selectedNoteIdlink,
                  yValue,
                  "",
                  true,
                );
                break;
              }
            }
            if (notesTextClassElements.length === 0) {
              displayNotesOnRight(
                modifiedLinkComments,
                selectedNoteIdlink,
                yValue,
                "",
                true,
              );
            }
          } else if (messageBoxChecked.toString() === "true") {
            let notesTextClassElements =
              document.querySelectorAll(".notesText");
            for (let i = 0; i < notesTextClassElements.length; i++) {
              if (
                notesTextClassElements[i].id.substring(
                  8,
                  notesTextClassElements[i].id.length,
                ) === selectedNoteIdlink
              ) {
                notesTextClassElements[i].parentNode.remove();
                displayLinksOnLeft(
                  selectedNoteIdlink,
                  yValue,
                  modifiedLinkText,
                  modifiedLinkComments,
                  messageBoxChecked,
                  linkEditingForproffessor,
                );
                break;
              }
            }
            displayLinksOnLeft(
              selectedNoteIdlink,
              yValue,
              modifiedLinkText,
              modifiedLinkComments,
              messageBoxChecked,
              linkEditingForproffessor,
            );
          }
        } else {
          if (data.httpErrorCode === "400") {
            setNotificationOpen(true);
            setNotificationContent(data.errorMessg);
          } else if (data.wkErrorCode) {
            handleException(data);
          }
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const displayLinksOnLeft = (
    linkId,
    topValue,
    urlText,
    urlComment,
    checkboxStatus,
    linkEditingForproffessor,
  ) => {
    if (document.getElementById("linkAnchorElement" + linkId))
      document.getElementById("linkAnchorElement" + linkId).remove();
    let containerTop = document
      .getElementById("links-container")
      .getBoundingClientRect().top;
    let clickableAnchorElement = document.createElement("A");
    clickableAnchorElement.id = "linkAnchorElement" + linkId;
    let linkIcon = document.createElement("IMG");
    linkIcon.className = "linksIcon display-inline-block";
    linkIcon.style.top = topValue - containerTop - 2 + "px";
    linkIcon.src = shareLinkIcon;
    linkIcon.style.width = "25px";
    linkIcon.style.height = "auto";
    linkIcon.style.position = "absolute";
    let linkText = document.createElement("div");
    linkText.id = "linkDiv" + linkId;
    linkText.style.top = topValue - containerTop - 2 + "px";
    linkText.className = "linksIcon linksText";
    linkText.style.right = "70px";
    if (urlComment !== "" && urlComment !== null && urlComment !== undefined) {
      if (
        (urlComment.length > 40 && urlComment.split(" ").length < 5) ||
        (urlComment.length > 40 && urlComment.split(" ")[0].length > 20) ||
        (urlComment.length > 25 && urlComment.split(" ")[0].length > 20)
      ) {
        linkText.className = "linksIcon linksText overlapCheckClass  ellipsis";
        linkText.style.width = "150px";
      } else {
        linkText.className = "linksIcon linksText overlapCheckClass";
      }
    } else {
      linkText.className = "linksIcon linksText";
    }
    let iconOverValueL = 15;
    let minimizeNoteBookLinkFlag3 = document
      .querySelector(".expandNoteBookLink")
      .getAttribute("aria-expanded");
    if (minimizeNoteBookLinkFlag3 === "true") {
      linkText.style.display = "none";
    } else if (minimizeNoteBookLinkFlag3 === "false") {
      linkText.style.display = "block";
    }
    let screenMode3 = localStorage.getItem("screenMode");
    if (screenMode3 === "split") {
      iconOverValueL = 20;
    } else if (screenMode3 === "expand") {
      iconOverValueL = 5;
    }
    if (urlComment !== undefined && urlComment !== null && urlComment !== "") {
      linkText.innerHTML = urlComment;
      linkText.title = urlComment;
      linkIcon.setAttribute(
        "urlComments",
        urlComment.replace(/</g, "&lt;").replace(/>/g, "&gt;"),
      );
    } else {
      linkIcon.setAttribute("urlComments", "");
    }
    linkIcon.setAttribute("urlText", urlText);
    linkIcon.setAttribute("shareLinkChecked", checkboxStatus);
    linkIcon.setAttribute("linkEditingForproffessor", linkEditingForproffessor);
    let countofLinesToBeShifted = 0;
    let allLinks = $(".linksText");
    allLinks.sort(function (a, b) {
      if (a.style.top > b.style.top) return 1;
      if (a.style.top < b.style.top) return -1;
      return 0;
    });
    let i;
    let lastNoteHeight = 0;
    let lastNoteTopValue = 0;
    for (i = 0; i < allLinks.length; i++) {
      lastNoteHeight = allLinks[i].offsetHeight + iconOverValueL;
      if (parseInt(allLinks[i].style.top) == parseInt(linkIcon.style.top)) {
        lastNoteTopValue = parseInt(allLinks[i].style.top);
        linkIcon.style.top =
          parseInt(allLinks[i].style.top) - 2 + lastNoteHeight + "px";
        linkText.style.top =
          parseInt(allLinks[i].style.top) + lastNoteHeight + "px";
        clickableAnchorElement.top =
          parseInt(allLinks[i].style.top) + lastNoteHeight + "px";
      } else if (
        parseInt(allLinks[i].style.top) <
          parseInt(linkIcon.style.top) + parseInt(lastNoteHeight) &&
        parseInt(allLinks[i].style.top) >
          parseInt(linkIcon.style.top) - parseInt(lastNoteHeight)
      ) {
        if (parseInt(allLinks[i].style.top) > lastNoteTopValue) {
          lastNoteTopValue = parseInt(allLinks[i].style.top);
          linkIcon.style.top =
            parseInt(allLinks[i].style.top) +
            7 +
            parseInt(lastNoteHeight) +
            "px";
          linkText.style.top =
            parseInt(allLinks[i].style.top) + lastNoteHeight + "px";
          clickableAnchorElement.top =
            parseInt(allLinks[i].style.top) + parseInt(lastNoteHeight) + "px";
        }
      }
    }
    clickableAnchorElement.appendChild(linkIcon);
    clickableAnchorElement.appendChild(linkText);
    document
      .getElementById("links-container")
      .appendChild(clickableAnchorElement);
    document
      .getElementById(clickableAnchorElement.id)
      .addEventListener("click", function (e) {
        linkSharedTextClicked(e);
      });
    let allrTsIcon = $(".rTsIcon");
    for (let j = 0; j < allrTsIcon.length; j++) {
      let differenceInTop = 0;
      if (parseInt(linkIcon.style.top) >= parseInt(allrTsIcon[j].style.top)) {
        differenceInTop =
          parseInt(linkIcon.style.top) - parseInt(allrTsIcon[j].style.top);
        if (differenceInTop < 20) {
          allrTsIcon[j].remove();
          allrTsIcon[j].style.top =
            parseInt(linkIcon.style.top) + 7 + parseInt(lastNoteHeight) + "px";
          document.getElementById("links-container").appendChild(allrTsIcon[j]);
        }
      }
    }
    let currentAnnotationRect = document
      .getElementById("linkDiv" + linkId)
      .getBoundingClientRect();
    let fetchedAnnotationRect = null;
    for (i = 0; i < allLinks.length; i++) {
      fetchedAnnotationRect = document
        .getElementById(allLinks[i].id)
        .getBoundingClientRect();
      if (
        !(
          currentAnnotationRect.right < fetchedAnnotationRect.left ||
          currentAnnotationRect.left > fetchedAnnotationRect.right ||
          currentAnnotationRect.bottom < fetchedAnnotationRect.top ||
          currentAnnotationRect.top > fetchedAnnotationRect.bottom
        )
      ) {
      }
    }
  };
  const deleteLink = () => {
    setLoading(true);
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastReadBookId: bookId,
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadPageNum: lastReadPageNum,
        },
        sessionVO: getSessionVO(),
      },
      annotationVO: {
        bookId: bookId,
        chapterId: chapterId,
        chapterTitle: chapterTitle,
        annotationId: selectedNoteIdlink,
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/deleteChapterLink`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          reqData.annotationVO.annotationStatus = "deleted";
          addHighlightToRedux(reqData.annotationVO);
          let allLinkTag = $("anchortag[id^=" + selectedNoteIdlink + "]");
          for (let i = 0; i < allLinkTag.length; i++) {
            let linkSpanTag = document.getElementById(allLinkTag[i].id);
            let spanElement = document.createElement("span");
            spanElement.innerHTML = linkSpanTag.innerText;
            spanElement.normalize();
            var parent = linkSpanTag.parentNode;
            while (linkSpanTag.firstChild)
              parent.insertBefore(linkSpanTag.firstChild, linkSpanTag);
            parent.removeChild(linkSpanTag);
          }
          let linkIconClassElements = $(".linksIcon");
          for (let i = 0; i < linkIconClassElements.length; i++) {
            if (
              linkIconClassElements[i].id.substring(
                7,
                linkIconClassElements[i].id.length,
              ) === selectedNoteIdlink
            ) {
              linkIconClassElements[i].parentNode.remove();
              break;
            }
          }
          let notesTextClassElements =
            document.getElementsByClassName("notesText");
          for (let i = 0; i < notesTextClassElements.length; i++) {
            if (
              notesTextClassElements[i].id.substring(
                8,
                notesTextClassElements[i].id.length,
              ) === selectedNoteIdlink
            ) {
              notesTextClassElements[i].parentNode.remove();
              break;
            }
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const noteTextClicked = (e) => {
    selectedNoteId = e.currentTarget.id;
    selectedNoteId = selectedNoteId.substring(13, selectedNoteId.length);
    highLightedTextClick(selectedNoteId);
  };
  const briefNoteTextClicked = (e) => {
    selectedNoteId = e.currentTarget.id;
    selectedNoteId = selectedNoteId.substring(18, selectedNoteId.length);
    briefTextClicked(selectedNoteId);
  };
  const linkNoteTextClicked = (e) => {
    selectedNoteId = e.currentTarget.id;
    selectedNoteId = selectedNoteId.substring(13, selectedNoteId.length);
    linkTextClick(selectedNoteId);
  };
  const linkSharedTextClicked = (e) => {
    selectedNoteId = e.currentTarget.id;
    selectedNoteId = selectedNoteId.substring(17, selectedNoteId.length);
    linkTextClick(selectedNoteId);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const copyId = "simple-copyPopover";
  const handlePageNavigation = (target) => {
    if (target.charCode == 13) {
      const navgNxtPageNum = document.getElementById("pageNumTxt").value;
      const navgPageNum = document.getElementById(`page-${navgNxtPageNum}`);
      if (navgPageNum) {
        navgPageNum.scrollIntoView();
      } else {
        let pageNumber = document.getElementById("pageNumTxt").value;
        setLastReadPgNum(pageNumber);
        localStorage.setItem("lastPageReadNum", pageNumber);
        navigateToPage(pageNumber);
      }
    }
    if (target.key === "Enter") {
      readBookFocus.current.focus();
    }
  };
  const navigateToPage = (pageNumber) => {
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastReadBookId: bookId,
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadParagraphId: "para01",
          lastReadPageNum: lastReadPageNum,
          lastReadSubSectionId: "subsec01",
        },
        sessionVO: getSessionVO(),
      },
      bookVO: { bookId: bookId, pageNumber: pageNumber },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/bookContentRetrievalService/getChapterIdByPageNumb`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data.bookVO) {
            let pageHtmlLocation = data.bookVO.pageHtmlLocation;
            if (data.bookVO.pageHtmlLocation) {
              let location = pageHtmlLocation.substr(
                pageHtmlLocation.indexOf("#"),
              );
              let chapterId = pageHtmlLocation.substr(
                0,
                pageHtmlLocation.indexOf("."),
              );
              if (location && chapterId)
                history.push(
                  `/read/users/${userId}/books/${bookISBN}/${chapterId + location}`,
                );
            }
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };

  const handleGotoPage = (e) => {
    if (
      e.target.getAttribute("onClick") &&
      e.target.getAttribute("onClick").includes("handleGotoPage(")
    ) {
      let pageNumb = e.target
        .getAttribute("onClick")
        .replaceAll("handleGotoPage(", "")
        .replaceAll("\'", "")
        .replaceAll(";", "")
        .replaceAll(")", "");
      if (pageNumb) {
        navigateToPage(pageNumb);
      }
    } else if (
      e.target.parentNode.getAttribute("onClick") &&
      e.target.parentNode.getAttribute("onClick").includes("handleGotoPage(")
    ) {
      let pageNumb = e.target.parentNode
        .getAttribute("onClick")
        .replaceAll("handleGotoPage(", "")
        .replaceAll("\'", "")
        .replaceAll(";", "")
        .replaceAll(")", "");
      if (pageNumb) {
        navigateToPage(pageNumb);
      }
    } else if (
      e.target.getAttribute("onClick") &&
      e.target.getAttribute("onClick").includes("EPub.showBCVideo(")
    ) {
      let videoId = e.target
        .getAttribute("onClick")
        .replaceAll("EPub.showBCVideo(", "")
        .replaceAll("\'", "")
        .replaceAll(";", "")
        .replaceAll(")", "")
        .replaceAll("return false", "");
      if (videoId) {
        setVideoId(videoId);
        setIsReadPopupOverOpen(true);
        setVideoplatform("showBCVideo");
      }
    } else if (
      e.target.getAttribute("onClick") &&
      e.target.getAttribute("onClick").includes("EPub.showVimeoVideo(")
    ) {
      let videoId = e.target
        .getAttribute("onClick")
        .replaceAll("EPub.showVimeoVideo(", "")
        .replaceAll("\'", "")
        .replaceAll(";", "")
        .replaceAll(")", "")
        .replaceAll("return false", "");
      videoId = videoId.split(",").map((x) => x.trim());
      if (videoId.length) {
        setVideoId(videoId[0]);
        setIsReadPopupOverOpen(true);
        setVideoplatform("showVimeoVideo");
      }
    } else if (
      e.target.getAttribute("onClick") &&
      e.target.getAttribute("onClick").includes("showQuickTipModal(")
    ) {
      let quicktipid = e.target.getAttribute("quicktipid");
      setIsReadQuickTipOpen(true);
      setQuickTipContent($("#" + quicktipid).html());
    } else if (
      (e.target.tagName == "B" || e.target.tagName == "SUP") &&
      e.target.parentElement.getAttribute("onClick") &&
      e.target.parentElement
        .getAttribute("onClick")
        .includes("showQuickTipModal(")
    ) {
      let quicktipid = e.target.parentElement.getAttribute("quicktipid");
      setIsReadQuickTipOpen(true);
      setQuickTipContent($("#" + quicktipid).html());
    } else if (
      (e.target.tagName.toLowerCase() == "i" ||
        e.target.tagName.toLowerCase() == "b") &&
      e.target.closest("a[quicktipid]") &&
      e.target
        .closest("a[quicktipid]")
        .getAttribute("onClick")
        .includes("showQuickTipModal(")
    ) {
      let quicktipid = e.target
        .closest("a[quicktipid]")
        .getAttribute("quicktipid");
      setIsReadQuickTipOpen(true);
      setQuickTipContent($("#" + quicktipid).html());
    }
  };
  const closeBriefConfirmModal = () => {
    outlineOnly = false;
    setIsBriefOpen(false);
  };
  const removeHighLightOnly = () => {};
  const onSuccess = (success) => {};
  const onFailure = (failure) => {};
  useEffect(() => {
    let labelVOList1 = labelSettingsVOList;
    localStorage.setItem("labelVOList", JSON.stringify(labelVOList1));
    if (labelVOList1 !== null && labelVOList1 !== undefined) {
      labelVOList1 = labelVOList1
        ? Array.isArray(labelVOList1)
          ? labelVOList1
          : [labelVOList1]
        : null;
      labelVOList1 = labelVOList1
        ? labelVOList1.filter(
            (entry) => entry.labelName && entry.labelName.trim() !== "",
          )
        : null;
    }
    setBriefLabels(labelVOList1);
  }, [labelSettingsVOList]);
  useEffect(() => {
    let colorCodeListEbook = [
      {
        id: "color-yellow",
        color: "#EDE48C",
        colorCode: "#EDE48C",
        title: "Yellow",
        stateValue: "colorYellow",
      },
      {
        id: "color-green",
        color: "#B5EB97",
        colorCode: "#B5EB97",
        title: "Green",
        stateValue: "colorGreen",
      },
      {
        id: "color-blue",
        color: "#AEE6FE",
        colorCode: "#AEE6FE",
        title: "Blue",
        stateValue: "colorBlue",
      },
      {
        id: "color-pink",
        color: "#FEC0FF",
        colorCode: "#FEC0FF",
        title: "Pink",
        stateValue: "colorPink",
      },
      {
        id: "color-orange",
        color: "#FFD4A8",
        colorCode: "#FFD4A8",
        title: "Orange",
        stateValue: "colorOrange",
      },
      {
        id: "color-purple",
        color: "#CBBEFC",
        colorCode: "#CBBEFC",
        title: "Purple",
        stateValue: "colorPurple",
      },
      {
        id: "color-cyan",
        color: "#35FBE2",
        colorCode: "#35FBE2",
        title: "Cyan",
        stateValue: "colorCyan",
      },
      {
        id: "color-lightNavy",
        color: "#95A7FF",
        colorCode: "#95A7FF",
        title: "LightNavy",
        stateValue: "colorLightNavy",
      },
      {
        id: "color-lightCoral",
        color: "#FF8787",
        colorCode: "#FF8787",
        title: "LightCoral",
        stateValue: "colorLightCoral",
      },
      {
        id: "color-sandrift",
        color: "#C1A88E",
        colorCode: "#C1A88E",
        title: "Sandrift",
        stateValue: "colorSandrift",
      },
      {
        id: "color-gainsboro",
        color: "#DADADA",
        colorCode: "#DADADA",
        title: "Gainsboro",
        stateValue: "colorGainsboro",
      },
      {
        id: "underLine",
        color: "underLine",
        colorCode: "underLine",
        title: "underLine",
        stateValue: highlightQuickUnderLine,
      },
    ];
    let hiddenColorCodes = removedColorsVOList;
    if (hiddenColorCodes !== null && hiddenColorCodes !== undefined) {
      hiddenColorCodes.map((i, index) => {
        colorCodeListEbook.splice(
          colorCodeListEbook.findIndex(
            (item) =>
              item.color.toLowerCase() === i.highlightColorCode.toLowerCase(),
          ),
          1,
        );
      });
    }
    let colorCodeListEbookNew = [...colorCodeListEbook];
    setColorCodeListEbook1(colorCodeListEbookNew);
  }, [removedColorsVOList]);

  useEffect(() => {
    document.title = `${props.bookVO ? props.bookVO.bookTitle : ""} | ${props.bookVO ? props.bookVO.navbarTitle : ""} | Aspen Publishing`;
  }, []);

  useEffect(() => {
    window.showQuickTipModal = (event) => {
      event?.preventDefault?.();
      event?.stopPropagation?.();

      const el = event?.currentTarget || event?.target;
      const quicktipid =
        el?.getAttribute?.("quicktipid") ||
        el?.closest?.("[quicktipid]")?.getAttribute?.("quicktipid");

      if (quicktipid) {
        setIsReadQuickTipOpen(true);
        setQuickTipContent($("#" + quicktipid).html() || "");
      }

      return false;
    };

    return () => {
      delete window.showQuickTipModal;
    };
  }, []);

  const addHighlightChangeMsg = (selectedColor) => {
    const colorTitleObj =
      colorCodeListEbook1 &&
      colorCodeListEbook1.find((colCod) => colCod.colorCode === selectedColor);
    const colorTitle = colorTitleObj
      ? colorTitleObj.title !== "underLine"
        ? `${colorTitleObj.title} Color`
        : `${colorTitleObj.title}`
      : `Unknown Color`;
    setHighlightChangeMsg(
      `Added ${colorTitle} to the Highlighted Paragraph Successfully'`,
    );
  };
  const handleShareStudent = (e, id) => {
    if (e.key === "Enter") {
      document.getElementById(id).click();
    }
  };
  return (
    <React.Fragment>
      <Dialog
        open={notificationOpen}
        aria-labelledby="Notification Title"
        onClose={() => setNotificationOpen(false)}
        aria-describedby="Notofication Description"
      >
        <DialogContent className="notificationHgMsg">
          <DialogContentText
            className="notificationHgMsg1"
            id="alert-dialog-description"
          >
            {notificationContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="notificationHgMsg">
          <Button
            className="noHighlightButton"
            onClick={() => setNotificationOpen(false)}
            color="primary"
            autoFocus
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        className="modal fade"
        show={isBriefOpen}
        onHide={() => setIsBriefOpen(false)}
        id="briefModalLabelId"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="editHighliterModalLabel"
        aria-hidden="true"
      >
        <div className="modal-header">
          <h5 className="modal-title" id="briefModalLabelTitle">
            E-Book Highlight
          </h5>
          <Modal.Header closeButton />
        </div>
        <div className="modal-body">
          This color is not a case brief section, but your highlight will still
          display on your outline. Do you want to continue?
        </div>
        <div className="briefCheckbox_rt mBottomTen">
          <label>
            <input type="checkbox" />
            <span className="mLeftTen">Don't show this message again.</span>
          </label>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => closeBriefConfirmModal()}
          >
            No, Go Back
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() =>
              casePopOverUpdate
                ? updateChapterBrief(labelColor, briefNote)
                : saveBriefHighlights(labelColor, briefNote)
            }
          >
            Yes, Save changes
          </button>
        </div>
      </Modal>
      <Modal
        className="modal fade"
        show={isReadPopupOverOpen}
        onHide={() => setIsReadPopupOverOpen(false)}
        id="readPopupOverOpen"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="segmentVideoModalLabel"
        aria-hidden="true"
      >
        <div className="modal-header">
          <h5 className="modal-title" id="briefModalLabelTitle"></h5>
          <Modal.Header closeButton />
        </div>
        <div className="modal-body">
          {videoplatform == "showBCVideo" ? (
            <div data-testid="showBCVideo" id="readPopupOverContent">
              <ReactPlayerLoader
                playerId="Vgqo3XXiY"
                accountId="20782352001"
                videoId={videoId}
                onFailure={() => onFailure()}
                onSuccess={() => onSuccess()}
              />
            </div>
          ) : null}
          {videoplatform == "showVimeoVideo" ? (
            <div
              data-testid="showVimeoVideo"
              id="readPopupOverContent"
              className="embed-responsive embed-responsive-16by9"
            >
              <iFrame
                src={videoId}
                allowFullScreen
                allow="encrypted-media"
                className="iframe-video"
              />
            </div>
          ) : null}
        </div>
      </Modal>
      <Dialog
        open={isReadQuickTipOpen}
        aria-labelledby="Notification Title"
        onClose={() => setIsReadQuickTipOpen(false)}
        aria-describedby="Notofication Description"
      >
        <DialogTitle id="notification_title">
          <span
            data-testid="close_quick_tip_modal"
            className="float-right"
            style={{ cursor: "pointer" }}
            onClick={() => setIsReadQuickTipOpen(false)}
          >
            X
          </span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div dangerouslySetInnerHTML={{ __html: quickTipContent }}></div>
          </DialogContentText>
        </DialogContent>
        <DialogActions> </DialogActions>
      </Dialog>
      <Spinner
        imageSrc={loaderColors1}
        overlayBackground="rgba(0,0,0,0.5)"
        loading={loading || saveHighlightLoading}
        label={
          saveHighlightLoading ? "Saving your highlight" : "Loading your eBook"
        }
      />
      <div className={classes.root}>
        <Popper
          id={id}
          anchorEl={anchorEl}
          open={isPopoverOpen}
          // 47048 - A11Y: Highlight popover uses the incorrect role and lacks an accessible name (MUI Popper defaults to role="tooltip")
          role="dialog"
          aria-label="Add Note"
          aria-modal="false"
          transition
          placement={placement}
          disablePortal={false}
          container={document.getElementById("ereader-container")}
          modifiers={{
            flip: { enabled: true },
            preventOverflow: {
              enabled: true,
              boundariesElement: "scrollParent",
            },
          }}
        >
          {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={handleClickAwayFromPopover}>
              <Fade {...TransitionProps} timeout={350}>
                <Paper>
                  <Typography className={classes.typography}>
                    <div
                      className="hlPopover"
                      rel="popover"
                      data-trigger="focus"
                    >
                      <div className="highlight-popover" id="highlight-popover">
                        <div className="highlighter-colors">
                          <div className="highlight-label">Highlight</div>
                          <div className="color-pallete">
                            {colorCodeListEbook1.map((cc, index) => {
                              if (cc.id === "underLine") {
                                return highlightQuickUnderLine ? (
                                  <GrFormClose
                                    id="underLine"
                                    className="underline_rt1"
                                    onClick={removeHighLightColor}
                                  />
                                ) : (
                                  <button
                                    className="underline_rt"
                                    style={{ background: "" }}
                                    aria-label="underLine"
                                    colorcode="UNDERLINE"
                                    title="underLine"
                                    onClick={(e) =>
                                      colorBtnPressed(e, "underLine")
                                    }
                                    id="underLine"
                                  >
                                    <AiOutlineUnderline />
                                  </button>
                                );
                              } else {
                                switch (cc.stateValue) {
                                  case "colorYellow":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorYellow
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorGreen":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorGreen
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorBlue":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorBlue
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorPink":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorPink
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorOrange":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorOrange
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorPurple":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorPurple
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorCyan":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorCyan
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorLightNavy":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorLightNavy
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorLightCoral":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorLightCoral
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorSandrift":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorSandrift
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorGainsboro":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorGainsboro
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                }
                              }
                            })}
                          </div>
                        </div>
                        {casePopOver ? (
                          <div id="highlighter-labels">
                            <div className="highlight-label">Label</div>
                            <select
                              id="viewingInput_Labels"
                              className="viewingInput_Labels mLeftFive form-control text-box-common display-inline-block"
                              onChange={(e) => onChangeBriefLabelsEvent(e)}
                            >
                              <option> Select Label </option>
                              {briefLabels !== null
                                ? briefLabels.map((option, i) => (
                                    <option
                                      key={i}
                                      id={option.labelId}
                                      value={option.labelName}
                                      name={option.colorCode}
                                      colorCodes={option.colorCode}
                                    >
                                      {option.labelName}
                                    </option>
                                  ))
                                : ""}
                            </select>
                          </div>
                        ) : null}
                        <div className="highlight-label" tabIndex="0">
                          Annotate
                        </div>
                        <div id="highlighter-notes">
                          <div className="note-edit-container">
                            <textarea
                              id="edit-note-text-area"
                              aria-label="Enter annotation"
                              className="note-text-area"
                              name="noteValue"
                              value={noteValue}
                              onChange={(e) => handleNoteValue(e)}
                            ></textarea>
                          </div>
                        </div>
                        <CopyToClipboard
                          text={copySelectedText}
                          onCopy={() => setCopiedText(copySelectedText)}
                        >
                          <a href="javascript:void(0)">
                            <div className="highlight-label-blue">
                              Copy Text{" "}
                              {copiedText !== "" ? (
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  className="TickIcon"
                                />
                              ) : null}
                            </div>
                          </a>
                        </CopyToClipboard>
                      </div>
                    </div>
                  </Typography>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </div>
      <div className={classes.root}>
        <Popper
          id={id}
          disablePortal={false}
          anchorEl={anchorElUpdate}
          transition
          open={isPopoverOpenUpdate}
          // 47048 - A11Y: Highlight popover uses the incorrect role and lacks an accessible name (MUI Popper defaults to role="tooltip")
          role="dialog"
          aria-label="Edit Note"
          aria-modal="false"
          placement={placementUpdate}
          container={document.getElementById("ereader-container")}
          modifiers={{
            flip: { enabled: true },
            preventOverflow: {
              enabled: true,
              boundariesElement: "scrollParent",
            },
          }}
        >
          {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={handleClickAwayFromPopoverUpdate}>
              <Fade {...TransitionProps} timeout={350}>
                <Paper>
                  <Typography className={classes.typography}>
                    <div
                      className="hlPopover"
                      rel="popover"
                      data-trigger="focus"
                    >
                      <div
                        className="highlight-popover"
                        id="highlightUpdate-popover"
                      >
                        <div className="highlighter-colors">
                          {!studLinkFlag ? (
                            <>
                              <div className="highlight-label">Highlight</div>
                              <div className="color-pallete"></div>
                              <div className="color-pallete">
                                {colorCodeListEbook1.map((cc, index) => {
                                  if (cc.id === "underLine") {
                                    return highlightQuickUnderLine ? (
                                      <GrFormClose
                                        className="underline_rt1"
                                        id="underLine"
                                        onClick={removeHighLightColor}
                                      />
                                    ) : (
                                      <button
                                        className="underline_rt"
                                        style={{ background: "" }}
                                        aria-label="underLine"
                                        colorcode="UNDERLINE"
                                        title="underLine"
                                        onClick={(e) =>
                                          colorBtnPressedUpdate(e, "underLine")
                                        }
                                        id="underLine"
                                      >
                                        <AiOutlineUnderline />
                                      </button>
                                    );
                                  } else {
                                    switch (cc.stateValue) {
                                      case "colorYellow":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorYellow
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                      case "colorGreen":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorGreen
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                      case "colorBlue":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorBlue
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                      case "colorPink":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorPink
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                      case "colorOrange":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorOrange
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                      case "colorPurple":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorPurple
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                      case "colorCyan":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorCyan
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                      case "colorLightNavy":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorLightNavy
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                      case "colorLightCoral":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorLightCoral
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                      case "colorSandrift":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorSandrift
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                      case "colorGainsboro":
                                        return (
                                          <button
                                            className="noButton select-marker colorButton"
                                            style={{ background: cc.color }}
                                            aria-label={cc.title}
                                            title={cc.title}
                                            onClick={(e) =>
                                              colorGainsboro
                                                ? removeHighLightColor(e)
                                                : colorBtnPressedUpdate(
                                                    e,
                                                    cc.color,
                                                  )
                                            }
                                            id={cc.id}
                                            type="button"
                                            colorcode={cc.colorCode}
                                          ></button>
                                        );
                                    }
                                  }
                                })}
                              </div>
                            </>
                          ) : null}
                        </div>
                        {casePopOverUpdate ? (
                          <div id="highlighter-labels1">
                            <div className="highlight-label">Label</div>
                            <select
                              id="viewingInput_Labels"
                              className="viewingInput_Labels mLeftFive form-control text-box-common display-inline-block"
                              onChange={(e) => onChangeBriefLabelsEvent(e)}
                            >
                              <option> Select Label </option>
                              {briefLabels !== null
                                ? briefLabels.map((option, i) => (
                                    <option
                                      key={i}
                                      id={option.labelId}
                                      value={option.labelName}
                                      name={option.colorCode}
                                      colorCodes={option.colorCode}
                                    >
                                      {option.labelName}
                                    </option>
                                  ))
                                : ""}
                            </select>
                          </div>
                        ) : null}
                        {linkDesStud && studLinkFlag ? (
                          <>
                            <div className="highlight-label">
                              Notes from Professor
                            </div>
                            <div id="highlighter-notes1">
                              <div className="note-edit-container">
                                <textarea
                                  id="edit-note-text-area1"
                                  className="note-text-area"
                                  name="noteValue"
                                  value={noteValueUpdate}
                                  onChange={(e) => handleNoteValueUpdate(e)}
                                ></textarea>
                              </div>
                            </div>
                          </>
                        ) : null}
                        {linkDesStud === false && studLinkFlag === false ? (
                          <>
                            <div className="highlight-label">Annotate</div>
                            <div id="highlighter-notes1">
                              <div className="note-edit-container">
                                <textarea
                                  id="edit-note-text-area1"
                                  aria-label="Enter annotation"
                                  className="note-text-area"
                                  name="noteValue"
                                  value={noteValueUpdate}
                                  onChange={(e) => handleNoteValueUpdate(e)}
                                ></textarea>
                              </div>
                            </div>
                          </>
                        ) : null}
                        {studLinkFlag ? (
                          <div id="linkArea">
                            <div className="highlight-label">Link</div>
                            <div className="highlight-link">
                              <a href={studLink} target="_blank">
                                {studLink}
                              </a>
                            </div>
                          </div>
                        ) : null}
                        <CopyToClipboard
                          text={copySelectedText}
                          onCopy={() => setCopiedText(copySelectedText)}
                        >
                          <a href="javascript:void(0)">
                            <div className="highlight-label-blue">
                              Copy Text{" "}
                              {copiedText !== "" ? (
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  className="TickIcon"
                                />
                              ) : null}
                            </div>
                          </a>
                        </CopyToClipboard>
                      </div>
                    </div>
                  </Typography>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </div>
      <div className={classes.root}>
        <Popper
          id={id}
          anchorEl={anchorEl}
          placement={placement}
          transition
          disablePortal={false}
          open={isPopoverOpenProfessor}
          // 47048 - A11Y: Highlight popover uses the incorrect role and lacks an accessible name (MUI Popper defaults to role="tooltip")
          role="dialog"
          aria-label="Add Note"
          aria-modal="false"
          container={document.getElementById("ereader-container")}
          modifiers={{
            flip: { enabled: true },
            preventOverflow: {
              enabled: true,
              boundariesElement: "scrollParent",
            },
          }}
        >
          {({ TransitionProps }) => (
            <ClickAwayListener
              onClickAway={handleClickAwayFromPopoverProfessor}
            >
              <Fade {...TransitionProps} timeout={350}>
                <Paper>
                  <Typography className={classes.typography}>
                    <div
                      className="hlPopover"
                      rel="popover"
                      data-trigger="focus"
                    >
                      <div
                        className="highlight-popover"
                        id="highlight-popoverProfessor"
                      >
                        <div className="highlighter-colors">
                          <div className="highlight-labelProf">Highlight</div>
                          <div className="color-pallete">
                            {colorCodeListEbook1.map((cc, index) => {
                              if (cc.id === "underLine") {
                                return highlightQuickUnderLine ? (
                                  <GrFormClose
                                    className="underline_rt1"
                                    id="underLine"
                                    onClick={removeHighLightColor}
                                  />
                                ) : (
                                  <button
                                    className="underline_rt"
                                    style={{ background: "" }}
                                    aria-label="underLine"
                                    colorcode="UNDERLINE"
                                    title="underLine"
                                    onClick={(e) =>
                                      colorBtnPressed(e, "underLine")
                                    }
                                    id="underLine"
                                  >
                                    <AiOutlineUnderline />
                                  </button>
                                );
                              } else {
                                switch (cc.stateValue) {
                                  case "colorYellow":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorYellow
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorGreen":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorGreen
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorBlue":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorBlue
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorPink":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorPink
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorOrange":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorOrange
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorPurple":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorPurple
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorCyan":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorCyan
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorLightNavy":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorLightNavy
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorLightCoral":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorLightCoral
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorSandrift":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorSandrift
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorGainsboro":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorGainsboro
                                            ? removeHighLightColor(e)
                                            : colorBtnPressed(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                }
                              }
                            })}
                          </div>
                        </div>
                        {casePopOver ? (
                          <div id="highlighter-labels">
                            <div className="highlight-label">Label</div>
                            <select
                              id="viewingInput_Labels"
                              className="viewingInput_Labels mLeftFive form-control text-box-common display-inline-block"
                              onChange={(e) => onChangeBriefLabelsEvent(e)}
                            >
                              <option> Select Label </option>
                              {briefLabels !== null
                                ? briefLabels.map((option, i) => (
                                    <option
                                      key={i}
                                      id={option.labelId}
                                      value={option.labelName}
                                      name={option.colorCode}
                                      colorCodes={option.colorCode}
                                    >
                                      {option.labelName}
                                    </option>
                                  ))
                                : ""}
                            </select>
                          </div>
                        ) : null}
                        <div className="highlight-label">Add a Note</div>
                        <div id="highlighter-notes">
                          <div className="note-edit-container">
                            <textarea
                              id="edit-note-text-area"
                              aria-label="Add a note"
                              className="note-text-area"
                              name="noteValue"
                              value={noteValue}
                              onChange={(e) => handleNoteValue(e)}
                            ></textarea>
                          </div>
                        </div>
                        <div className="highlight-label">Add a Link</div>
                        <div id="highlighter-link">
                          <input
                            id="Proflink"
                            aria-label="Add a link"
                            className="Proflink"
                            name="Proflink"
                            value={profLink}
                            onChange={(e) => handleProflink(e)}
                          ></input>
                        </div>
                        <div className="sharewithStud" id="sharewithStud">
                          <label>
                            <input
                              type="checkbox"
                              id="shareit"
                              onKeyDown={(e) =>
                                handleShareStudent(e, "shareit")
                              }
                            />
                            <span className="mLeftFive">
                              Share with students
                            </span>
                          </label>
                        </div>
                        <CopyToClipboard
                          text={copySelectedText}
                          onCopy={() => setCopiedText(copySelectedText)}
                        >
                          <a href="javascript:void(0)">
                            <div className="highlight-label-blue">
                              Copy Text{" "}
                              {copiedText !== "" ? (
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  className="TickIcon"
                                />
                              ) : null}{" "}
                            </div>
                          </a>
                        </CopyToClipboard>
                      </div>
                    </div>
                  </Typography>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </div>
      <div className={classes.root}>
        <Popper
          id={id}
          placement={placement}
          disablePortal={false}
          transition
          anchorEl={anchorElUpdate}
          open={isPopoverOpenProfessorUpdate}
          // 47048 - A11Y: Highlight popover uses the incorrect role and lacks an accessible name (MUI Popper defaults to role="tooltip")
          role="dialog"
          aria-label="Edit Note"
          aria-modal="false"
          container={document.getElementById("ereader-container")}
          modifiers={{
            flip: { enabled: true },
            preventOverflow: {
              enabled: true,
              boundariesElement: "scrollParent",
            },
          }}
        >
          {({ TransitionProps }) => (
            <ClickAwayListener
              onClickAway={handleClickAwayFromPopoverProfessorUpdate}
            >
              <Fade {...TransitionProps} timeout={350}>
                <Paper>
                  <Typography className={classes.typography}>
                    <div
                      className="hlPopover"
                      rel="popover"
                      data-trigger="focus"
                    >
                      <div
                        className="highlight-popover"
                        id="highlight-popoverProfessor"
                      >
                        <div className="highlighter-colors">
                          <div className="highlight-labelProf">Highlight</div>
                          <div className="color-pallete">
                            {colorCodeListEbook1.map((cc, index) => {
                              if (cc.id === "underLine") {
                                return highlightQuickUnderLine ? (
                                  <GrFormClose
                                    className="underline_rt1"
                                    id="underLine"
                                    onClick={removeHighLightColor}
                                  />
                                ) : (
                                  <button
                                    className="underline_rt"
                                    style={{ background: "" }}
                                    aria-label="underLine"
                                    colorcode="UNDERLINE"
                                    title="underLine"
                                    onClick={(e) =>
                                      colorBtnPressedUpdate(e, "underLine")
                                    }
                                    id="underLine"
                                  >
                                    <AiOutlineUnderline />
                                  </button>
                                );
                              } else {
                                switch (cc.stateValue) {
                                  case "colorYellow":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorYellow
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorGreen":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorGreen
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorBlue":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorBlue
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorPink":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorPink
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorOrange":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorOrange
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorPurple":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorPurple
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorCyan":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorCyan
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorLightNavy":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorLightNavy
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorLightCoral":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorLightCoral
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorSandrift":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorSandrift
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                  case "colorGainsboro":
                                    return (
                                      <button
                                        className="noButton select-marker colorButton"
                                        style={{ background: cc.color }}
                                        aria-label={cc.title}
                                        title={cc.title}
                                        onClick={(e) =>
                                          colorGainsboro
                                            ? removeHighLightColor(e)
                                            : colorBtnPressedUpdate(e, cc.color)
                                        }
                                        id={cc.id}
                                        type="button"
                                        colorcode={cc.colorCode}
                                      ></button>
                                    );
                                }
                              }
                            })}
                          </div>
                        </div>
                        {casePopOverUpdate ? (
                          <div id="highlighter-labels">
                            <div className="highlight-label">Label</div>
                            <select
                              id="viewingInput_Labels"
                              className="viewingInput_Labels mLeftFive form-control text-box-common display-inline-block"
                              onChange={(e) => onChangeBriefLabelsEvent(e)}
                            >
                              <option> Select Label </option>
                              {briefLabels !== null
                                ? briefLabels.map((option, i) => (
                                    <option
                                      key={i}
                                      id={option.labelId}
                                      value={option.labelName}
                                      name={option.colorCode}
                                      colorCodes={option.colorCode}
                                    >
                                      {option.labelName}
                                    </option>
                                  ))
                                : ""}
                            </select>
                          </div>
                        ) : null}
                        <div className="highlight-label">Add a Note</div>
                        <div id="highlighter-notes">
                          <div className="note-edit-container">
                            <textarea
                              id="edit-note-text-area"
                              aria-label="Add a note"
                              className="note-text-area"
                              name="noteValue"
                              value={noteValueUpdate}
                              onChange={(e) => handleNoteValueUpdate(e)}
                            ></textarea>
                          </div>
                        </div>
                        {showLink ? (
                          <>
                            <div className="highlight-label">Add a Link</div>
                            <div id="highlighter-link">
                              <input
                                id="Proflink"
                                aria-label="Add a link"
                                className="Proflink"
                                name="Proflink"
                                value={profLink}
                                onChange={(e) => handleProflink(e)}
                              ></input>
                            </div>
                            <div
                              className="sharewithStudUpdate"
                              id="sharewithStud"
                            >
                              <label>
                                <input
                                  type="checkbox"
                                  id="shareit"
                                  onKeyDown={(e) =>
                                    handleShareStudent(e, "shareit")
                                  }
                                />
                                <span className="mLeftFive">
                                  Share with students
                                </span>
                              </label>
                            </div>
                          </>
                        ) : null}
                        <CopyToClipboard
                          text={copySelectedText}
                          onCopy={() => setCopiedText(copySelectedText)}
                        >
                          <a href="javascript:void(0)">
                            <div className="highlight-label-blue">
                              Copy Text{" "}
                              {copiedText !== "" ? (
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  className="TickIcon"
                                />
                              ) : null}
                            </div>
                          </a>
                        </CopyToClipboard>
                      </div>
                    </div>
                  </Typography>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </div>
      <div className={classes.root}>
        <Popper
          id={copyId}
          anchorEl={anchorEl}
          placement={placement}
          transition
          disablePortal={false}
          open={isCopyOnlyPopoverOpen}
          container={document.getElementById("ereader-container")}
          modifiers={{
            flip: { enabled: true },
            preventOverflow: {
              enabled: true,
              boundariesElement: "scrollParent",
            },
          }}
        >
          {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={handleClickAwayFromPopover}>
              <Fade {...TransitionProps} timeout={350}>
                <Paper>
                  <Typography className={classes.typography}>
                    <div
                      className="hlPopover"
                      rel="popover"
                      data-trigger="focus"
                    >
                      <div className="highlight-popover" id="highlight-popover">
                        <CopyToClipboard
                          text={copySelectedText}
                          onCopy={() => setCopiedText(copySelectedText)}
                        >
                          <a href="javascript:void(0)">
                            <div className="highlightCopy-labelBlue">
                              Copy Text{" "}
                              {copiedText !== "" ? (
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  className="TickIcon"
                                />
                              ) : null}
                            </div>
                          </a>
                        </CopyToClipboard>
                        <div className="highlightCopy-label">
                          Looking to highlight or annotate? Try selecting only
                          one paragraph at a time or text that hasn’t been
                          highlighted yet.
                        </div>
                      </div>
                    </div>
                  </Typography>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </div>
      <div
        role="region"
        aria-label="eBook"
        className="leftLayout content no-padding iPadMargin"
      >
        <div className="">
          <div
            className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
            id="ereaderBookIndexHedaer"
          >
            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-9 display-inline-block no-padding mTopTwl mBottomTwl bookTitle_xs_rt pr-1">
              <div
                className="bookTitle_rt ellipsis"
                title={props.bookVO.bookTitle}
              >
                {props.bookVO.bookTitle}
              </div>
              {isDesktopOrLaptop && (
                <div
                  className="chapterTitle_rt mTopFive ellipsis"
                  title={props.bookVO.navbarTitle}
                >
                  {props.bookVO.navbarTitle}
                </div>
              )}
            </div>
            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3 display-inline-block mTopTwl mBottomTwl no-padding pageNum_xs_rt float-right">
              {isTabletOrMobile && (
                <span className="pull-right">
                  <span className="pageBox_rt mRightFive">Page</span>
                  <span className="pageNumberInputBlock">
                    <input
                      data-testid="input_page_number"
                      type="text"
                      id="pageNumTxt"
                      className="pageNumberInputBox"
                      aria-label="Enter page number to jump to"
                      onKeyPress={handlePageNavigation}
                    />
                    <span>
                      of{" "}
                      <span className="totalPageNumberCount">
                        {props.bookVO.totalChapterPageCount}
                      </span>
                    </span>
                  </span>
                </span>
              )}
              {isDesktopOrLaptop && (
                <span className="pull-right">
                  <div className="pageBox_rt mRightFive">Page</div>
                  <span className="pageNumberInputBlock">
                    <input
                      data-testid="input_page_number_desktop"
                      type="text"
                      id="pageNumTxt"
                      aria-label="Enter page number to jump to"
                      className="pageNumberInputBox"
                      onKeyPress={handlePageNavigation}
                    />
                    <span>
                      of{" "}
                      <span className="totalPageNumberCount">
                        {props.bookVO.totalChapterPageCount}
                      </span>
                    </span>
                  </span>
                </span>
              )}
            </div>
            <a
              href="javascript:void(0)"
              id="expandNoteBookLink"
              role="button"
              className="text-right display-inline-block expandNoteBookLink pull-right"
              data-toggle="collapse"
              data-target="#minimizeNoteBook"
              aria-expanded="true"
              onClick={props.toggleExpand}
            >
              Expand Notebook
            </a>
            <div
              aria-live="assertive"
              style={{ position: "absolute", left: "-9999px" }}
            >
              {highlightChangeMsg}
            </div>
          </div>
          <div
            data-testid="ereaderBookContentContainer"
            className="col-xl-12 col-lg-12 col-md-12 col-sm-12  col-xs-12 no-padding"
            id="ereaderBookContentContainer"
            tabIndex="1"
            ref={readBookFocus}
            onScroll={handleScroll}
          >
            <div
              className="col-xl-12 col-lg-12 col-md-12 col-sm-12  col-xs-12"
              id="ereaderBookContentMainBlock"
            >
              <div className="col-xl-1 col-lg-1 col-md-1 col-sm-1  col-xs-1 mTopTen display-inline-block ereaderAnnotationBlock">
                <div
                  id="links-container"
                  className="display-inline-block"
                ></div>
              </div>
              <div className="col-xl-10 col-lg-10 col-md-10 col-sm-8  col-xs-10  mTopTen display-inline-block ereaderContentCenterSec">
                <div
                  data-testid="ereader"
                  id="ereader-container"
                  className="ereader-container"
                  onClick={(e) => handleGotoPage(e)}
                  onMouseUp={(e) => highLightSelection(e, "bottom")}
                  onKeyUp={(e) => highLightSelection(e, "bottom")}
                  onTouchStart={(e) => highLightSelection(e, "bottom")}
                >
                  <div dangerouslySetInnerHTML={{ __html: HTMLData }}></div>
                </div>
              </div>
              <div className="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 mTopTen display-inline-block ereaderAnnotationBlock">
                <div
                  id="notes-container"
                  className="display-inline-block"
                ></div>
              </div>
              <div className="nextChapterLinkSpace"></div>
            </div>
          </div>
          {showNextChapterLink && props.bookInfo.nextChapterId ? (
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding nextChapterLink">
              <i className="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 fas fa-arrow-right nextChapterLinkArrow"></i>
              <a
                className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-xs-10 no-padding"
                href="javascript:void(0);"
                onClick={goToNextChapter}
              >
                {props.bookVO.nextNavBarTitle}
              </a>
              {/* 47042 - A11Y: Chapter link close button does not have an accessible name */}
              {/* Original: <i data-testid="close_next_chapter_link" className="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 fa fa-close nextChapterLinkClose" onClick={() => setShowNextChapterLink(false)}><a href="javascript:void(0)" aria-label="Close" role="button"></a></i> */}
              <button
                type="button"
                data-testid="close_next_chapter_link"
                // 47042 - A11Y: Chapter link close button does not have an accessible name
                className="nextChapterLinkClose"
                // 47042 - A11Y: Chapter link close button does not have an accessible name
                aria-label="Close"
                // 47042 - A11Y: Chapter link close button does not have an accessible name
                onClick={() => setShowNextChapterLink(false)}
              >
                {/* 47042 - A11Y: Chapter link close button does not have an accessible name */}
                <i className="fa fa-close" aria-hidden="true"></i>
              </button>
            </div>
          ) : null}
          <div
            className="col-lg-12 col-md-12 col-sm-12  col-xl-12 col-xs-12"
            id="ereaderBookIndexFooter"
          >
            <QuickHighlightShowColorPalete
              handleQuickToolInputs={handleHLQuickToolInputs}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
});
export default Ebook;
